import React, { createContext, useContext, useState, useEffect } from 'react';

interface Translation {
  [key: string]: string;
}

const translations: { vi: Translation; en: Translation } = {
  vi: {
    addRoleTitle: 'Tạo nhóm phân quyền',
    generalInfo: 'Thông tin chung',
    applyBuildings: 'Chung cư áp dụng',
    allBuildings: 'Tất cả chung cư',
    selectBuildings: 'Theo danh sách bên dưới',
    select: 'Chọn',
    building: 'Chung cư',
    save: 'Lưu',
    cancel: 'Hủy',
    add: 'Thêm',
    permissionGroups: 'Nhóm phân quyền',
    addPermissionGroup: 'Tạo nhóm phân quyền',
    groupName: 'Tên nhóm',
    description: 'Mô tả',
    userCount: 'Số tài khoản',
    // Account Management
    accounts: 'TÀI KHOẢN',
    addAccount: 'Thêm tài khoản',
    accountList: 'Danh sách tài khoản',
    accountManagement: 'Quản lý tài khoản',
    permissions: 'Phân quyền',
    functions: 'Chức năng',
    functionCategory: 'Danh mục chức năng',
    functionCategories: 'Danh mục chức năng',
    addFunctionCategory: 'Thêm danh mục chức năng',
    editFunctionCategory: 'Chỉnh sửa danh mục chức năng',
    functionCategoryName: 'Tên danh mục chức năng',
    functionCategoryDescription: 'Mô tả danh mục chức năng',
    functionCategoryIcon: 'Icon danh mục chức năng',
    functionCategoryOrder: 'Thứ tự hiển thị',
    createDefaultFunctionCategories: 'Tạo danh mục chức năng mặc định',
    functionCategoriesUsingTemplate: 'Đang dùng danh mục mặc định từ Superadmin. Khi bạn sắp xếp hoặc chỉnh sửa, hệ thống sẽ tạo bản sao riêng cho operator này.',
    manageFunctionCategories: 'Quản lý danh mục chức năng/menu hệ thống',
    noFunctionCategories: 'Chưa có danh mục chức năng',
    noFunctionCategoriesHelp: 'Bắt đầu bằng cách tạo danh mục chức năng mặc định hoặc thêm danh mục mới',
    functionCategoryCreatedSuccess: 'Danh mục chức năng đã được tạo thành công!',
    functionCategoryUpdatedSuccess: 'Danh mục chức năng đã được cập nhật thành công!',
    functionCategoryDeletedSuccess: 'Danh mục chức năng đã được xóa thành công!',
    defaultFunctionCategoriesCreated: 'Đã tạo {count} danh mục chức năng mặc định thành công!',
    errorLoadingFunctionCategories: 'Có lỗi xảy ra khi tải danh sách danh mục chức năng',
    errorCreatingFunctionCategory: 'Có lỗi xảy ra khi tạo danh mục chức năng',
    errorUpdatingFunctionCategory: 'Có lỗi xảy ra khi cập nhật danh mục chức năng',
    errorDeletingFunctionCategory: 'Có lỗi xảy ra khi xóa danh mục chức năng',
    errorCreatingDefaultFunctionCategories: 'Có lỗi xảy ra khi tạo danh mục chức năng mặc định',
    confirmDeleteFunctionCategory: 'Bạn có chắc chắn muốn xóa danh mục chức năng này không?',
    enterFunctionCategoryName: 'Nhập tên danh mục chức năng',
    enterFunctionCategoryCode: 'Nhập mã danh mục chức năng (VD: MAIN_MANAGEMENT)',
    selectFunctionCategory: 'Chọn danh mục chức năng',
    viewFunctionsInCategory: 'Xem chức năng trong danh mục',
    functionsInCategory: 'chức năng trong danh mục',
    categoryDescription: 'Danh mục chức năng hệ thống',
    functionCategoryCode: 'Mã danh mục chức năng',
    exportFunctionCategories: 'Xuất danh mục chức năng',
    importFunctionCategories: 'Nhập danh mục chức năng',
    exportFunctionCategoriesSuccess: 'Đã xuất danh mục chức năng thành công',
    importFunctionCategoriesHint: 'Tải lên file JSON đã xuất từ operator khác để sao chép cấu hình danh mục chức năng.',
    importFunctionCategoriesModeSkip: 'Bỏ qua mã danh mục đã tồn tại',
    importFunctionCategoriesModeReplace: 'Cập nhật nếu mã danh mục đã tồn tại',
    functionCategoryImportJsonOnly: 'Chỉ hỗ trợ file JSON (.json) xuất từ hệ thống',
    missingFunctionCodes: 'Mã chức năng không tìm thấy trong hệ thống',
    addExistingFunction: 'Thêm chức năng',
    addExistingFunctions: 'Thêm chức năng vào danh mục',
    selectFunctionsToAdd: 'Chọn chức năng cần thêm',
    noFunctionsInCategory: 'Chưa có chức năng trong danh mục này',
    dragToReorder: 'Kéo thả để sắp xếp',
    saveOrder: 'Lưu thứ tự',
    orderSaved: 'Đã lưu thứ tự thành công',
    removeFromCategory: 'Gỡ khỏi danh mục',
    functionsPreview: 'Chức năng trong danh mục',
    allFunctionsAssigned: 'Tất cả chức năng đã được gán vào danh mục',
    manageCategoryFunctions: 'Quản lý chức năng trong danh mục',
    currentCategory: 'Danh mục hiện tại',
    unsavedOrderChanges: 'Có thay đổi thứ tự chưa lưu',
    hideFromMenu: 'Ẩn khỏi menu',
    showInMenu: 'Hiện trên menu',
    hideCategoryFromMenu: 'Tắt hiển thị menu',
    showCategoryInMenu: 'Bật hiển thị menu',
    cannotDeleteCategoryWithFunctions: 'Không thể xóa danh mục còn chức năng. Hãy gỡ chức năng trước hoặc tắt hiển thị menu.',
    categoryHiddenFromMenuHint: 'Danh mục tắt sẽ không hiển thị trên menu bên trái',
    selectCategoryIcon: 'Chọn icon',
    // Function Category Codes (for sidebar localization)
    MAIN_MANAGEMENT: 'QUẢN LÝ CHÍNH',
    SERVICE_FEES: 'PHÍ DỊCH VỤ',
    INCOME_EXPENSE_MANAGEMENT: 'QUẢN LÝ THU CHI',
    ACCOUNT_MANAGEMENT: 'QUẢN LÝ TÀI KHOẢN',
    BUILDING_MANAGEMENT: 'QUẢN LÝ CHUNG CƯ',
    APARTMENT_MANAGEMENT: 'QUẢN LÝ CĂN HỘ',
    TASK_MANAGEMENT: 'QUẢN LÝ CÔNG VIỆC',
    BUILDING_UTILITIES: 'TIỆN ÍCH TÒA NHÀ',
    BUILDING_SERVICES: 'DỊCH VỤ TÒA NHÀ',
    CUSTOMER_CARE: 'CHĂM SÓC KHÁCH HÀNG',
    SYSTEM_UTILITIES: 'TIỆN ÍCH HỆ THỐNG',
    SYSTEM_SETTINGS: 'CÀI ĐẶT HỆ THỐNG',
    FUNCTION_CATEGORIES: 'Danh mục chức năng',
    FUNCTIONS: 'Chức năng hệ thống',
    SETTINGS: 'Cài đặt chung',
    addFunction: 'Thêm chức năng',
    functionList: 'Danh sách chức năng',
    mainManagement: 'Quản lý chính',
    DASHBOARD: 'Bảng điều khiển',
    functionName: 'Tên chức năng',
    functionCode: 'Mã chức năng',
    functionRoute: 'Đường dẫn',
    functionIcon: 'Icon',
    menuOrder: 'Thứ tự hiển thị',
    isActive: 'Kích hoạt',
    status: 'Trạng thái',
    editFunction: 'Chỉnh sửa chức năng',
    updateFunction: 'Cập nhật chức năng',
    back: 'Quay lại',
    // Error messages and alerts
    errorLoadingFunctions: 'Có lỗi xảy ra khi tải danh sách chức năng',
    errorToggleStatus: 'Có lỗi xảy ra khi thay đổi trạng thái',
    errorDeleteFunction: 'Có lỗi xảy ra khi xóa chức năng',
    errorSeedFunctions: 'Có lỗi xảy ra khi tạo chức năng mặc định',
    confirmDelete: 'Bạn có chắc chắn muốn xóa chức năng này?',
    seedSuccessMessage: 'Đã tạo các chức năng mặc định thành công!',
    tryAgain: 'Thử lại',
    // Table headers and labels
    stt: 'STT',
    actions: 'Thao tác',
    active: 'Hoạt động',
    yes: 'Có',
    no: 'Không',
    inactive: 'Tạm khóa',
    totalFunctions: 'Tổng số chức năng',
    activeFunctions: 'Đang hoạt động',
    createDefaultFunctions: 'Tạo chức năng mặc định',
    functionInformation: 'Thông tin chức năng',
    manageSystemFunctions: 'Quản lý các chức năng trong hệ thống',
    addNewFunction: 'Thêm chức năng/menu mới vào hệ thống',
    updateFunctionInfo: 'Cập nhật thông tin chức năng trong hệ thống',
    // Permission Groups
    managePermissionGroups: 'Quản lý nhóm phân quyền và cấp độ truy cập của hệ thống',
    createNewPermissionGroup: 'Tạo nhóm phân quyền mới với cấp độ truy cập chức năng cụ thể',
    updatePermissionGroupSettings: 'Cập nhật cài đặt nhóm phân quyền và cấp độ truy cập chức năng',
    createDefaultGroups: 'Tạo nhóm mặc định',
    creating: 'Đang tạo...',
    total: 'Tổng',
    groups: 'nhóm',
    noPermissionGroups: 'Không có nhóm phân quyền',
    getStartedPermissionGroups: 'Bắt đầu bằng cách tạo nhóm phân quyền đầu tiên hoặc tạo các nhóm mặc định.',
    createFirstGroup: 'Tạo nhóm đầu tiên',
    seedDefaultGroups: 'Tạo nhóm mặc định',
    functionPermissions: 'Phân quyền chức năng',
    noFunctionsAvailable: 'Không có chức năng hệ thống nào. Vui lòng tạo chức năng mặc định trước.',
    noFunctionsAvailableHelp: 'Để tạo nhóm phân quyền, bạn cần tạo các chức năng hệ thống trước. Vui lòng truy cập vào menu "Chức năng" và nhấn nút "Tạo chức năng mặc định".',
    goToFunctionsToSeed: 'Đi tới Chức năng để tạo mặc định',
    goToFunctions: 'Đi đến Chức năng',
    function: 'Chức năng',
    editPermissionGroup: 'Chỉnh sửa nhóm phân quyền',
    updateGroup: 'Cập nhật nhóm',
    updating: 'Đang cập nhật...',
    groupStatistics: 'Thống kê nhóm',
    assignedUsers: 'Người dùng được gán',
    functionsWithPermissions: 'Chức năng có phân quyền',
    created: 'Tạo lúc',
    permissionGroupNotFound: 'Không tìm thấy nhóm phân quyền',
    backToPermissionGroups: 'Quay lại Nhóm phân quyền',
    loading: 'Đang tải...',
    edit: 'Sửa',
    delete: 'Xóa',
    confirmDeleteGroup: 'Bạn có chắc chắn muốn xóa',
    defaultGroupsCreatedSuccess: 'Đã tạo các nhóm phân quyền mặc định thành công!',
    errorCreatingDefaultGroups: 'Lỗi khi tạo các nhóm phân quyền mặc định',
    errorLoadingPermissionGroups: 'Lỗi khi tải danh sách nhóm phân quyền',
    exportPermissionGroups: 'Xuất nhóm phân quyền',
    importPermissionGroups: 'Nhập nhóm phân quyền',
    exportPermissionGroupsSuccess: 'Đã xuất nhóm phân quyền thành công',
    importPermissionGroupsHint: 'Tải lên file JSON đã xuất từ dự án khác để sao chép nhóm phân quyền sang tài khoản điều hành này.',
    importPermissionGroupsModeSkip: 'Bỏ qua nhóm đã tồn tại',
    importPermissionGroupsModeReplace: 'Thay thế quyền nếu nhóm đã tồn tại',
    importPermissionGroupsModeMerge: 'Gộp thêm quyền nếu nhóm đã tồn tại',
    importPermissionGroupsSuccess: 'Đã nhập nhóm phân quyền thành công',
    importPermissionGroupsJsonHint: 'File xuất từ màn Nhóm phân quyền',
    importPermissionGroupsFormatTitle: 'Cấu trúc file JSON',
    importPermissionGroupsFormatName: 'Tên nhóm, mô tả, loại nhóm',
    importPermissionGroupsFormatCode: 'Mã nhóm (nếu có) để khớp khi cập nhật',
    importPermissionGroupsFormatPermissions: 'Danh sách quyền theo mã chức năng (function code)',
    importResultCreated: 'Tạo mới',
    importResultUpdated: 'Cập nhật',
    importResultSkipped: 'Bỏ qua',
    importWarnings: 'Cảnh báo',
    importMoreWarnings: 'cảnh báo khác',
    errorDeletingPermissionGroup: 'Lỗi khi xóa nhóm phân quyền',
    pleaseEnterGroupName: 'Vui lòng nhập tên nhóm',
    permissionGroupCreatedSuccess: 'Đã tạo nhóm phân quyền thành công!',
    errorCreatingPermissionGroup: 'Lỗi khi tạo nhóm phân quyền',
    permissionGroupUpdatedSuccess: 'Đã cập nhật nhóm phân quyền thành công!',
    errorUpdatingPermissionGroup: 'Lỗi khi cập nhật nhóm phân quyền',
    errorLoadingPermissionGroup: 'Lỗi khi tải nhóm phân quyền',
    enterGroupName: 'Nhập tên nhóm',
    enterGroupDescription: 'Nhập mô tả nhóm',
    buildingSelectionNote: 'Lựa chọn chung cư sẽ được triển khai khi module chung cư có sẵn. Hiện tại mặc định là "Tất cả chung cư".',
    loadingPermissionGroups: 'Đang tải nhóm phân quyền...',
    myPermissionGroups: 'Nhóm phân quyền của tôi',
    viewingOperatorGroups: 'Đang xem nhóm của điều hành viên',
    viewingOwnGroups: 'Đang xem nhóm của bạn',
    // User Form
    fullName: 'Họ và tên',
    phoneNumber: 'Số điện thoại',
    role: 'Vai trò',
    permissionGroup: 'Nhóm phân quyền',
    // User counts
    users: 'người dùng',
    user: 'người dùng',
    // Permission Details
    detailedPermissions: 'Phân quyền chi tiết',
    functionality: 'Chức năng',
    permission: 'Phân quyền',
    view: 'Xem',
    create: 'Tạo',
    update: 'Cập nhật',
    servicePayment: 'Thanh toán phí dịch vụ',
    billReport: 'Báo cáo phí phải thu',
    apartment: 'Căn hộ',
    resident: 'Cư dân',
    code: 'Mã',
    name: 'Tên',
    account: 'Tài khoản',
    emailNotification: 'Email',
    staff: 'Công việc',
    // Actions
    saveInfo: 'LƯU THÔNG TIN',
    // Login page
    loginTitle: 'Đăng nhập hệ thống',
    createSuperadminTitle: 'Tạo tài khoản Superadmin',
    firstTimePrompt: 'Đây là lần đăng nhập đầu tiên. Vui lòng tạo tài khoản superadmin.',
    email: 'Email',
    password: 'Mật khẩu',
    signIn: 'Đăng nhập',
    signOut: 'Đăng xuất',
    rememberMe: 'Nhớ thông tin đăng nhập',
    forgotPassword: 'Quên mật khẩu?',
    forgotPasswordTitle: 'Quên mật khẩu',
    forgotPasswordDescription: 'Nhập email đăng ký của bạn. Chúng tôi sẽ gửi liên kết đặt lại mật khẩu.',
    forgotPasswordSuccess: 'Nếu email tồn tại trong hệ thống, liên kết đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra hộp thư.',
    forgotPasswordError: 'Không thể gửi email đặt lại mật khẩu. Vui lòng thử lại.',
    sendResetLink: 'Gửi liên kết đặt lại',
    sendingResetLink: 'Đang gửi...',
    backToLogin: 'Quay lại đăng nhập',
    resetPasswordTitle: 'Đặt lại mật khẩu',
    resetPasswordDescription: 'Nhập mật khẩu mới cho tài khoản của bạn.',
    resetPasswordSuccess: 'Đặt lại mật khẩu thành công. Vui lòng đăng nhập.',
    resetPasswordError: 'Không thể đặt lại mật khẩu. Vui lòng thử lại.',
    invalidResetToken: 'Liên kết đặt lại mật khẩu không hợp lệ hoặc đã hết hạn.',
    resettingPassword: 'Đang đặt lại...',
    newPassword: 'Mật khẩu mới',
    confirmPassword: 'Xác nhận mật khẩu',
    passwordMismatch: 'Mật khẩu xác nhận không khớp.',
    myAccount: 'Tài khoản của tôi',
    myAccountDescription: 'Quản lý thông tin cá nhân và mật khẩu',
    personalInformation: 'Thông tin cá nhân',
    changePassword: 'Đổi mật khẩu',
    currentPassword: 'Mật khẩu hiện tại',
    changingPassword: 'Đang đổi mật khẩu...',
    passwordChangedSuccess: 'Đổi mật khẩu thành công!',
    errorChangingPassword: 'Lỗi khi đổi mật khẩu',
    profileUpdatedSuccess: 'Cập nhật thông tin thành công!',
    errorUpdatingProfile: 'Lỗi khi cập nhật thông tin',
    createAccount: 'Tạo tài khoản',
    creatingAccount: 'Đang tạo tài khoản...',
    signingIn: 'Đang đăng nhập...',
    firstTimeError: 'Không thể tạo tài khoản superadmin. Vui lòng thử lại.',
    loginError: 'Email hoặc mật khẩu không đúng.',
    superadminName: 'Superadmin',
    systemSubtitle: 'Hệ thống quản lý tòa nhà chung cư',
    loginFeatureSmartApartments: 'Quản lý căn hộ thông minh',
    loginFeatureModernPayments: 'Hệ thống thanh toán hiện đại',
    loginFeatureAccurateReports: 'Báo cáo chi tiết và chính xác',
    documentTitleTagline: 'Giải pháp số cho quản lý tòa nhà',
    // Backend error messages
    passwordComplexity: 'Mật khẩu phải có ít nhất 6 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.',
    emailExists: 'Email đã tồn tại.',
    unauthorized: 'Không có quyền truy cập.',
    // Account Management
    manageAccounts: 'Quản lý tài khoản người dùng trong hệ thống',
    searchAccountsPlaceholder: 'Tìm theo tên, email, tên đăng nhập hoặc chung cư...',
    createNewAccount: 'Tạo tài khoản người dùng mới với thông tin cá nhân và quyền truy cập',
    loginInformation: 'Thông tin đăng nhập',
    username: 'Tên đăng nhập',
    selectPermissionGroup: 'Chọn nhóm phân quyền',
    noAccounts: 'Không có tài khoản',
    getStartedAccounts: 'Bắt đầu bằng cách tạo tài khoản người dùng đầu tiên.',
    createFirstAccount: 'Tạo tài khoản đầu tiên',
    lastLogin: 'Đăng nhập lần cuối',
    never: 'Chưa từng',
    resetPassword: 'Đặt lại mật khẩu',
    toggleStatus: 'Thay đổi trạng thái',
    confirmDeleteAccount: 'Bạn có chắc chắn muốn xóa tài khoản',
    accountCreatedSuccess: 'Đã tạo tài khoản thành công!',
    errorCreatingAccount: 'Lỗi khi tạo tài khoản',
    accountUpdatedSuccess: 'Đã cập nhật tài khoản thành công!',
    errorUpdatingAccount: 'Lỗi khi cập nhật tài khoản',
    errorLoadingAccounts: 'Lỗi khi tải danh sách tài khoản',
    errorDeletingAccount: 'Lỗi khi xóa tài khoản',
    errorToggleAccountStatus: 'Lỗi khi thay đổi trạng thái tài khoản',
    pleaseEnterUsername: 'Vui lòng nhập tên đăng nhập',
    pleaseEnterPassword: 'Vui lòng nhập mật khẩu',
    pleaseSelectPermissionGroup: 'Vui lòng chọn nhóm phân quyền',
    fullSystemAccessNoGroup: 'Toàn quyền hệ thống (không gán nhóm phân quyền)',
    superadminPermissionGroupHelp: 'Để trống để có toàn quyền (dành cho quản trị viên chính). Chỉ chọn nhóm phân quyền cho superadmin được ủy quyền với quyền hạn giới hạn.',
    pleaseSelectRole: 'Vui lòng chọn vai trò',
    enterUsername: 'Nhập tên đăng nhập',
    enterPassword: 'Nhập mật khẩu',
    loadingAccounts: 'Đang tải danh sách tài khoản...',
    // Missing validation and form keys
    pleaseEnterFullName: 'Vui lòng nhập họ và tên',
    pleaseEnterEmail: 'Vui lòng nhập email',
    enterFullName: 'Nhập họ và tên',
    enterEmail: 'Nhập email',
    enterPhoneNumber: 'Nhập số điện thoại',
    usernameOrEmail: 'Tên đăng nhập hoặc Email',
    enterUsernameOrEmail: 'Nhập tên đăng nhập hoặc email',
    // Role translations
    roleSelection: 'Vai trò',
    selectRole: 'Chọn vai trò',
    statusSelection: 'Trạng thái tài khoản',
    SUPERADMIN: 'Quản trị viên',
    OPERATOR: 'Điều hành viên', 
    STAFF: 'Nhân viên',
    RESIDENT: 'Cư dân',
    
    // Service Fee Section
    serviceFeeSection: 'PHÍ DỊCH VỤ',
    payment: 'Thanh toán',
    reports: 'Báo cáo',
    transactionReportMenu: 'Giao dịch',
    receivableReportMenu: 'Phí phải thu',
    
    // Payment Page
    paymentSearchApartmentInfo: 'Tìm căn hộ',
    paymentBuildingSelection: 'Chung cư',
    paymentApartmentCodeInput: 'Mã căn hộ',
    paymentPhoneNumberSearch: 'Số điện thoại',
    paymentSearchButton: 'TÌM KIẾM',
    paymentMethodType: 'Hình thức',
    paymentCash: 'Tiền mặt',
    paymentBankTransfer: 'Chuyển khoản',
    paymentTotalAmount: 'Thành tiền',
    
    // Transaction Report
    reportFromDate: 'Từ ngày',
    reportToDate: 'Đến ngày',
    reportViewUnpaidTransactions: 'Xem cả các giao dịch chưa thanh toán',
    reportViewButton: 'XEM BÁO CÁO',
    
    // Receivable Report  
    reportViewOverdueFees: 'Chỉ xem phí đã quá hạn thanh toán',
    // Menu groupings
    accountsGroup: 'Tài khoản',
    permissionsGroup: 'Phân quyền',
    // Building Management
    buildings: 'Chung cư',
    buildingList: 'Danh sách chung cư',
    addBuilding: 'Thêm chung cư',
    editBuilding: 'Chỉnh sửa chung cư',
    buildingName: 'Tên chung cư',
    projectCode: 'Mã dự án',
    enterProjectCode: 'Nhập mã dự án (VD: DA101)',
    projectCodeHint: 'Mã ngắn gọn để nhận diện khi xuất báo cáo thống kê',
    invalidProjectCode: 'Mã dự án chỉ được chứa chữ in hoa, số, gạch dưới hoặc gạch ngang',
    operator: 'Điều hành viên',
    managementPhone: 'Điện thoại Ban quản lý',
    managementEmail: 'Email Ban quản lý',
    buildingLogoPath: 'Logo dự án / chung cư',
    buildingLogoPathHint: 'Đường dẫn hoặc URL logo riêng của từng chung cư (hiển thị trên PDF thông báo phí, phiếu thu). Có thể upload ảnh hoặc nhập đường dẫn/URL.',
    buildingLogoUploadHint: 'PNG, JPG hoặc SVG. Tối đa 5MB.',
    buildingLogoUrlLabel: 'Hoặc nhập đường dẫn / URL',
    buildingLogoUploadSuccess: 'Upload logo thành công',
    buildingLogoUploadSelectOperator: 'Vui lòng chọn đơn vị vận hành trước khi upload logo',
    enterBuildingLogoPath: 'VD: /uploads/buildings/stm-logo.png hoặc https://...',
    imageUploadEmpty: 'Chưa có ảnh',
    imageUploadChoose: 'Chọn ảnh',
    imageUploadReplace: 'Thay ảnh',
    imageUploadRemove: 'Xóa logo',
    imageUploadRemoving: 'Đang xóa...',
    imageUploading: 'Đang upload...',
    buildingLogoRemoveSuccess: 'Đã xóa logo',
    confirmRemoveBuildingLogo: 'Xóa logo của chung cư này?',
    address: 'Địa chỉ',
    apartmentCount: 'Số căn hộ',
    noBuildingsYet: 'Chưa có chung cư nào được tạo',
    addFirstBuilding: 'Thêm chung cư đầu tiên',
    confirmDeleteBuilding: 'Bạn có chắc chắn muốn xóa chung cư này?',
    errorDeletingBuilding: 'Có lỗi xảy ra khi xóa chung cư',
    buildingGeneralInfo: 'Thông tin chung',
    systemConfiguration: 'Cấu hình hệ thống',
    allowOnlinePayment: 'Cho phép thanh toán online',
    allowPartialPayment: 'Cho phép thanh toán riêng lẻ từng phần',
    combinedElevatorVehicleCards: 'Thẻ thang máy + thẻ xe dùng chung kho Thẻ xe (THE001 trên thẻ xe)',
    cardElevatorLinked: 'Thẻ thang máy',
    cardElevatorLinkedYes: 'Đã liên kết',
    cardElevatorLinkedFilterAll: 'Tất cả (thang máy)',
    cardElevatorLinkedFilterLinked: 'Đã liên kết thang máy',
    cardElevatorLinkedFilterNotLinked: 'Chưa liên kết thang máy',
    cardVehicleAssigned: 'Đã gán xe',
    autoSendEmailReminder: 'Tự động gửi email báo phí dịch vụ',
    autoGenerateMonthlyServiceFees: 'Tự động tạo phí dịch vụ hàng tháng',
    autoGenerateMonthlyServiceFeesHint:
      'Theo ngày chốt phí bên dưới. Tắt để cron không chạy Tạo phí; vẫn tạo thủ công tại Quản lý phí.',
    serviceFeeDay: 'Ngày chốt phí dịch vụ (hàng tháng)',
    paymentFromDay: 'Hạn thanh toán từ ngày',
    paymentToDay: 'đến ngày (hàng tháng)',
    configurationNote: 'Tùy chọn các thông số cấu hình theo nhu cầu.',
    parkingLegacyApiKey: 'API KEY cổng xe (get_v2 / set_v2)',
    parkingLegacyApiKeyHint:
      'Khóa dùng cho phần mềm cổng xe legacy. Tạo mới, sửa trực tiếp hoặc Thu hồi để vô hiệu. Lưu form để áp dụng.',
    parkingLegacyApiKeyPlaceholder: 'VD: 02822109199-002',
    generateParkingLegacyApiKey: 'Tạo mới',
    revokeParkingLegacyApiKey: 'Thu hồi',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    savingBuilding: 'Đang lưu...',
    saveBuilding: 'LƯU THÔNG TIN',
    updatingBuilding: 'Đang cập nhật...',
    updateBuilding: 'CẬP NHẬT THÔNG TIN',
    loadingBuildingInfo: 'Đang tải thông tin...',
    buildingNotFound: 'Không tìm thấy thông tin chung cư',
    backToList: 'Quay lại danh sách',
    errorLoadingBuilding: 'Có lỗi xảy ra khi tải thông tin chung cư',
    errorCreatingBuilding: 'Có lỗi xảy ra khi tạo chung cư',
    errorUpdatingBuilding: 'Có lỗi xảy ra khi cập nhật chung cư',
    enterBuildingName: 'Nhập tên chung cư hoặc dự án',
    enterManagementPhone: 'Nhập số điện thoại BQL',
    enterManagementEmail: 'Nhập địa chỉ email BQL',
    managementEmailOptionalHint: 'Tùy chọn. Nếu nhập, phải là địa chỉ email hợp lệ.',
    invalidEmail: 'Vui lòng nhập địa chỉ email hợp lệ',
    pleaseFixFormErrors: 'Vui lòng kiểm tra và sửa các lỗi trong biểu mẫu.',
    selectOperator: 'Chọn điều hành viên',
    pleaseSelectOperator: 'Please select operator',
    currentOperator: 'Current Operator',
    selectOperatorForPermissionGroup: 'Select operator owning this permission group',
    selectOperatorToViewPermissionGroups: 'Select operator to view permission groups',
    selectBuildingsFromList: 'Select building from list',
    noBuildings: 'Không có chung cư nào',
    selectOperatorToViewBuildings: 'Select operator to view buildings',
    // Role descriptions
    roleInformation: 'Role Information',
    fullSystemAccess: 'Full System Access',
    manageOwnBuildings: 'Manage Own Buildings',
    limitedAccessWithPermissions: 'Limited Access with Permissions',
    viewOwnInformation: 'View Own Information',
    // Utilities
    emailNotifications: 'Thông báo Email',
    sendNotification: 'Gửi thông báo',
    sendEmail: 'Gửi email', 
    emailList: 'Danh sách email',
    // Function code
    CHAT: 'Tin nhắn',
    SUPPORT: 'Hỗ trợ',
    EMAIL_NOTIFICATIONS: 'Mẫu email thông báo',
    SEND_EMAIL: 'Gửi email thông báo',
    EMAIL_LIST: 'Danh sách email thông báo',
    AUTOMATION_SETTINGS: 'Cài đặt tự động',
    PDF_TEMPLATES: 'Mẫu PDF phí dịch vụ',
    SERVICE_PAYMENT: 'Thanh toán phí dịch vụ',
    TRANSACTION_REPORT: 'Báo cáo giao dịch',
    RECEIVABLE_REPORT: 'Báo cáo phí phải thu',
    SERVICE_FEE_MANAGEMENT: 'Quản lý phí dịch vụ',
    CONTRACT_MANAGEMENT: 'Quản lý hợp đồng',
    REVENUE_CONTRACTS: 'Hợp đồng thu',
    EXPENDITURE_CONTRACTS: 'Hợp đồng chi',
    IE_REVENUE_ACTIVITIES: 'Hoạt động thu',
    IE_EXPENDITURE_ACTIVITIES: 'Hoạt động chi',
    IE_SUMMARY: 'Tổng hợp thu chi',
    IE_BANK_ACCOUNTS: 'Tài khoản ngân hàng',
    IE_FINANCIAL_REPORTS: 'Báo cáo tài chính',
    IE_DATA_IMPORT: 'Import dữ liệu',
    ACCOUNT_LIST: 'Danh sách tài khoản',
    PERMISSION_GROUPS: 'Nhóm phân quyền',
    BUILDING_LIST: 'Danh sách chung cư',
    SEND_FEE_NOTIFICATION: 'Gửi thông báo phí',
    FEE_CATEGORIES: 'Danh mục phí',
    BULK_FEE_ENTRY: 'Nhập phí hàng loạt',
    EXPORT_PDF_SERVICE_FEES: 'Xuất PDF phí dịch vụ',
    APARTMENT_LIST: 'Danh sách căn hộ',
    APARTMENT_GROUPS: 'Nhóm căn hộ',
    APARTMENT_USAGE_TYPES: 'Loại sử dụng căn hộ',
    RESIDENT_LIST: 'Danh sách cư dân',
    MONTHLY_VEHICLE_MANAGEMENT: 'Quản lý xe tháng',
    CARD_MANAGEMENT: 'Quản lý thẻ',
    TASK_LIST: 'Danh sách công việc',
    BUILDING_UTILITY_GROUPS: 'Danh sách nhóm tiện ích',
    BUILDING_UTILITY_LIST: 'Danh sách tiện ích tòa nhà',
    BUILDING_UTILITY_ADD: 'Thêm tiện ích tòa nhà',
    BUILDING_UTILITY_EDIT: 'Sửa tiện ích tòa nhà',

    BUILDING_BANNER_LIST: 'Quản lý banner',
    BUILDING_BANNER_ADD: 'Thêm banner',
    BUILDING_BANNER_EDIT: 'Sửa banner',
    BUILDING_NEWS_LIST: 'Quản lý tin tức',
    BUILDING_NEWS_ADD: 'Thêm tin tức',
    BUILDING_NEWS_EDIT: 'Sửa tin tức',

    BUILDING_UTILITY_BOOKINGS: 'Danh sách đăng ký tiện ích',
    CONSTRUCTION_REGISTRATION: 'Đăng ký thi công',
    ENTRY_EXIT_REGISTRATION: 'Đăng ký ra vào',
    MOVING_REGISTRATION: 'Đăng ký chuyển đồ',
    FEEDBACK_LIST: 'Danh sách phản hồi',
    FEEDBACK_CATEGORY_CONFIG: 'Danh mục phản hồi',
    FEEDBACK_STATISTICS: 'Thống kê CSKH',
    utilities: 'Tiện ích',
    // Send Email Form
    recipientSelection: 'Đối tượng nhận email',
    emailContent: 'Nội dung email',
    selectBuildingForEmail: 'Chọn chung cư',
    selectApartmentGroupForEmail: 'Chọn nhóm căn hộ',
    sendToAllApartments: 'Gửi cho tất cả các căn hộ',
    emailSubject: 'Tiêu đề',
    emailContentText: 'Nội dung',
    attachments: 'File đính kèm',
    maxTwoFiles: 'Tối đa 2 files',
    sendEmailButton: 'GỬI EMAIL',
    dragDropFiles: 'Kéo thả file hoặc Click vào đây để chọn',
    acceptedFileTypes: 'File đính kèm (image, pdf, word, excel. Tối đa 2 files)',
    // Email List
    emailRecordsPerPage: 'Số bản ghi/trang',
    emailSearchPlaceholder: 'Tìm kiếm',
    emailTitle: 'Tiêu đề',
    emailSendDate: 'Ngày gửi',
    emailRecipientGroup: 'Nhóm nhận email',
    emailSendCount: 'Số gửi',
    // Email View & Status
    emailStatus: 'Trạng thái',
    emailSent: 'Đã gửi',
    emailSending: 'Đang gửi',
    emailFailed: 'Thất bại',
    emailDraft: 'Nháp',
    viewEmailDetails: 'Xem chi tiết',
    backToEmailList: 'Quay lại danh sách',
    emailDetails: 'Chi tiết email',
    sentTo: 'Gửi tới',
    sentDate: 'Ngày gửi',
    emailAttachments: 'File đính kèm',
    thankYou: 'Trân trọng cảm ơn!',
    // Recipient Group Display
    allApartments: 'Tất cả căn hộ',
    unknownGroup: 'Không xác định',
    // Form Placeholders
    enterEmailSubject: 'Nhập tiêu đề email',
    enterEmailContent: 'Nhập nội dung email',
    selectBuildingFirst: 'Chọn chung cư trước',
    selectGroupOrAll: 'Chọn nhóm hoặc gửi tất cả',
    // Success Messages
    emailSentSuccess: 'Email đã được gửi thành công!',
    emailSentToApartments: 'Email đã được gửi đến {count} căn hộ',
    // Error Messages  
    errorSendingEmail: 'Có lỗi xảy ra khi gửi email',
    errorLoadingEmails: 'Có lỗi xảy ra khi tải danh sách email',
    errorLoadingEmailDetails: 'Có lỗi xảy ra khi tải chi tiết email',
    pleaseEnterEmailSubject: 'Vui lòng nhập tiêu đề email',
    pleaseEnterEmailContent: 'Vui lòng nhập nội dung email',
    fileUploadError: 'Lỗi tải file',
    maxFilesExceeded: 'Tối đa 2 files được phép',
    fileSizeExceeded: 'Kích thước file quá lớn',
    // Fee Categories
    feeCategories: 'Danh mục phí',
    addFeeService: 'Thêm loại phí dịch vụ',
    selectBuilding: 'Chọn chung cư:',
    selectBuildingPlaceholder: '-- Chọn chung cư --',
    manager: 'Quản lý:',
    noFeeCategories: 'Chưa có loại phí dịch vụ nào',
    addFirstFee: 'Thêm loại phí dịch vụ đầu tiên',
    serviceNumber: '#',
    feeService: 'Phí dịch vụ',
    feeCode: 'Mã chi phí',
    enterFeeCode: 'Nhập mã chi phí (VD: DV001, DV004)',
    feeCodeHint: 'Mã dịch vụ/chi phí theo biểu mẫu thu PQL, dùng khi xuất báo cáo',
    invalidFeeCode: 'Mã chi phí chỉ được chứa chữ in hoa, số và gạch ngang',
    feeType: 'Loại phí',
    unitPrice: 'Đơn giá',
    vat: 'VAT (%)',
    totalAmount: 'Thành tiền',
    closeFee: 'Chốt phí',
    notes: 'Ghi chú',
    fixed: 'Cố định',
    usageBased: 'Theo mức sử dụng',
    tiered: 'Bậc thang',
    automatic: 'Tự động',
    manual: 'Thủ công',
    confirmDeleteFeeCategory: 'Bạn có chắc chắn muốn xóa loại phí này?',
    failedToLoad: 'Không thể tải danh sách chung cư',
    failedToLoadCategories: 'Không thể tải danh sách phí dịch vụ',
    failedToDelete: 'Không thể xóa loại phí',
    failedToUpdateStatus: 'Không thể cập nhật trạng thái',
    errorCreatingFeeCategory: 'Không thể tạo loại phí dịch vụ',
    errorUpdatingFeeCategory: 'Không thể cập nhật loại phí dịch vụ',
    failedToLoadFeeCategory: 'Không thể tải thông tin loại phí dịch vụ',
    close: 'Đóng',
    // Member-related translations
    memberManagement: 'Quản lý thành viên căn hộ',
    fullNameMember: 'Họ tên',
    dateOfBirth: 'Ngày sinh',
    relationship: 'Quan hệ',
    relationshipRole: 'Quan hệ/vai trò trong căn hộ',
    // Relationship types
    ownerRole: 'Chủ sở hữu',
    spouseRole: 'Vợ/chồng',
    parentRole: 'Bố/mẹ',
    childRole: 'Con',
    otherRole: 'Khác',
    // Form validation
    pleaseSelectDateOfBirth: 'Vui lòng chọn ngày sinh',
    // Actions
    addMemberTitle: 'Thêm thành viên căn hộ',
    deleteMember: 'Xóa thành viên',
    confirmDeleteMember: 'Bạn có chắc chắn muốn xóa thành viên này?',
    // Table data states
    noMembersData: 'Chưa có thành viên nào',
    addMember: 'Thêm thành viên',
    // Fee Category Forms
    addFeeServiceTitle: 'Thêm loại phí dịch vụ',
    editFeeServiceTitle: 'Chỉnh sửa loại phí dịch vụ',
    selectBuildingSection: 'Chọn chung cư',
    pleaseSelectBuilding: 'Vui lòng chọn chung cư',
    pleaseEnterServiceName: 'Vui lòng nhập tên phí dịch vụ',
    serviceNameLabel: 'Tên phí dịch vụ',
    serviceNamePlaceholder: 'Tên phí dịch vụ',
    serviceInformation: 'Thông tin phí dịch vụ',
    tieredPricing: 'Đơn giá bậc thang',
    singleTier: 'Đơn giá cố định',
    quotaBased: 'Tính theo định mức',
    unitPriceLabel: 'Đơn giá (chưa gồm VAT - nếu có)',
    priceWithVatLabel: 'Đơn giá (đã gồm VAT)',
    compositePricingTitle: 'Cấu trúc đơn giá chi tiết',
    compositePricingHint: 'Tổng = đơn giá chưa VAT + VAT + phí bổ sung 1 + phí bổ sung 2 (theo % đơn giá hoặc phí cố định).',
    extraFeeGroup1Title: '1. Loại phí thêm 1',
    extraFeeGroup2Title: '2. Loại phí thêm 2',
    extraFeeGroupNameLabel: 'Tên loại phí thêm',
    extraFeeGroupNamePlaceholder: 'VD: Phí DVTN&XLNT, Phí hao hụt',
    tierCommonFeeSettingsHint: 'Cài đặt chung cho tất cả bậc thang (tên, %, VAT %, phí cố định). Số tiền được tính riêng theo từng bậc.',
    extraFeePercentLabel: 'Phí (%) - từ đơn giá',
    extraFeeAmountLabel: 'Tiền phí',
    extraFeeVatPercentLabel: 'Thuế VAT phí (%)',
    extraFeeVatAmountLabel: 'Tiền thuế VAT phí',
    extraFeeFixedLabel: 'Phí cố định',
    totalUnitPriceAfterTax: 'Tổng giá sau thuế',
    calculatedValue: 'Tính toán',
    vatAmountLabel: 'Thuế VAT',
    pricePlaceholder: 'Số tiền',
    usageLevel: 'Mức sử dụng',
    usageFrom: 'Từ',
    usageTo: 'đến',
    usageToUnlimitedHint: 'Để trống = không giới hạn',
    usageToLastTierNote: 'Bậc cuối: để trống ô "đến" (m³ không giới hạn). Ví dụ bậc 3: từ 6 đến trống. Các bậc ĐM khác (4, 5, 6…) dùng cho tính phí không theo định mức — cấu hình giá tại bậc tương ứng.',
    importMetersSampleDescription: 'Tải file mẫu có đầy đủ cột MÃ CĂN HỘ, MÃ ĐỒNG HỒ, LOẠI TÍNH PHÍ, TÍNH TỪ ĐỊNH MỨC (ĐM 1, 2, 3… theo cấu hình phí nước)...',
    priceLabel: 'Đơn giá (chưa gồm VAT - nếu có)',
    unitLabel: 'Đơn vị',
    unitPlaceholder: 'm2, m3, căn...',
    removeLevel: 'Xóa mức',
    addLevel: '+ Thêm mức',
    vatPercentage: 'Phí VAT (%)',
    monthlyFixedFee: 'Phí cố định hàng tháng cho 1 đơn vị (căn/m2/m3,...)',
    autoCloseMonthly: 'Tự động chốt phí hàng tháng',
    statusLabel: 'Trạng thái:',
    notesLabel: 'Ghi chú:',
    notesPlaceholder: 'Thông tin ghi chú',
    waiveFirstVehicleCardIssuanceFee: 'Miễn phí phát hành thẻ xe lần đầu theo biển số',
    waiveFirstVehicleCardIssuanceFeeHint:
      'Bật cho tòa nhà miễn phí cấp thẻ xe lần đầu cho mỗi biển số; thẻ thay thế cùng biển số vẫn tính phí THE003.',
    backButton: 'Quay lại',
    saving: 'Đang lưu...',
    // Fee Category Seeding
    createDefaultFeeCategories: 'Tạo danh mục phí mặc định',
    seedDefaultFeeCategories: 'Tạo danh mục phí mặc định',
    exportFeeCategories: 'Xuất danh mục phí',
    importFeeCategories: 'Nhập danh mục phí',
    exportFeeCategoriesSuccess: 'Đã xuất danh mục phí thành công',
    importFeeCategoriesHint: 'Tải lên file JSON đã xuất từ tòa nhà khác để sao chép cấu hình phí sang tòa nhà này.',
    importFeeCategoriesModeSkip: 'Bỏ qua mã phí đã tồn tại',
    importFeeCategoriesModeReplace: 'Cập nhật nếu mã phí đã tồn tại',
    feeCategoryImportJsonOnly: 'Chỉ hỗ trợ file JSON (.json) xuất từ hệ thống',
    defaultFeeCategoriesCreatedSuccess: 'Đã tạo các loại phí dịch vụ mặc định thành công!',
    errorCreatingDefaultFeeCategories: 'Lỗi khi tạo các loại phí dịch vụ mặc định',
    // Bulk Fee Entry
    bulkFeeEntry: 'Nhập phí hàng loạt',
    bulkFeeEntryTitle: 'Thêm hóa đơn hàng loạt',
    chooseServiceAndPeriod: 'Lựa chọn dịch vụ và kỳ hóa đơn',
    service: 'Dịch vụ',
    billingPeriod: 'Kỳ hóa đơn',
    selectService: 'Chọn dịch vụ',
    selectBillingPeriod: 'Chọn kỳ hóa đơn',
    manualEntryByApartmentList: 'THÊM THỦ CÔNG THEO DANH SÁCH CĂN HỘ',
    exportSampleFile: 'XUẤT FILE DỮ LIỆU MẪU',
    importDataFromFile: 'NHẬP DỮ LIỆU TỪ FILE MẪU',
    searchApartment: 'Tìm kiếm',
    apartmentCode: 'Căn hộ',
    oldReading: 'Chỉ số cũ',
    newReading: 'Chỉ số mới',
    usage: 'Số sử dụng',
    search: 'Tìm kiếm',
    addManuallyByList: 'Thêm thủ công theo danh sách căn hộ',
    // Pagination
    recordsPerPage: 'Số bản ghi/trang',
    showingRecords: 'Hiển thị {from} - {to} của {total} căn hộ',
    page: 'Trang',
    of: 'của',
    previous: 'Trước',
    next: 'Tiếp',
    first: 'Đầu',
    last: 'Cuối',
    noData: 'Không có dữ liệu',
    // Manual entry toggle
    showManualEntry: 'HIỂN THỊ NHẬP THỦ CÔNG',
    hideManualEntry: 'ẨN NHẬP THỦ CÔNG',
    manualEntrySection: 'Nhập thủ công theo danh sách căn hộ',
    // Additional translations for bulk fee entry
    pleaseSelectBuildingToViewApartments: 'Vui lòng chọn chung cư để xem danh sách căn hộ',
    processing: 'Đang xử lý...',
    noApartmentsFound: 'Chưa có căn hộ nào',
    noApartmentsInBuilding: 'Chưa có căn hộ nào trong chung cư này',
    // Error messages for bulk fee entry
    failedToLoadBillingPeriods: 'Không thể tải danh sách kỳ hóa đơn',
    failedToLoadServices: 'Không thể tải danh sách dịch vụ',
    failedToLoadApartments: 'Không thể tải danh sách căn hộ',
    failedToExportSample: 'Không thể xuất file mẫu',
    failedToImportFile: 'Không thể nhập file',
    pleaseEnterValidReadings: 'Vui lòng nhập ít nhất một chỉ số hợp lệ',
    failedToSubmitBulkEntry: 'Không thể gửi chỉ số hàng loạt',
    meterSubmitNoEndingReadings:
      'Chưa có CHỈ SỐ MỚI (chỉ số cuối kỳ) để gửi. Cột CHỈ SỐ CŨ trong file Ghi chỉ số là chỉ số đầu kỳ (tùy chọn), không phải chỉ số đầu khi lắp đồng hồ. Chỉ số đầu đồng hồ: tab Đồng hồ nước/điện → Import đồng hồ. Để tính phí kỳ: điền CHỈ SỐ MỚI (hoặc CHỈ SỐ CUỐI) cho từng căn.',
    bulkFeeEntrySuccess: 'Gửi chỉ số thành công!',
    meterBaselineSavedCount: 'Đã cập nhật {count} chỉ số đầu (không tạo phí kỳ)',
    pleaseSelectBuildingServiceAndFile: 'Vui lòng chọn chung cư, dịch vụ và file',
    pleaseSelectBuildingMeterTypeAndFile: 'Vui lòng chọn chung cư, loại đồng hồ và file',
    pleaseSelectBuildingServiceAndPeriod: 'Vui lòng chọn chung cư, dịch vụ và kỳ hóa đơn',
    // Missing translations for BulkFeeEntry
    meterType: 'Loại đồng hồ',
    electricity: 'Điện',
    water: 'Nước',
    hasData: 'Có dữ liệu',
    submitMeterReadings: 'Gửi chỉ số đồng hồ',
    chooseMeterTypeAndPeriod: 'Chọn loại đồng hồ và kỳ hóa đơn',
    tabWaterReadings: 'Chỉ số nước',
    tabElectricReadings: 'Chỉ số điện',
    tabWaterMeters: 'Đồng hồ nước',
    tabElectricMeters: 'Đồng hồ điện',
    meterReadingEntryTab: 'Ghi chỉ số',
    meterReadingHistoryTab: 'Lịch sử thao tác',
    meterReadingHistoryAllPeriods: 'Tất cả kỳ',
    usageVariance: 'Chênh lệch',
    meterReadingListTab: 'Danh sách chỉ số',
    noRecordedReadingsForPeriod: 'Không có chỉ số đã ghi cho kỳ {period}',
    readingStatusRecorded: 'Đã ghi chỉ số',
    readingHasImage: 'Có ảnh',
    readingNoImage: 'Không có ảnh',
    meterCode: 'Mã đồng hồ',
    billingMode: 'Loại tính phí',
    billingModeQuota: 'Theo định mức',
    billingModeNonQuota: 'Không theo định mức',
    feeMultiplier: 'Hệ số tính phí',
    quotaTierStart: 'Tính từ định mức',
    quotaTier1: 'ĐM 1',
    quotaTier2: 'ĐM 2',
    quotaTier3: 'ĐM 3',
    quotaTier4: 'ĐM 4',
    initialReading: 'Chỉ số đầu',
    registrationDate: 'Ngày đăng ký',
    meterStatusActive: 'Hoạt động',
    meterStatusInactive: 'Ngừng',
    exportMeters: 'Xuất danh sách đồng hồ',
    exportMeterQrSelected: 'Xuất QR đã chọn',
    exportMeterQrAll: 'Xuất QR tất cả',
    meterQrListTitle: 'Danh sách QR',
    noMetersSelectedForQr: 'Vui lòng chọn ít nhất một đồng hồ để xuất QR',
    print: 'In',
    meterQrPrinterSize: 'Khổ giấy in',
    meterQrPrinterA4: 'A4 (210mm)',
    meterQrPrinter80mm: 'Máy in 80mm',
    meterQrPrinter58mm: 'Máy in 58mm',
    importMeters: 'Import đồng hồ',
    addMeter: 'Thêm đồng hồ',
    meterList: 'Danh sách đồng hồ',
    noMeters: 'Chưa có đồng hồ',
    failedToLoadMeters: 'Không thể tải danh sách đồng hồ',
    failedToImportMeters: 'Không thể import đồng hồ',
    failedToCreateMeter: 'Không thể tạo đồng hồ',
    failedToDeleteMeter: 'Không thể xóa đồng hồ',
    failedToSaveMeter: 'Không thể lưu đồng hồ',
    confirmDeleteMeter: 'Xóa đồng hồ {code}?',
    deleteSelectedMeters: 'Xóa đã chọn',
    confirmBulkDeleteMeters: 'Xóa {count} đồng hồ đã chọn?',
    bulkDeleteMetersResultSummary: 'Đã xóa {deleted} đồng hồ, bỏ qua {skipped}.',
    meterCreateRequiredFields: 'Vui lòng chọn căn hộ và nhập mã đồng hồ',
    importMetersResult: 'Import: {created} mới, {updated} cập nhật, {skipped} bỏ qua',
    importReadingsSuccess: 'Import thành công {count} chỉ số',
    exportReadings: 'Xuất chỉ số',
    importReadings: 'Import chỉ số',
    importReadingsSampleDescription:
      'File Ghi chỉ số: bắt buộc CHỈ SỐ MỚI (chỉ số cuối kỳ); CHỈ SỐ CŨ tùy chọn (đầu kỳ, thường hệ thống lấy từ kỳ trước). Chỉ số đầu khi đăng ký đồng hồ: tab Đồng hồ nước/điện. Cột: KỲ HÓA ĐƠN, MÃ CĂN HỘ, MÃ ĐỒNG HỒ, CHỈ SỐ CŨ, CHỈ SỐ MỚI, SỐ SỬ DỤNG, GHI CHÚ — kỳ trong file phải khớp kỳ đã chọn.',
    deletePeriodReadings: 'Xóa chỉ số kỳ này',
    confirmDeletePeriodReadings:
      'Xóa tất cả chỉ số và hóa đơn chờ (chưa thanh toán) của kỳ {period}? Dùng khi nhập nhầm kỳ.',
    failedToDeletePeriodReadings: 'Không thể xóa chỉ số kỳ',
    importedFromExcel: 'Dữ liệu đã được nhập từ file Excel',
    searchApartmentOrMeter: 'Tìm căn hộ hoặc mã đồng hồ',
    editMeterTitle: 'Chỉnh sửa đồng hồ',
    // Apartment Management
    apartments: 'Căn hộ',
    addApartment: 'Thêm căn hộ',
    apartmentList: 'Danh sách căn hộ',
    apartmentGroups: 'Nhóm căn hộ',
    apartmentUsageTypes: 'Loại sử dụng căn hộ',
    searchApartments: 'Tìm căn hộ',
    addApartmentGroup: 'Thêm nhóm căn hộ',
    addApartmentUsageType: 'Thêm loại sử dụng',
    usageType: 'Sử dụng',
    usageTypeName: 'Tên loại sử dụng',
    usageTypeCode: 'Mã loại sử dụng',
    usageTypeManagementFeeCode: 'Mã phí quản lý (PQL)',
    usageTypeManagementFeeCodeHint:
      'Mã danh mục phí (vd. DV001, DV008). Để trống: CAN_HO → DV001, TM → DV008.',
    usageTypeNamePlaceholder: 'Ví dụ: Căn hộ, TM',
    selectUsageType: 'Chọn loại sử dụng',
    noUsageType: 'Không chọn',
    registeredQuotaCount: 'Số lượng ĐKĐM',
    registeredQuotaCountPlaceholder: 'Số người đăng ký định mức nước',
    registeredQuotaCountNote: 'Dùng để tính phí nước theo định mức (ví dụ: 3 người × 6m³ = 18m³)',
    apartmentName: 'Tên căn hộ',
    apartmentNamePlaceholder: 'Tên căn hộ',
    apartmentOccupancyStatus: 'Trạng thái căn hộ',
    occupancyOwnerUsing: 'Chủ nhà đang ở',
    occupancyRented: 'Hiện đang cho thuê',
    occupancyForRent: 'Căn hộ cho thuê',
    occupancyForSale: 'Căn hộ bán',
    handoverDate: 'Ngày bàn giao',
    handoverDatePlaceholder: 'dd/mm/yyyy',
    handoverDateEmptyHint: 'Để trống nếu chưa bàn giao',
    peCode: 'Mã PE',
    peCodePlaceholder: 'Mã PE',
    populationCount: 'Số nhân khẩu',
    populationCountPlaceholder: 'Số nhân khẩu',
    setAsDefaultUsageType: 'Đặt làm mặc định',
    pleaseEnterUsageTypeName: 'Vui lòng nhập tên loại sử dụng',
    pleaseEnterUsageTypeCode: 'Vui lòng nhập mã loại sử dụng',
    errorCreatingUsageType: 'Lỗi khi tạo loại sử dụng',
    errorLoadingUsageTypes: 'Lỗi khi tải loại sử dụng',
    errorDeletingUsageType: 'Lỗi khi xóa loại sử dụng',
    errorUpdatingUsageType: 'Lỗi khi cập nhật loại sử dụng',
    editApartmentUsageType: 'Chỉnh sửa loại sử dụng',
    exportUsageTypes: 'Xuất loại sử dụng',
    importUsageTypes: 'Nhập loại sử dụng',
    exportUsageTypesSuccess: 'Đã xuất loại sử dụng thành công',
    importUsageTypesHint: 'Tải lên file Excel hoặc CSV đã xuất từ tòa nhà khác để sao chép loại sử dụng căn hộ sang tòa nhà này.',
    importUsageTypesModeSkip: 'Bỏ qua mã đã tồn tại',
    importMode: 'Chế độ nhập',
    importUsageTypesModeReplace: 'Cập nhật nếu mã đã tồn tại',
    confirmDeleteUsageType: 'Bạn có chắc muốn xóa loại sử dụng này?',
    loadingUsageTypes: 'Đang tải loại sử dụng...',
    pleaseSelectBuildingToViewUsageTypes: 'Vui lòng chọn chung cư để xem loại sử dụng',
    noUsageTypes: 'Chưa có loại sử dụng nào',
    addFirstUsageType: 'Thêm loại sử dụng đầu tiên',
    default: 'Mặc định',
    editApartment: 'Chỉnh sửa căn hộ',
    editApartmentGroup: 'Chỉnh sửa nhóm căn hộ',
    selectApartmentGroup: 'Chọn nhóm căn hộ',
    customerCode: 'Mã khách hàng',
    ownerName: 'Tên chủ hộ',
    ownerPhone: 'Điện thoại',
    ownerEmail: 'Email chủ hộ',
    feeNotificationEmail: 'Email (Thông báo phí)',
    feeNotificationEmailPlaceholder: 'Email nhận thông báo phí',
    invoiceEmail: 'Email nhận hóa đơn',
    invoiceEmailPlaceholder: 'Email nhận hóa đơn VAT',
    multipleEmailsHint: 'Nhiều email cách nhau bởi dấu chấm phẩy (;)',
    invalidEmailList: 'Mỗi email phải hợp lệ. Nhiều email cách nhau bởi dấu chấm phẩy (;).',
    apartmentAddress: 'Địa chỉ',
    apartmentArea: 'Diện tích (m2)',
    taxCode: 'Mã số thuế',
    apartmentNotes: 'Ghi chú',
    hasVatInvoice: 'Có xuất hóa đơn VAT',
    apartmentGroup: 'Nhóm căn hộ',
    groupDescription: 'Mô tả nhóm',
    noApartmentGroup: 'Không thuộc nhóm nào',
    noApartments: 'Chưa có căn hộ nào',
    noApartmentGroups: 'Chưa có nhóm căn hộ nào',
    addFirstApartment: 'Thêm căn hộ đầu tiên',
    addFirstApartmentGroup: 'Thêm nhóm căn hộ đầu tiên',
    apartmentInformation: 'Thông tin căn hộ',
    ownerInformation: 'Thông tin chủ hộ',
    groupInformation: 'Thông tin nhóm',
    totalApartments: 'Tổng số căn hộ',
    totalGroups: 'Tổng số nhóm',
    apartmentsInGroup: 'Số căn hộ',
    confirmDeleteApartment: 'Bạn có chắc chắn muốn xóa căn hộ này?',
    confirmDeleteApartmentGroup: 'Bạn có chắc chắn muốn xóa nhóm căn hộ này?',
    apartmentCreatedSuccess: 'Đã tạo căn hộ thành công!',
    apartmentUpdatedSuccess: 'Đã cập nhật căn hộ thành công!',
    apartmentGroupCreatedSuccess: 'Đã tạo nhóm căn hộ thành công!',
    apartmentGroupUpdatedSuccess: 'Đã cập nhật nhóm căn hộ thành công!',
    errorCreatingApartment: 'Lỗi khi tạo căn hộ',
    errorUpdatingApartment: 'Lỗi khi cập nhật căn hộ',
    errorLoadingApartments: 'Lỗi khi tải danh sách căn hộ',
    errorDeletingApartment: 'Lỗi khi xóa căn hộ',
    errorCreatingApartmentGroup: 'Lỗi khi tạo nhóm căn hộ',
    errorUpdatingApartmentGroup: 'Lỗi khi cập nhật nhóm căn hộ',
    errorLoadingApartmentGroups: 'Lỗi khi tải danh sách nhóm căn hộ',
    errorDeletingApartmentGroup: 'Lỗi khi xóa nhóm căn hộ',
    selectApartmentGroups: 'Chọn nhóm căn hộ',
    unassignedApartmentGroup: 'Không có nhóm',
    apartmentGroupMultiSelectHint: 'Chọn một hoặc nhiều nhóm. Bỏ trống (và không chọn "Gửi tất cả") sẽ không gửi được.',
    feeNotificationGroupHint: 'Chọn nhóm cần tạo phí và gửi thông báo. Bỏ trống để áp dụng cho toàn bộ chung cư.',
    selectedApartmentGroupsText: 'các căn hộ trong nhóm đã chọn',
    bulkAssignApartmentGroup: 'Gán căn hộ hàng loạt',
    bulkAssignApartmentGroupFor: 'Gán căn hộ cho nhóm',
    bulkAssignApartmentGroupSuccess: 'Đã gán {count} căn hộ vào nhóm thành công',
    errorBulkAssignApartmentGroup: 'Lỗi khi gán căn hộ vào nhóm',
    showUnassignedApartmentsOnly: 'Chỉ hiện căn hộ chưa có nhóm',
    selectAllFiltered: 'Chọn tất cả trong danh sách',
    selectUnassignedFiltered: 'Chọn căn chưa có nhóm',
    clearFilteredSelection: 'Bỏ chọn trong danh sách',
    selectedApartmentsCount: 'Đã chọn: {count} căn hộ',
    assignApartments: 'Gán căn hộ',
    pleaseEnterApartmentCode: 'Vui lòng nhập mã căn hộ',
    pleaseEnterOwnerName: 'Vui lòng nhập tên chủ hộ',
    enterApartmentCode: 'Nhập mã căn hộ',
    enterCustomerCode: 'Nhập mã khách hàng',
    enterOwnerName: 'Nhập tên chủ hộ',
    enterOwnerPhone: 'Nhập điện thoại chủ hộ',
    enterOwnerEmail: 'Nhập email chủ hộ',
    enterApartmentAddress: 'Nhập địa chỉ căn hộ',
    enterApartmentArea: 'Nhập diện tích',
    enterTaxCode: 'Nhập mã số thuế',
    enterApartmentNotes: 'Nhập ghi chú',
    loadingApartments: 'Đang tải danh sách căn hộ...',
    loadingApartmentGroups: 'Đang tải danh sách nhóm căn hộ...',
    // Apartment Form Placeholders and Labels
    apartmentCodePlaceholder: 'MÃ CĂN HỘ',
    customerCodePlaceholder: 'MÃ KHÁCH HÀNG', 
    customerCodeNote: 'Mã khách hàng được sử dụng để cư dân tra cứu phí dịch vụ online, để trống nếu dùng chung với mã căn hộ.',
    apartmentAreaPlaceholder: 'Diện tích',
    ownerInfoTitle: 'Thông tin chủ/đại diện căn hộ',
    ownerNamePlaceholder: 'Tên chủ căn hộ',
    ownerPhonePlaceholder: 'Điện thoại chủ căn hộ',
    ownerAddressPlaceholder: 'Địa chỉ chủ căn hộ',
    ownerEmailPlaceholder: 'Email chủ căn hộ',
    taxCodePlaceholder: 'Mã số thuế',
    vatInvoiceNote: 'Các thông tin này được sử dụng để gửi thông tin & phát hành hóa đơn (nếu có).',
    defaultGroup: 'Nhóm mặc định',
    // Apartment Details
    apartmentDetails: 'Chi tiết căn hộ',
    serviceFees: 'Phí dịch vụ',
    members: 'Thành viên',
    residentList: 'Danh sách cư dân',
    mobileAppAccount: 'Tài khoản app di động',
    mobileAppLinked: 'Đã liên kết',
    mobileAppNotLinked: 'Chưa liên kết',
    totalResidents: 'Tổng cư dân',
    totalOwners: 'Chủ hộ',
    appLinkedResidents: 'Đã liên kết app',
    pleaseSelectBuildingToViewApartmentGroups: 'Vui lòng chọn chung cư để xem nhóm căn hộ',
    pleaseSelectBuildingToViewResidents: 'Vui lòng chọn chung cư để xem danh sách cư dân',
    addResident: 'Thêm cư dân',
    editResident: 'Sửa cư dân',
    residentName: 'Tên cư dân',
    residentRole: 'Vai trò',
    residentRoleOwner: 'Chủ hộ',
    residentRoleMember: 'Nhân khẩu',
    manageResidents: 'Quản lý cư dân',
    membersTabReadOnlyHint: 'Quản lý thêm/sửa/xóa cư dân tại menu Danh sách cư dân.',
    exportResidents: 'Xuất cư dân',
    importResidents: 'Nhập cư dân',
    importResidentsHint: 'Tải file Excel theo mẫu. Mã căn phải tồn tại trong tòa nhà đã chọn.',
    errorLoadingResidents: 'Lỗi khi tải danh sách cư dân',
    errorSavingResident: 'Lỗi khi lưu cư dân',
    errorDeletingResident: 'Lỗi khi xóa cư dân',
    confirmDeleteResident: 'Bạn có chắc chắn muốn xóa cư dân này?',
    residentListTab: 'Danh sách cư dân',
    residentHistoryTab: 'Lịch sử hoạt động',
    deleteSelectedResidents: 'Xóa đã chọn',
    confirmBulkDeleteResidents: 'Xóa {count} cư dân đã chọn?',
    bulkDeleteResidentsResultSummary: 'Đã xóa {deleted} cư dân.',
    deleteSelectedMonthlyVehicles: 'Xóa đã chọn',
    confirmBulkDeleteMonthlyVehicles: 'Xóa {count} xe tháng đã chọn?',
    bulkDeleteMonthlyVehiclesResultSummary: 'Đã xóa {deleted} xe tháng.',
    activityHistoryDeletedResidents: 'Đã xóa',
    showLegacyDeletedVehicles: 'Hiển thị xe legacy (Bị xóa)',
    showLegacyDeletedVehiclesHint: 'Các bản ghi soft-delete cũ còn trong database. Chọn và xóa vĩnh viễn nếu không cần giữ.',
    legacyDeletedViewNote: 'Đang xem xe legacy (soft-delete cũ). Chọn xe cần xóa vĩnh viễn khỏi database.',
    legacyDeletedCountLabel: 'Xe legacy trong tòa nhà',
    purgeLegacyVehicle: 'Xóa vĩnh viễn',
    purgeSelectedLegacyVehicles: 'Xóa vĩnh viễn đã chọn',
    confirmPurgeLegacyVehicle: 'Xóa vĩnh viễn xe legacy này khỏi database?',
    confirmBulkPurgeLegacyVehicles: 'Xóa vĩnh viễn {count} xe legacy đã chọn khỏi database?',
    monthlyVehicleManagement: 'Quản lý xe tháng',
    cardManagement: 'Quản lý thẻ',
    vehicleCards: 'Thẻ xe',
    vehicleAndElevatorCards: 'Thẻ xe + thang máy',
    elevatorCards: 'Thẻ thang máy',
    entryCards: 'Thẻ ra vào',
    addMonthlyVehicle: 'Thêm xe tháng',
    editMonthlyVehicle: 'Sửa xe tháng',
    importMonthlyVehicles: 'Nhập xe tháng từ Excel',
    confirmDeleteMonthlyVehicle: 'Bạn có chắc chắn muốn xóa xe tháng này?',
    monthlyVehicleDeleteModalTitle: 'Xóa xe tháng',
    monthlyVehicleBulkDeleteModalTitle: 'Xóa {count} xe tháng đã chọn',
    monthlyVehicleDeleteNotesHint:
      'Ghi chú lý do xóa (tùy chọn, lưu vào lịch sử thao tác và cột Ghi chú của xe legacy)',
    restoreMonthlyVehicle: 'Khôi phục',
    restoreSelectedMonthlyVehicles: 'Khôi phục đã chọn',
    monthlyVehicleRestoreModalTitle: 'Khôi phục xe tháng',
    monthlyVehicleBulkRestoreModalTitle: 'Khôi phục {count} xe tháng đã chọn',
    confirmRestoreMonthlyVehicle: 'Khôi phục xe tháng này về danh sách đang quản lý?',
    confirmBulkRestoreMonthlyVehicles: 'Khôi phục {count} xe tháng đã chọn?',
    monthlyVehicleRestoreNotesHint: 'Ghi chú lý do khôi phục (tùy chọn)',
    bulkRestoreMonthlyVehiclesResultSummary: 'Đã khôi phục {restored} xe tháng.',
    cardActionRestore: 'Khôi phục',
    confirmDeleteCard: 'Bạn có chắc chắn muốn xóa thẻ này?',
    addCard: 'Thêm thẻ',
    editCard: 'Sửa thẻ',
    importCards: 'Nhập thẻ từ Excel',
    cardNumber: 'Số thẻ',
    cardCode: 'Mã thẻ',
    cardType: 'Loại thẻ',
    cardStockStatus: 'Trạng thái',
    cardSold: 'Đã bán',
    cardAvailable: 'Còn trống',
    cardsSoldCount: 'Đã bán',
    cardsAvailableCount: 'Còn trống',
    cardActionHistory: 'Lịch sử thao tác',
    cardActionCreate: 'Thêm',
    cardActionUpdate: 'Sửa',
    cardActionDelete: 'Xóa',
    cardActionBulkDelete: 'Xóa hàng loạt',
    cardActionImport: 'Nhập Excel',
    cardStockStatusFilterAll: 'Tất cả trạng thái',
    cardTypeFilterAll: 'Tất cả loại thẻ',
    cardTypeUsageCountHint: 'Số thẻ trong danh sách Thẻ xe (theo loại thẻ).',
    deleteSelectedCards: 'Xóa đã chọn',
    deleteAllAvailableCards: 'Xóa tất cả còn trống',
    confirmBulkDeleteAccessCards: 'Xóa {count} thẻ đã chọn (chỉ thẻ còn trống)?',
    confirmDeleteAllAvailableAccessCards:
      'Xóa tất cả thẻ còn trống trong tab này (theo bộ lọc hiện tại)? Thẻ đã bán hoặc đã gán xe sẽ được bỏ qua.',
    bulkDeleteAccessCardsResultSummary: 'Đã xóa {deleted} thẻ, bỏ qua {skipped}.',
    restoreAccessCard: 'Khôi phục',
    confirmRestoreAccessCard: 'Khôi phục thẻ đã xóa từ bản ghi lịch sử này?',
    bulkRestoreAccessCardsResultSummary: 'Đã khôi phục {restored} thẻ.',
    cardKindLabel: 'Loại thẻ',
    cardActionStaff: 'Nhân viên',
    cardNumberFromRegistry: 'Chọn số thẻ đã đăng ký trong Quản lý thẻ',
    cardNumberSearchPlaceholder: 'Gõ số thẻ hoặc mã UID (tối thiểu 2 ký tự)...',
    createVehicleCardIssuanceFee: 'Tạo phí phát hành thẻ xe',
    createParkingFeeInvoice: 'Tạo hóa đơn thanh toán phí giữ xe',
    saveAndPay: 'Lưu & Thanh toán',
    monthlyVehicleCardRequiredForIssuanceFee: 'Vui lòng chọn thẻ khả dụng để tạo phí phát hành thẻ xe',
    monthlyVehicleCardClearedHint:
      'Đã gỡ thẻ hiện tại. Chọn thẻ mới trong danh sách hoặc bấm Lưu để chỉ cập nhật các trường khác.',
    monthlyVehicleDatesRequiredForParkingFee: 'Vui lòng nhập ngày bắt đầu và ngày hết hạn để tạo hóa đơn phí giữ xe',
    licensePlate: 'Biển số xe',
    vehicleModel: 'Mẫu xe',
    vehicleModelPlaceholder: 'Ví dụ: Honda Vision, Toyota Vios',
    parkingSpot: 'Số ô đậu',
    monthlyVehicleParkingFee: 'Phí tháng',
    monthlyVehicleParkingFeeHint:
      'Để trống = tính theo danh mục phí (loại thẻ). 0 = miễn phí (không tạo phí gửi xe). Nhập số = phí gửi xe all-in (đã gồm VAT).',
    monthlyVehicleParkingFeeByCategory: 'Theo DM',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày hết hạn',
    endOfMonth: 'Cuối tháng',
    parkingExpiryHint: 'Ngày 01 hàng tháng = 00:00 ngày 01 (hết hạn tại thời điểm đó). VD: 01/09/2026',
    parkingStatusExpired: 'Hết hạn',
    parkingStatusLocked: 'Bị khóa',
    parkingStatusDeleted: 'Bị xóa',
    syncParkingQuantities: 'Đồng bộ toàn bộ',
    syncParkingQuantitiesHint:
      'Đồng bộ số lượng phí gửi xe trên danh sách căn hộ theo xe tháng thực tế. Căn hộ không có xe tháng sẽ đặt số lượng về 0. Hóa đơn gửi xe chưa thanh toán không khớp xe đăng ký chỉ được dọn ở kỳ hiện tại (MM/YYYY); các kỳ trước giữ nguyên.',
    monthlyVehicleAutoSyncNote: 'Khi căn hộ có dữ liệu xe tháng: hóa đơn gửi xe tạo theo từng xe, số lượng phí chỉ để thống kê. Căn hộ/tòa nhà không có xe tháng vẫn tính phí theo số lượng (một hóa đơn mỗi loại xe).',
    parkingQuantitiesSynced: 'Đã đồng bộ số lượng phí gửi xe cho các căn hộ',
    cardTypeFeeMapping: 'Ánh xạ loại thẻ → phí gửi xe',
    cardTypeFeeMappingHint: 'Mỗi loại thẻ được ánh xạ tới một danh mục phí gửi xe. Số lượng phí căn hộ sẽ tự động cập nhật theo số xe tháng trạng thái OK.',
    cardTypeManagement: 'Loại thẻ xe',
    cardTypeManagementHint: 'Quản lý loại thẻ xe linh hoạt theo từng tòa nhà. Khi nhập Thẻ xe hoặc Xe tháng, loại thẻ mới trong cột LOẠI THẺ sẽ được tạo tự động nếu chưa có.',
    addCardType: 'Thêm loại thẻ',
    editCardType: 'Sửa loại thẻ',
    cardTypeName: 'Tên loại thẻ',
    cardTypeCode: 'Mã loại thẻ',
    cardTypeCodeOptional: 'Tùy chọn — tự tạo từ tên nếu để trống',
    confirmDeleteCardType: 'Bạn có chắc chắn muốn xóa loại thẻ này?',
    noCardTypesYet: 'Chưa có loại thẻ. Thêm thủ công hoặc nhập Excel với cột LOẠI THẺ.',
    noCardTypesForVehicleImport: 'Chưa có loại thẻ. Bạn có thể thêm ở tab Loại thẻ xe, hoặc nhập Excel — loại thẻ mới sẽ được tạo tự động từ cột LOẠI THẺ.',
    importCardsTypeHint: 'Cột LOẠI THẺ sẽ tạo loại thẻ mới tự động nếu chưa tồn tại.',
    importCardsSampleDescription: 'Tải file mẫu có cột SỐ THẺ, MÃ THẺ, LOẠI THẺ (Thẻ xe), GHI CHÚ. Loại thẻ mới trong file sẽ được tạo tự động.',
    cardTypeFeeMappingSaveHint: 'Sau khi lưu ánh xạ phí, dùng "Đồng bộ số lượng phí" ở Quản lý xe tháng để cập nhật số lượng căn hộ.',
    vehicleOwner: 'Chủ xe',
    cardNotFoundInRegistry: 'Không tìm thấy số thẻ trong danh sách Thẻ xe',
    importMonthlyVehiclesSampleDescription:
      'Tải file mẫu với MÃ CĂN HỘ, SỐ THẺ, LOẠI THẺ, BIỂN SỐ XE, PHÍ THÁNG (all-in), CHỦ XE... Loại thẻ mới sẽ được tạo tự động.',
    usageCount: 'Đang dùng',
    notMapped: 'Chưa ánh xạ',
    searchMonthlyVehiclesPlaceholder: 'Tìm theo mã/tên căn hộ, biển số, mẫu xe, số thẻ...',
    searchCardsPlaceholder: 'Tìm theo số thẻ, mã thẻ...',
    importExcel: 'Nhập Excel',
    exportExcel: 'Xuất Excel',
    downloadSample: 'Tải mẫu',
    importComplete: 'Nhập xong',
    importCreated: 'tạo mới',
    updated: 'cập nhật',
    skipped: 'bỏ qua',
    importing: 'Đang nhập...',
    import: 'Nhập',
    syncing: 'Đang đồng bộ...',
    syncFailed: 'Đồng bộ thất bại',
    saveFailed: 'Lưu thất bại',
    deleteFailed: 'Xóa thất bại',
    totalRecords: 'Tổng bản ghi',
    noResidents: 'Chưa có cư dân',
    searchResidentsPlaceholder: 'Tìm theo tên, email, điện thoại, mã căn...',
    residentApartmentCode: 'Mã căn',
    gender: 'Giới tính',
    nationality: 'Quốc tịch',
    idIssueDate: 'Ngày cấp',
    idExpiryDate: 'Hết hạn',
    moveInDate: 'Ngày vào',
    moveOutDate: 'Ngày đi',
    genderMale: 'Nam',
    genderFemale: 'Nữ',
    genderOther: 'Khác',
    nationalityVietnam: 'Việt Nam',
    nationalityForeign: 'Nước ngoài',
    relationshipTenant: 'Khách thuê',
    relationshipContractHolder: 'Đứng tên trên hợp đồng thuê',
    relationshipHusband: 'Chồng',
    relationshipWife: 'Vợ',
    relationshipBrother: 'Anh',
    relationshipSister: 'Chị',
    relationshipGrandson: 'Cháu trai',
    relationshipGranddaughter: 'Cháu gái',
    relationshipYoungerBrother: 'Em trai',
    relationshipYoungerSister: 'Em gái',
    relationshipFather: 'Cha',
    relationshipMother: 'Mẹ',
    relationshipGrandfather: 'Ông',
    relationshipGrandmother: 'Bà',
    relationshipAunt: 'Cô',
    relationshipUncle: 'Chú',
    relationshipCleaner: 'Vệ sinh',
    relationshipSecurity: 'Bảo vệ',
    relationshipStaff: 'Nhân viên',
    relationshipAuthorized: 'Được ủy quyền',
    relationshipMotherInLaw: 'Mẹ chồng',
    relationshipFatherInLaw: 'Ba chồng',
    relationshipDaughterInLaw: 'Con dâu',
    relationshipSonInLaw: 'Con rể',
    relationshipGrandchild: 'Cháu nội',
    relationshipBrotherInLaw: 'Anh rể',
    relationshipSisterInLaw: 'Em dâu',
    relationshipFriend: 'Bạn',
    relationshipHousekeeper: 'Người giúp việc',
    relationshipFormerOwner: 'Chủ cũ',
    relationshipOwner: 'Chủ sở hữu / Chủ hộ',
    relationshipSon: 'Con trai',
    relationshipDaughter: 'Con gái',
    relationshipPartner: 'Bạn bè / Đối tác',
    relationshipRelative: 'Người thân / Họ hàng',
    relationshipSpouse: 'Vợ / chồng',
    relationshipChild: 'Con trai / con gái',
    paymentHistory: 'Lịch sử thanh toán',
    notificationHistory: 'Lịch sử thông báo',
    noNotificationHistory: 'Chưa có lịch sử thông báo nào',
    updateInfo: 'CẬP NHẬT THÔNG TIN',
    // Missing translations for ApartmentDetailsEnhanced
    memberList: 'Danh sách thành viên',
    // Missing translations for AddMemberModal
    roleInApartment: 'Vai trò trong căn hộ',
    tenantRole: 'Người thuê',
    familyRole: 'Thành viên gia đình',
    corporateRepresentativeRole: 'Đại diện công ty',
    corporateEmployeeRole: 'Nhân viên công ty',
    citizenId: 'CMND/CCCD',
    isPrimaryContact: 'Liên hệ chính',
    // Missing translations for EditMemberModal
    editMemberTitle: 'Chỉnh sửa thành viên',
    fullNameAndSurname: 'Họ và tên',
    enterFullNameAndSurname: 'Nhập họ và tên',
    roleInApartmentEdit: 'Vai trò trong căn hộ',
    ownerRoleEdit: 'Chủ hộ',
    phone: 'Số điện thoại',
    enterPhone: 'Nhập số điện thoại',
    enterCitizenId: 'Nhập CMND/CCCD',
    errorUpdatingMember: 'Có lỗi xảy ra khi cập nhật thành viên',
    // Additional member-related translations
    primary: 'Chính',
    userTypeResident: 'Cư dân',
    userTypeCorporate: 'Doanh nghiệp',
    notLinked: 'Chưa liên kết',
    // Settings Page
    settings: 'Cấu hình',
    settingsTitle: 'Cấu hình hệ thống',
    emailSettings: 'Cài đặt Email',
    paymentSettings: 'Cài đặt Thanh toán',
    systemSettings: 'Cài đặt Hệ thống',
    personalSettings: 'Cài đặt cá nhân',
    globalSettings: 'Cài đặt mặc định (Global)',
    effectiveSettings: 'Cài đặt hiệu lực hiện tại',
    currentlyActive: 'Đang sử dụng',
    noSettingsConfigured: 'Chưa có cài đặt nào được cấu hình',
    fallbackToGlobal: 'Sẽ sử dụng cài đặt mặc định (global)',
    fallbackToEnvironment: 'Sẽ sử dụng cài đặt từ biến môi trường',
    // Email Settings
    smtpHost: 'Máy chủ SMTP',
    smtpPort: 'Cổng SMTP',
    smtpSecure: 'Sử dụng mã hóa SSL/TLS',
    smtpSecureDescription: 'Bật cho cổng 465 (SSL/TLS), tắt cho cổng 587 (STARTTLS) hoặc cổng 25 (không mã hóa)',
    smtpUsername: 'Tài khoản SMTP',
    smtpPassword: 'Mật khẩu SMTP',
    smtpFromEmail: 'Email gửi',
    emailProviderType: 'Phương thức gửi email',
    emailProviderSmtp: 'SMTP',
    emailProviderSmtpDescription: 'Gửi qua máy chủ SMTP truyền thống (Gmail, hosting mail, ...)',
    emailProviderApi: 'Email API',
    emailProviderApiDescription: 'Gửi qua API (Sendify, Resend, ...) — hỗ trợ theo dõi trạng thái gửi',
    emailApiProvider: 'Nhà cung cấp API',
    emailApiProviderSendify: 'Sendify (MatBao)',
    emailApiProviderResend: 'Resend',
    emailApiProviderCustom: 'Tùy chỉnh (API tương thích Resend)',
    emailApiProviderDescription: 'Sendify API: https://sendify.vn/api/emails — mỗi API key chỉ gửi cho 1 domain đã xác minh',
    emailApiKey: 'API Key',
    emailApiBaseUrl: 'API Base URL',
    emailApiBaseUrlDescription: 'URL gốc của API, ví dụ https://api.example.com (không thêm /emails)',
    emailApiFromDescription: 'Địa chỉ đã xác minh trên nhà cung cấp API, ví dụ "eBMS" hello@domain.com',
    testConnection: 'Kiểm tra kết nối',
    saveSettings: 'Lưu cài đặt',
    deleteSettings: 'Xóa cài đặt',
    testingConnection: 'Đang kiểm tra kết nối...',
    savingSettings: 'Đang lưu cài đặt...',
    deletingSettings: 'Đang xóa cài đặt...',
    confirmDeleteEmailSettings: 'Bạn có chắc chắn muốn xóa cấu hình email này?',
    confirmDeletePaymentSettings: 'Bạn có chắc chắn muốn xóa cấu hình thanh toán này?',
    pleaseEnterSmtpHost: 'Vui lòng nhập máy chủ SMTP',
    pleaseEnterSmtpPort: 'Vui lòng nhập cổng SMTP', 
    pleaseEnterSmtpUsername: 'Vui lòng nhập tài khoản SMTP',
    pleaseEnterSmtpPassword: 'Vui lòng nhập mật khẩu SMTP',
    pleaseEnterFromEmail: 'Vui lòng nhập email gửi',
    enterSmtpHost: 'Nhập máy chủ SMTP (vd: smtp.gmail.com)',
    enterSmtpPort: 'Nhập cổng SMTP (vd: 587)',
    enterSmtpUsername: 'Nhập tài khoản SMTP',
    enterSmtpPassword: 'Nhập mật khẩu SMTP',
    enterFromEmail: 'Nhập email gửi',
    // Payment Settings
    bankName: 'Tên ngân hàng',
    bankAccount: 'Số tài khoản',
    bankAccountName: 'Tên tài khoản',
    paymentMethods: 'Phương thức thanh toán',
    pleaseEnterBankName: 'Vui lòng nhập tên ngân hàng',
    pleaseEnterBankAccount: 'Vui lòng nhập số tài khoản',
    pleaseEnterBankAccountName: 'Vui lòng nhập tên tài khoản',
    pleaseSelectPaymentMethods: 'Vui lòng chọn ít nhất một phương thức thanh toán',
    enterBankName: 'Nhập tên ngân hàng',
    enterBankAccount: 'Nhập số tài khoản',
    enterBankAccountName: 'Nhập tên tài khoản',
    selectPaymentMethods: 'Chọn phương thức thanh toán',
    bankTransfer: 'Chuyển khoản ngân hàng',
    cash: 'Tiền mặt',
    creditCard: 'Thẻ tín dụng',
    debitCard: 'Thẻ ghi nợ',
    eWallet: 'Ví điện tử',
    onlinePayment: 'Thanh toán online',
    check: 'Séc',
    other: 'Khác',
    // Building Selection
    selectBuildingForSettings: 'Chọn tòa nhà',
    pleaseSelectBuildingFirst: 'Vui lòng chọn tòa nhà trước khi cấu hình cài đặt cá nhân',
    // Status Messages
    notConfigured: 'Chưa cài đặt',
    usingPersonalSettings: 'Đang sử dụng cài đặt cá nhân',
    usingGlobalSettings: 'Đang sử dụng cài đặt mặc định',
    itemsCount: 'loại',
    // Send Fee Notification
    sendFeeNotification: 'Gửi thông báo phí',
    // Export PDF Service Fees
    exportPdfServiceFees: 'Xuất file PDF phí dịch vụ',
    apartmentInfo: 'Thông tin căn hộ',
    apartmentsWithEmail: 'Số căn có Email',
    apartmentsWithPhone: 'Số căn có số điện thoại',
    apartmentsWithAppLinked: 'Số căn liên kết app',
    sendDebtReminderNotification: 'Gửi thông báo nhắc nợ',
    selectFeeNotificationDeliveryMethods: 'Chọn hình thức gửi thông báo',
    deliveryMethodEmail: 'Gửi qua Email',
    deliveryMethodAppPush: 'Gửi qua App Push',
    deliveryMethodEmailFeeHint: 'Gửi đến email chính trong thông tin căn hộ',
    deliveryMethodAppFeeHint: 'Chỉ gửi đến căn hộ đã liên kết tài khoản app di động',
    confirmSendNotification: 'Xác nhận gửi',
    notificationStaffName: 'Nhân viên thực hiện',
    appPushNotificationMethod: 'App Push',
    bothNotificationMethods: 'Email, App Push',
    apartmentsWithOutstandingFees: 'Số căn còn nợ phí',
    monthlyServiceFeeNotification: 'Thông báo phí dịch vụ hàng tháng',
    notificationTitle: 'Tiêu đề',
    notificationSentDate: 'Ngày gửi',
    notificationMethod: 'Hình thức',
    emailNotificationMethod: 'Email',
    quantity: 'Số lượng',
    noAddress: 'Chưa có địa chỉ',
    enabled: 'Bật',
    disabled: 'Tắt',
    selectBuildingForNotification: 'Chọn chung cư',
    selectBuildingToContinue: 'Chọn một chung cư để tiếp tục',
    selectBuildingToViewAndSendNotification: 'Vui lòng chọn một chung cư từ danh sách bên trái để xem thông tin chi tiết và gửi thông báo phí dịch vụ',
    buildingInfoSection: 'Thông tin chung cư',    
    serviceFeeDayText: 'Ngày chốt phí',
    autoSendEmailReminderText: 'Gửi email tự động',
    actionNotificationSection: 'Thao tác gửi thông báo',
    importantNoteTitle: 'Thông tin quan trọng',
    systemWillAutoGenerateText: 'Hệ thống sẽ tự động tạo hóa đơn phí dịch vụ cho',
    allApartmentsText: 'tất cả căn hộ',
    inBuildingText: 'trong chung cư',
    emailWillBeSentText: 'Email thông báo sẽ được gửi đến các căn hộ',
    haveEmailAddressText: 'có địa chỉ email',
    billingPeriodText: 'Kỳ thanh toán',
    operationCannotBeUndoneText: 'Thao tác này không thể hoàn tác sau khi thực hiện',
    successText: 'Thành công',
    failureText: 'Thất bại',
    // Toast Messages
    saveEmailSettingsGlobalSuccess: '✅ Lưu cài đặt email toàn cục thành công!',
    saveEmailSettingsPersonalSuccess: '✅ Lưu cài đặt email thành công cho tòa nhà {buildingName}!',
    savePaymentSettingsGlobalSuccess: '✅ Lưu cài đặt thanh toán toàn cục thành công!',
    savePaymentSettingsPersonalSuccess: '✅ Lưu cài đặt thanh toán thành công cho tòa nhà {buildingName}!',
    testEmailConnectionGlobalSuccess: '✅ Kiểm tra kết nối email toàn cục thành công!',
    testEmailConnectionPersonalSuccess: '✅ Kiểm tra kết nối email thành công cho tòa nhà {buildingName}!',
    deleteEmailSettingsSuccess: '✅ Xóa cài đặt email thành công!',
    deletePaymentSettingsSuccess: '✅ Xóa cài đặt thanh toán thành công!',
    errorSavingEmailSettings: '❌ Không thể lưu cài đặt email: {error}',
    errorSavingPaymentSettings: '❌ Không thể lưu cài đặt thanh toán: {error}',
    errorTestingEmailConnection: '❌ Không thể kiểm tra kết nối email: {error}',
    errorDeletingEmailSettings: '❌ Không thể xóa cài đặt email: {error}',
    errorDeletingPaymentSettings: '❌ Không thể xóa cài đặt thanh toán: {error}',
    // Export PDF Feature
    selectBuildingToExportPdf: 'Chọn chung cư để xuất file PDF',
    selectBillingPeriodToExport: 'Chọn kỳ hóa đơn để xuất',
    onlyExportOutstandingFees: 'Chỉ xuất file căn hộ còn nợ phí',
    emailToReceiveDownloadLink: 'Email nhận link download',
    exportPdf: 'XUẤT FILE PDF',
    exporting: 'Đang xuất...',
    exportHistory: 'Lịch sử xuất file',
    exportTime: 'Thời gian',
    exportStatus: 'Trạng thái',
    downloadLink: 'Link download',
    processingExport: 'Đang xử lý',
    completed: 'Hoàn thành',
    failed: 'Thất bại',
    noExportHistory: 'Chưa có lịch sử xuất file',
    pleaseSelectBuildingAndPeriod: 'Vui lòng chọn chung cư và kỳ hóa đơn',
    pleaseEnterEmailForDownload: 'Vui lòng nhập email',
    exportRequestSent: 'Yêu cầu xuất file đã được gửi thành công!',
    errorSubmittingExportRequest: 'Có lỗi xảy ra khi gửi yêu cầu xuất file',
    exportPdfTitle: 'Xuất file PDF phí dịch vụ',
    exportPdfDescription: 'Xuất tất cả hóa đơn phí dịch vụ ra định dạng PDF để in ấn',
    selectBuildingForExport: 'Chọn chung cư',
    enterEmailToReceiveLink: 'Nhập email nhận link download',
    // PDF Templates
    pdfTemplates: 'Mẫu PDF phí dịch vụ',
    pdfTemplateManagement: 'Quản lý mẫu PDF',
    addPdfTemplate: 'Thêm mẫu PDF',
    editPdfTemplate: 'Chỉnh sửa mẫu PDF',
    templateName: 'Tên mẫu',
    templateDescription: 'Mô tả mẫu',
    templateType: 'Loại mẫu',
    defaultTemplate: 'Mẫu mặc định',
    globalTemplate: 'Mẫu toàn cục',
    buildingTemplate: 'Mẫu chung cư',
    templateLayout: 'Bố cục mẫu',
    professionalLayout: 'Bố cục chuyên nghiệp',
    simpleLayout: 'Bố cục đơn giản',
    customLayout: 'Bố cục tùy chỉnh',
    headerSettings: 'Cài đặt tiêu đề',
    tableSettings: 'Cài đặt bảng',
    footerSettings: 'Cài đặt chân trang',
    showLogo: 'Hiển thị logo',
    showBorders: 'Hiển thị viền bảng',
    showPaymentInfo: 'Hiển thị thông tin thanh toán',
    showSignature: 'Hiển thị chữ ký',
    createDefaultTemplates: 'Tạo mẫu mặc định',
    qrSettings: 'Cài đặt QR',
    logoSettings: 'Cài đặt logo',
    logoSettingsGlobalHint: 'Logo toàn cục dùng làm mặc định trên trang đăng nhập và khi operator chưa cấu hình logo riêng.',
    logoSettingsOperatorHint: 'Logo operator hiển thị ở sidebar sau khi đăng nhập. Nếu chưa cấu hình, hệ thống dùng logo toàn cục của SUPERADMIN.',
    logoSettingsEffectiveTitle: 'Logo đang hiển thị',
    logoSettingsUsingOperator: 'Đang dùng logo operator.',
    logoSettingsUsingGlobalFallback: 'Đang dùng logo toàn cục (chưa có logo operator).',
    logoSettingsNoOwnYet: 'Chưa có logo riêng. Upload ảnh bên dưới hoặc để hệ thống dùng logo toàn cục.',
    logoSettingsUploadLabel: 'Logo hệ thống',
    logoSettingsUploadHint: 'PNG, JPG hoặc WEBP. Khuyến nghị nền trong suốt, tối đa 5MB.',
    logoSettingsSaved: 'Đã lưu logo.',
    logoSettingsSaveFailed: 'Không thể lưu logo.',
    logoSettingsDeleted: 'Đã xóa logo.',
    logoSettingsDeleteFailed: 'Không thể xóa logo.',
    confirmDeleteLogoSettings: 'Bạn có chắc chắn muốn xóa logo này?',
    qrPaymentTab: 'QR thanh toán',
    qrAppTab: 'QR tải app',
    qrSelectBank: 'Chọn ngân hàng',
    qrBankAccount: 'Số tài khoản',
    qrAccountName: 'Tên tài khoản',
    qrAmountOptional: 'Số tiền (tùy chọn)',
    qrDescriptionOptional: 'Nội dung (tùy chọn)',
    qrGenerateSample: 'Tạo mẫu QR',
    qrGenerateAppImages: 'Tạo & lưu QR',
    qrAndroidUrl: 'Link Android',
    qrIosUrl: 'Link iOS',
    qrSavedSuccess: 'Đã lưu cài đặt QR',
    qrAppGeneratedSuccess: 'Đã tạo và lưu QR tải app',
    qrAppSavedSuccess: 'Đã lưu link QR tải app',
    qrAppClearedSuccess: 'Đã xóa QR tải app',
    qrClearAppQr: 'Xóa QR tải app',
    qrAppUsingGlobalDefaults:
      'Chưa có cài đặt QR tải app riêng cho phạm vi này. Thông báo phí sẽ dùng cài đặt chung (nếu có). Nhập link và bấm Lưu hoặc Tạo & lưu QR để tạo cài đặt riêng.',
    qrClearPaymentQr: 'Xóa QR thanh toán',
    qrPaymentClearedSuccess: 'Đã xóa QR thanh toán',
    qrPaymentUsingGlobalDefaults:
      'Chưa có cài đặt QR thanh toán riêng cho phạm vi này. Thông báo phí sẽ dùng cài đặt chung (nếu có). Nhập thông tin ngân hàng và bấm Lưu để tạo cài đặt riêng.',
    noTemplatesYet: 'Chưa có mẫu PDF nào',
    addFirstTemplate: 'Thêm mẫu PDF đầu tiên',
    templateCreatedSuccess: 'Tạo mẫu PDF thành công!',
    templateUpdatedSuccess: 'Cập nhật mẫu PDF thành công!',
    templateDeletedSuccess: 'Xóa mẫu PDF thành công!',
    defaultTemplatesCreatedSuccess: 'Tạo mẫu mặc định thành công!',
    errorCreatingTemplate: 'Lỗi khi tạo mẫu PDF',
    errorUpdatingTemplate: 'Lỗi khi cập nhật mẫu PDF',
    errorDeletingTemplate: 'Lỗi khi xóa mẫu PDF',
    errorLoadingTemplates: 'Lỗi khi tải danh sách mẫu PDF',
    confirmDeleteTemplate: 'Bạn có chắc chắn muốn xóa mẫu PDF này?',
    defaultTemplateWillBeReassigned: 'Mẫu mặc định khác sẽ được tự động gán nếu có.',
    setAsDefault: 'Đặt mặc định',
    templateSetAsDefaultSuccess: 'Đã đặt làm mẫu mặc định',
    cannotDeleteDefaultTemplate: 'Không thể xóa mẫu mặc định',
    pleaseEnterTemplateName: 'Vui lòng nhập tên mẫu',
    enterTemplateName: 'Nhập tên mẫu PDF',
    enterTemplateDescription: 'Nhập mô tả mẫu (tùy chọn)',
    selectTemplateType: 'Chọn loại mẫu',
    serviceFeeTemplate: 'Mẫu phí dịch vụ',
    feeNoticeTemplate: 'Thông báo phí',
    receiptTemplate: 'Phiếu thu',
    invoiceTemplate: 'Mẫu hóa đơn',
    createNewPdfTemplate: 'Tạo mẫu mới',
    basicInformation: 'Thông tin cơ bản',
    fieldsAndLayout: 'Trường & Bố cục',
    stylingAndColors: 'Kiểu dáng & Màu sắc',
    showBuildingInfo: 'Hiển thị thông tin tòa nhà',
    bilingualHeader: 'Song ngữ (Việt/Anh)',
    titleLabel: 'Tiêu đề',
    titleEnLabel: 'Tiêu đề (Tiếng Anh)',
    managementCompany: 'Công ty quản lý',
    managementCompanyEn: 'Công ty quản lý (Tiếng Anh)',
    logoPathOptional: 'Đường dẫn logo (tùy chọn)',
    templateLogoPathHint: 'Logo công ty hiển thị trên PDF (góc trái header). Có thể upload ảnh hoặc nhập đường dẫn/URL.',
    buildingLogoPathOptional: 'Đường dẫn logo tòa nhà (dự phòng)',
    templateBuildingLogoPathHint: 'Cấu hình logo từng tòa nhà tại Chung cư → Sửa. Trường này chỉ dùng khi tòa nhà chưa có logo.',
    hideZeroSections: 'Ẩn mục có số tiền bằng 0',
    customerInformation: 'Thông tin khách hàng',
    showCustomerInfoBox: 'Hiển thị khung thông tin khách hàng',
    customerFields: 'Trường khách hàng',
    alternateRowColors: 'Xen kẽ màu dòng',
    showVatColumns: 'Hiển thị cột VAT',
    tableHeaders: 'Tiêu đề cột bảng',
    addColumn: 'Thêm cột',
    showBankInfo: 'Hiển thị thông tin ngân hàng',
    showSignatureFields: 'Hiển thị vùng chữ ký',
    showPaymentQr: 'Hiển thị QR thanh toán',
    showAppQr: 'Hiển thị QR tải app',
    showNoticeText: 'Hiển thị nội dung lưu ý',
    showSignatureBlocks: 'Hiển thị khối chữ ký (Người lập phiếu / Người nộp)',
    defaultReason: 'Lý do thu mặc định',
    hotlineLabel: 'Hotline',
    officeHoursVi: 'Giờ làm việc (VI)',
    noticeTextVi: 'Nội dung lưu ý (VI)',
    noticeTextEn: 'Nội dung lưu ý (EN)',
    layoutLabel: 'Bố cục',
    primaryColor: 'Màu chính',
    secondaryColor: 'Màu phụ',
    accentColor: 'Màu nhấn',
    previewLabel: 'Xem trước',
    generatePreview: 'Tạo xem trước',
    generatingPreview: 'Đang tạo...',
    clickGeneratePreview: 'Nhấn "Tạo xem trước" để xem mẫu',
    saveTemplateFirstPreview: 'Lưu mẫu trước để tạo xem trước',
    updateTemplate: 'Cập nhật mẫu',
    createTemplate: 'Tạo mẫu',
    saveTemplateFirstForPreview: 'Vui lòng lưu mẫu trước khi xem trước',
    failedGeneratePreview: 'Không thể tạo xem trước',
    failedSaveTemplate: 'Không thể lưu mẫu',
    optionalLeaveBlank: 'Tùy chọn — để trống nếu không dùng',
    pdfCustomerFieldName: 'Tên',
    pdfCustomerFieldAddress: 'Địa chỉ',
    pdfCustomerFieldContract: 'Hợp đồng',
    pdfCustomerFieldTaxCode: 'Mã số thuế',
    pdfCustomerFieldPhone: 'Điện thoại',
    pdfCustomerFieldEmail: 'Email',
    layoutFeeNotice: 'Thông báo phí (Fee Notice)',
    layoutPaymentReceipt: 'Phiếu thu đơn giản (Receipt Voucher)',
    layoutPaymentReceiptDetailed: 'Phiếu thu chi tiết (giống Thông báo phí)',
    layoutProfessional: 'Chuyên nghiệp (Debit Note)',
    layoutSimple: 'Đơn giản (Simple)',
    layoutCustom: 'Tùy chỉnh (Custom)',
    statusPaid: 'Đã thanh toán',
    statusOverdue: 'Quá hạn',
    statusUnpaid: 'Chưa thanh toán',
    
    // Task Management
    tasksSection: 'CÔNG VIỆC',
    addTask: 'Thêm công việc',
    taskList: 'Danh sách công việc',
    allTasks: 'Tất cả',
    incompleteTasks: 'Chưa hoàn thành',
    completedTasks: 'Đã hoàn thành',
    taskAssignment: 'Đối tượng giao việc',
    taskContent: 'Nội dung công việc',
    assignToStaff: 'Người thực hiện',
    dueDate: 'Hạn hoàn thành',
    taskTitle: 'Tiêu đề',
    taskDescription: 'Nội dung chi tiết',
    taskAttachments: 'File đính kèm',
    taskAttachmentsNote: 'image, pdf, word, excel. Tối đa 2 files',
    createTaskButton: 'TẠO CÔNG VIỆC',
    taskNumber: '#',
    taskName: 'Công việc',
    createdDate: 'Ngày tạo',
    completedDate: 'Ngày hoàn thành',
    taskStatus: 'Trạng thái',
    lastUpdated: 'Lần cập nhật cuối',
    taskStatusInProgress: 'Đang thực hiện',
    taskStatusPending: 'Chưa thực hiện',
    taskStatusCompleted: 'Hoàn thành',
    taskRequirements: 'Nội dung yêu cầu',
    taskUpdates: 'Cập nhật, phản hồi',
    confirmTaskCompletion: 'Xác nhận đã thực hiện xong',
    updateTaskButton: 'LƯU THÔNG TIN',
    // Task form validation
    pleaseSelectStaff: 'Vui lòng chọn người thực hiện',
    pleaseEnterDeadline: 'Vui lòng chọn hạn hoàn thành',
    pleaseEnterTaskTitle: 'Vui lòng nhập tiêu đề công việc',
    pleaseEnterTaskDescription: 'Vui lòng nhập nội dung chi tiết',
    selectStaffPlaceholder: 'Chọn người thực hiện',
    enterTaskTitle: 'Nhập tiêu đề công việc',
    enterTaskDescription: 'Nhập nội dung chi tiết công việc',
    enterTaskUpdate: 'Nhập cập nhật hoặc phản hồi',
    // Task success/error messages
    taskCreatedSuccess: 'Đã tạo công việc thành công!',
    taskUpdatedSuccess: 'Đã cập nhật công việc thành công!',
    errorCreatingTask: 'Có lỗi xảy ra khi tạo công việc',
    errorUpdatingTask: 'Có lỗi xảy ra khi cập nhật công việc',
    errorLoadingTasks: 'Có lỗi xảy ra khi tải danh sách công việc',
    errorLoadingTaskDetails: 'Có lỗi xảy ra khi tải chi tiết công việc',
    errorLoadingStaff: 'Có lỗi xảy ra khi tải danh sách nhân viên',
    noTasksFound: 'Không tìm thấy công việc nào',
    noTasksMessage: 'Chưa có công việc nào được tạo',
    createFirstTask: 'Tạo công việc đầu tiên',
    backToTaskList: 'Quay lại danh sách công việc',
    // Task Details - New translations only
    taskDetails: 'Chi tiết công việc',
    viewAndUpdateTaskDetails: 'Xem và cập nhật thông tin chi tiết công việc',
    updatesAndFeedback: 'Cập nhật & phản hồi',
    addUpdate: 'Thêm cập nhật',
    enterUpdateComment: 'Nhập nội dung cập nhật, ghi chú tiến độ...',
    updateTask: 'Cập nhật công việc',
    taskHistory: 'Lịch sử công việc',
    noUpdatesYet: 'Chưa có cập nhật nào',
    addFirstUpdate: 'Hãy thêm cập nhật đầu tiên để theo dõi tiến độ',
    markedAsCompleted: 'Đã đánh dấu hoàn thành',
    unknown: 'Không rõ',
    taskNotFound: 'Không tìm thấy công việc',
    taskMayBeDeleted: 'Công việc có thể đã bị xóa hoặc không tồn tại',
    errorLoadingTask: 'Có lỗi xảy ra khi tải công việc',
    taskUpdatedSuccessfully: 'Cập nhật công việc thành công',
    assignedTo: 'Người thực hiện',
    createdBy: 'Người tạo',
    markAsCompleted: 'Xác nhận đã thực hiện xong.',
    // Task details - additional keys
    attachFiles: 'Đính kèm file',
    uploadFiles: 'Tải file lên',
    orDragAndDrop: 'Hoặc kéo thả',
    maxFileSize: 'Tối đa 10MB',
    confirmInProgress: 'Xác nhận đang thực hiện',
    confirmCompleted: 'Xác nhận đã thực hiện xong',
    taskPriority: 'Mức độ ưu tiên',
    taskPriorityLow: 'Thấp',
    taskPriorityMedium: 'Trung bình',
    taskPriorityHigh: 'Cao',
    taskPriorityUrgent: 'Khẩn cấp',
    openInNewTab: 'Mở trong tab mới',
    download: 'Tải về',
    
    // Feedback Management
    customerCareSection: 'CHĂM SÓC KHÁCH HÀNG',
    feedbackManagement: 'Phản ánh',
    feedbackList: 'Danh sách phản ánh',
    feedbackCategoryConfig: 'Cấu hình phân loại phản ánh',
    addFeedback: 'Thêm phản ánh',
    addFeedbackCategory: 'Thêm phân loại phản ánh',
    editFeedbackCategory: 'Sửa phân loại phản ánh',
    feedbackCategoryName: 'Tên phân loại',
    feedbackCategoryNameEn: 'Tên tiếng Anh',
    feedbackCategoryCode: 'Mã phân loại',
    feedbackId: 'Mã phản ánh',
    feedbackContent: 'Nội dung',
    feedbackApartment: 'Căn hộ',
    feedbackResident: 'Cư dân',
    feedbackTags: 'Nhãn',
    feedbackCategory: 'Loại phản ánh',
    feedbackDeadline: 'Thời hạn',
    feedbackConfirmedDate: 'Ngày duyệt',
    feedbackConfirmedBy: 'Người duyệt',
    feedbackCompletedDate: 'Ngày hoàn thành',
    feedbackStatus: 'Trạng thái',
    feedbackPriority: 'Mức độ ưu tiên',
    feedbackActions: 'Hành động',
    feedbackMessages: 'Tin nhắn trao đổi',
    feedbackDetails: 'Chi tiết phản ánh',
    
    // Feedback Status
    feedbackStatusPendingConfirmation: 'Chờ xác nhận',
    feedbackStatusConfirmed: 'Đã xác nhận',
    feedbackStatusInProgress: 'Đang xử lý',
    feedbackStatusCompleted: 'Hoàn thành',
    feedbackStatusRejected: 'Từ chối',
    
    // Feedback Priority
    feedbackPriorityLow: 'Thấp',
    feedbackPriorityMedium: 'Trung bình',
    feedbackPriorityHigh: 'Cao',
    feedbackPriorityUrgent: 'Khẩn cấp',
    
    // Feedback Actions
    confirmFeedback: 'Xác nhận',
    completeFeedback: 'Hoàn thành',
    rejectFeedback: 'Từ chối',
    viewFeedbackDetails: 'Xem chi tiết',
    addMessage: 'Thêm tin nhắn',
    
    // Feedback Form
    selectBuildingToViewFeedbacks: 'Vui lòng chọn chung cư để xem danh sách phản hồi',
    selectApartment: 'Chọn căn hộ',
    selectFeedbackCategory: 'Chọn loại phản ánh',
    enterFeedbackContent: 'Nhập nội dung phản ánh',
    enterFeedbackTags: 'Nhập nhãn (cách nhau bởi dấu phẩy)',
    selectFeedbackPriority: 'Chọn mức độ ưu tiên',
    selectDeadline: 'Chọn thời hạn xử lý',
    enterCategoryName: 'Nhập tên phân loại',
    enterCategoryNameEn: 'Nhập tên tiếng Anh',
    enterCategoryCode: 'Nhập mã phân loại',
    
    // Feedback Messages
    feedbackCreatedSuccess: 'Tạo phản ánh thành công!',
    feedbackUpdatedSuccess: 'Cập nhật phản ánh thành công!',
    feedbackConfirmedSuccess: 'Xác nhận phản ánh thành công!',
    feedbackCompletedSuccess: 'Hoàn thành phản ánh thành công!',
    feedbackCategoryCreatedSuccess: 'Tạo phân loại phản ánh thành công!',
    feedbackCategoryUpdatedSuccess: 'Cập nhật phân loại phản ánh thành công!',
    feedbackCategoryDeletedSuccess: 'Xóa phân loại phản ánh thành công!',
    defaultFeedbackCategoriesCreatedSuccess: 'Tạo phân loại phản ánh mặc định thành công!',
    createDefaultFeedbackCategories: 'Tạo phân loại mặc định',
    confirmCreateDefaultFeedbackCategories: 'Bạn có chắc muốn tạo các phân loại phản ánh mặc định cho chung cư này?',
    errorCreatingDefaultFeedbackCategories: 'Lỗi khi tạo phân loại phản ánh mặc định',
    feedbackMessageAddedSuccess: 'Thêm tin nhắn thành công!',
    feedbackStatistics: 'Thống kê CSKH',
    feedbackResponsibleStaff: 'Người phụ trách',
    feedbackCompletedBy: 'Người hoàn thành',
    feedbackProcessingTime: 'Thời gian xử lý',
    feedbackStatusCancelled: 'Đã hủy',
    generalInfoTab: 'Thông tin chung',
    processingWorkflowTab: 'Quy trình xử lý',
    workflowStepName: 'Tên bước',
    workflowStatusDescription: 'Mô tả trạng thái',
    workflowSystemStatus: 'Trạng thái hệ thống',
    workflowDepartment: 'Phòng ban',
    workflowAssignees: 'Người phụ trách',
    workflowSla: 'SLA',
    workflowSlaReminder: 'Nhắc SLA',
    addWorkflowStep: 'Thêm bước',
    selectStaff: 'Chọn nhân viên',
    workflowSavedSuccess: 'Lưu quy trình xử lý thành công!',
    errorSavingWorkflow: 'Lỗi khi lưu quy trình xử lý',
    slaUnitMinutes: 'Phút',
    slaUnitHours: 'Giờ',
    slaUnitDays: 'Ngày',
    cskhDashboard: 'Thống kê CSKH',
    currentOverview: 'Tổng quan hiện tại',
    performanceInPeriod: 'Hiệu suất trong kỳ',
    pendingBacklog: 'Đang tồn đọng',
    overdueSla: 'Tồn quá hạn SLA',
    createdInPeriod: 'Đã tạo trong kỳ',
    closedByCreationPeriod: 'Đã đóng theo kỳ tạo',
    completionRate: 'Tỷ lệ hoàn thành',
    closedInPeriod: 'Đã đóng trong kỳ',
    slaComplianceRate: 'Tỷ lệ đúng SLA',
    newRequests: 'Yêu cầu mới',
    feedbackProcessingMetric: 'Đang xử lý',
    paused: 'Đang tạm dừng',
    slaTrend: 'Xu hướng đúng SLA',
    openTicketAge: 'Tuổi việc đang mở',
    slaOverview: 'Tổng quan SLA',
    processingTrend: 'Xu hướng xử lý',
    requestsByCategory: 'Phân loại yêu cầu',
    departmentPerformance: 'Hiệu suất theo phòng ban',
    staffPerformance: 'Hiệu suất theo cá nhân (Top 5)',
    averageProcessingTimes: 'Thời gian xử lý trung bình',
    requestsByChannel: 'Yêu cầu theo kênh',
    qualitySatisfaction: 'Chất lượng & Hài lòng',
    slaAlerts: 'Cảnh báo SLA',
    onTimeSla: 'Đúng SLA',
    slaViolations: 'Vi phạm SLA',
    satisfactionRate: 'Tỷ lệ hài lòng',
    viewNow: 'Xem ngay',
    violatingSla: 'Đang vi phạm SLA',
    approachingSla: 'Sắp vi phạm SLA',
    firstResponseTime: 'Thời gian phản hồi đầu tiên',
    averageProcessingTime: 'Thời gian xử lý trung bình',
    closeRequestTime: 'Thời gian đóng yêu cầu',
    averageSlaViolationTime: 'Thời gian vi phạm SLA TB',
    onTime: 'Đúng hạn',
    allDepartments: 'Tất cả phòng ban',
    allStaff: 'Tất cả nhân viên',
    
    // Feedback Errors
    errorCreatingFeedback: 'Lỗi khi tạo phản ánh',
    errorUpdatingFeedback: 'Lỗi khi cập nhật phản ánh',
    errorLoadingFeedbacks: 'Lỗi khi tải danh sách phản ánh',
    errorLoadingFeedbackDetails: 'Lỗi khi tải chi tiết phản ánh',
    errorCreatingFeedbackCategory: 'Lỗi khi tạo phân loại phản ánh',
    errorUpdatingFeedbackCategory: 'Lỗi khi cập nhật phân loại phản ánh',
    errorLoadingFeedbackCategories: 'Lỗi khi tải danh sách phân loại phản ánh',
    errorAddingFeedbackMessage: 'Lỗi khi thêm tin nhắn',
    
    // Feedback Validation
    pleaseSelectApartment: 'Vui lòng chọn căn hộ',
    pleaseSelectFeedbackCategory: 'Vui lòng chọn loại phản ánh',
    pleaseEnterFeedbackContent: 'Vui lòng nhập nội dung phản ánh',
    pleaseEnterCategoryName: 'Vui lòng nhập tên phân loại',
    pleaseEnterCategoryCode: 'Vui lòng nhập mã phân loại',
    pleaseEnterMessageContent: 'Vui lòng nhập nội dung tin nhắn',
    
    // Feedback Confirmation
    confirmDeleteFeedback: 'Bạn có chắc chắn muốn xóa phản ánh này?',
    confirmDeleteFeedbackCategory: 'Bạn có chắc chắn muốn xóa phân loại phản ánh này?',
    confirmCompleteFeedback: 'Bạn có chắc chắn muốn đánh dấu phản ánh này là hoàn thành?',
    
    // Feedback Statistics
    filter: 'Bộ lọc',
    feedbackExchange: 'Trao đổi',
    feedbackResidentChat: 'Cư dân',
    feedbackInternalChat: 'Nội bộ',
    feedbackInternalChatHint: 'Tin nhắn nội bộ chỉ hiển thị với nhân viên được phân công xử lý phản ánh.',
    noFeedbackMessages: 'Chưa có tin nhắn nào',
    feedbackMessagePlaceholder: 'Nhập tin nhắn...',
    feedbackRefresh: 'Làm mới',
    totalFeedbacks: 'Tổng số phản ánh',
    pendingFeedbacks: 'Chờ xác nhận',
    confirmedFeedbacks: 'Đã xác nhận',
    inProgressFeedbacks: 'Đang xử lý',
    completedFeedbacks: 'Hoàn thành',
    allCategories: 'Tất cả loại phản ánh',
    allPriorities: 'Tất cả mức độ ưu tiên',
    allApartmentGroups: 'Tất cả nhóm căn hộ',
    allAssignees: 'Tất cả người phụ trách',
    exportData: 'Xuất dữ liệu',
    exportDataSuccess: 'Đã xuất dữ liệu thành công',
    chooseFiles: 'Chọn tệp',
    noFileChosen: 'Chưa chọn tệp nào',
    searchMinCharsHint: 'Nhập ít nhất 2 ký tự để tìm kiếm',
    searching: 'Đang tìm...',
    noSearchResults: 'Không tìm thấy kết quả',
    searchApartmentGroupPlaceholder: 'Tìm nhóm căn hộ...',
    searchApartmentPlaceholder: 'Tìm mã căn hộ hoặc tên chủ hộ...',
    searchAssigneePlaceholder: 'Tìm người phụ trách...',
    noFeedbacks: 'Không có phản ánh nào',
    noFeedbackCategories: 'Chưa có phân loại phản ánh',
    
    // Feedback Tags
    securityTag: 'Bảo vệ',
    operationTag: 'Vận hành',
    landscapeTag: 'Cảnh quan',
    maintenanceTag: 'Bảo trì',
    cleaningTag: 'Vệ sinh',
    otherTag: 'Khác',
    
    // Chat System
    'Chat is locked': 'Cuộc trò chuyện đã bị khóa',
    'Chat is locked. Please unlock it first to send messages.': 'Cuộc trò chuyện đã bị khóa. Vui lòng mở khóa trước khi gửi tin nhắn.',
    'No one can send messages until the chat is unlocked. Only staff can unlock it.': 'Không ai có thể gửi tin nhắn cho đến khi cuộc trò chuyện được mở khóa. Chỉ có nhân viên mới có thể mở khóa.',
    'Type a message...': 'Nhập tin nhắn...',
    'Add description (optional)...': 'Thêm mô tả (tùy chọn)...',
    'Attach file': 'Đính kèm tệp',
    'Send message': 'Gửi tin nhắn',
    
    // Apartment Import
    importApartments: 'Nhập danh sách căn hộ',
    exportApartments: 'Xuất danh sách căn hộ',
    downloadSampleFile: 'Tải file mẫu',
    step1DownloadSample: 'Bước 1: Tải file mẫu',
    step2UploadFile: 'Bước 2: Tải lên file của bạn',
    requiredFields: 'Các trường bắt buộc',
    uploadYourFile: 'Tải lên file của bạn',
    clickToSelectFile: 'Click để chọn file hoặc kéo và thả',
    csvExcelSupported: 'CSV, Excel được hỗ trợ',
    excelRecommended: 'Excel (.xlsx, .xls) được khuyến nghị',
    csvAlsoSupported: 'CSV cũng được hỗ trợ',
    dragAndDrop: 'hoặc kéo và thả',
    fileSelected: 'File đã chọn',
    noFileSelected: 'Chưa chọn file',
    pleaseSelectFile: 'Vui lòng chọn file để nhập',
    importSuccess: 'Nhập thành công',
    importNewCount: 'Mới',
    importUpdatedCount: 'Cập nhật',
    importSkippedCount: 'Trùng trong file',
    importMissingCount: 'Thiếu trong file',
    importRenamedCount: 'Đổi mã',
    importMissingCodes: 'Căn hộ có trong DB nhưng không có trong file',
    importExistingCount: 'Căn hộ trong DB',
    importFileApartmentCount: 'Mã căn trong file',
    importErrorSummary: 'Lỗi theo loại',
    importErrorRows: 'dòng',
    importFailedSummary: 'Import thất bại — xem tóm tắt bên dưới',
    importSkippedCodes: 'Mã trùng trong file',
    apartmentListTab: 'Danh sách căn hộ',
    apartmentImportHistoryTab: 'Lịch sử import',
    importHistoryFileName: 'Tên file import',
    importHistoryDate: 'Thời gian',
    importHistoryStaff: 'Nhân viên',
    importHistoryTotalRows: 'Số dòng',
    importHistoryMissing: 'Thiếu',
    importHistoryStatus: 'Trạng thái',
    importHistoryNoData: 'Chưa có lịch sử hoạt động',
    importHistoryDetails: 'Chi tiết',
    apartmentImportRevert: 'Hoàn tác',
    apartmentImportReverted: 'Đã hoàn tác',
    apartmentImportRevertConfirm:
      'Hoàn tác số lượng phí đã cập nhật từ file "{fileName}"?\n\nChỉ khôi phục số lượng phí (Phí sạc, gửi xe, …) — không xóa căn hộ.',
    apartmentImportRevertSuccess: 'Đã hoàn tác {count} thay đổi số lượng phí.',
    apartmentImportRevertUnavailable: 'Lần import cũ không hỗ trợ hoàn tác — sửa thủ công hoặc import lại file đúng.',
    apartmentImportSummary: 'Cập nhật {updated} căn, {quantities} số lượng phí',
    activityHistoryKind: 'Loại',
    activityHistoryDescription: 'Mô tả',
    activityHistoryImport: 'Import',
    activityHistoryUpdate: 'Cập nhật',
    activityHistoryDelete: 'Xóa',
    activityHistoryBulkDelete: 'Xóa hàng loạt',
    activityHistoryDeletedCodes: 'Đã xóa',
    activityHistorySkippedApartments: 'Bỏ qua',
    selectAllOnPage: 'Chọn trang',
    deleteSelectedApartments: 'Xóa đã chọn',
    confirmBulkDeleteApartments: 'Xóa {count} căn hộ đã chọn? Chỉ xóa được căn hộ không có dữ liệu liên kết.',
    bulkDeleteResultSummary: 'Đã xóa {deleted} căn hộ, bỏ qua {skipped} căn hộ.',
    importSuccessStatus: 'Hoàn tất',
    importPartialStatus: 'Cảnh báo',
    importFailedStatus: 'Thất bại',
    importFailed: 'Nhập thất bại',
    importLoading: 'Đang nhập...',
    importError: 'Lỗi nhập',
    importSuccessMessage: 'Nhập danh sách căn hộ thành công!',
    importErrorMessage: 'Không thể nhập danh sách căn hộ. Vui lòng kiểm tra định dạng file.',
    fileFormatError: 'Định dạng file không hợp lệ. Vui lòng sử dụng file CSV hoặc Excel.',
    existingCodesSkipped: 'mã đã tồn tại đã được bỏ qua',
    existingCodesSkippedMessage: 'mã đã tồn tại đã được bỏ qua',
    sampleFileDescription: 'Tải file mẫu Excel bên dưới để xem định dạng yêu cầu. Chỉnh sửa với dữ liệu căn hộ của bạn và lưu dưới dạng Excel (.xlsx) để có kết quả tốt nhất.',
    requiredFieldsDescription: 'Các trường bắt buộc được đánh dấu bằng dấu sao đỏ. Các trường khác là tùy chọn.',
    fieldCode: 'mã căn ngắn, duy nhất (VD: A-0.01) — không phải tên căn hộ',
    fieldApartmentName: 'tên căn hộ hiển thị (tùy chọn)',
    importApartmentParkingQuantityHint: 'Thêm cột số lượng theo tên đầy đủ danh mục phí (hoặc mã phí, VD: SAC001) — gửi xe, sạc xe điện, phí nhập thủ công theo căn hộ.',
    fieldOldCode: 'mã căn cũ trong hệ thống — dùng khi đổi mã căn (VD: A-0.01 → SGAM-DA-A001)',
    fieldOccupancyStatus: 'trạng thái căn hộ (Chủ nhà đang ở / Hiện đang cho thuê / Căn hộ cho thuê / Căn hộ bán)',
    fieldHandoverDate: 'ngày bàn giao dd/mm/yyyy (để trống nếu chưa bàn giao)',
    fieldPeCode: 'mã PE (tùy chọn)',
    fieldPopulationCount: 'số nhân khẩu (tùy chọn)',
    fieldOwnerName: 'tên chủ sở hữu',
    fieldOwnerNameOptional: 'tên chủ sở hữu (để trống nếu chưa bàn giao)',
    fieldOwnerPhone: 'số điện thoại chủ sở hữu (tùy chọn)',
    fieldOwnerEmail: 'email thông báo phí, nhiều email cách nhau bởi dấu ; (tùy chọn)',
    fieldInvoiceEmail: 'email nhận hóa đơn VAT, nhiều email cách nhau bởi dấu ; (tùy chọn)',
    fieldAddress: 'địa chỉ căn hộ (tùy chọn)',
    fieldArea: 'diện tích tính bằng mét vuông (tùy chọn)',
    fieldCustomerCode: 'mã khách hàng (tùy chọn)',
    fieldTaxCode: 'mã số thuế (tùy chọn)',
    fieldHasVatInvoice: 'có hóa đơn VAT - Có/Không hoặc true/false (tùy chọn)',
    fieldNotes: 'ghi chú bổ sung (tùy chọn)',
    fieldApartmentGroup: 'nhóm căn hộ - tên nhóm trong chung cư đã chọn (tùy chọn)',
    fieldUsageType: 'loại sử dụng - Căn hộ/TM (tùy chọn)',
    fieldRegisteredQuotaCount: 'số lượng đăng ký định mức nước (tùy chọn)',
    apply: 'Áp dụng',
    clear: 'Xóa',
  },
  en: {
    addRoleTitle: 'Add Permission Group',
    generalInfo: 'General Information',
    applyBuildings: 'Applicable Buildings',
    allBuildings: 'All buildings',
    selectBuildings: 'Select from list below',
    select: 'Select',
    building: 'Building',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    permissionGroups: 'Permission Groups',
    addPermissionGroup: 'Add Permission Group',
    groupName: 'Group Name',
    description: 'Description',
    userCount: 'User Count',
    // Account Management
    accounts: 'ACCOUNTS',
    addAccount: 'Add Account',
    accountList: 'Account List',
    accountManagement: 'Account Management',
    permissions: 'Permissions',
    functions: 'Functions',
    functionCategory: 'Function Category',
    functionCategories: 'Function Categories',
    addFunctionCategory: 'Add Function Category',
    editFunctionCategory: 'Edit Function Category',
    functionCategoryName: 'Function Category Name',
    functionCategoryDescription: 'Function Category Description',
    functionCategoryIcon: 'Function Category Icon',
    functionCategoryOrder: 'Menu Order',
    createDefaultFunctionCategories: 'Create Default Function Categories',
    functionCategoriesUsingTemplate: 'Using the default categories from Superadmin. When you rearrange or edit, a separate copy will be created for this operator.',
    manageFunctionCategories: 'Manage system function categories/menus',
    noFunctionCategories: 'No Function Categories',
    noFunctionCategoriesHelp: 'Start by creating default function categories or adding new ones',
    functionCategoryCreatedSuccess: 'Function category created successfully!',
    functionCategoryUpdatedSuccess: 'Function category updated successfully!',
    functionCategoryDeletedSuccess: 'Function category deleted successfully!',
    defaultFunctionCategoriesCreated: 'Default function categories created successfully!',
    errorLoadingFunctionCategories: 'Error loading function categories',
    errorCreatingFunctionCategory: 'Error creating function category',
    errorUpdatingFunctionCategory: 'Error updating function category',
    errorDeletingFunctionCategory: 'Error deleting function category',
    errorCreatingDefaultFunctionCategories: 'Error creating default function categories',
    confirmDeleteFunctionCategory: 'Are you sure you want to delete this function category?',
    enterFunctionCategoryName: 'Enter function category name',
    enterFunctionCategoryCode: 'Enter function category code (e.g., MAIN_MANAGEMENT)',
    selectFunctionCategory: 'Select function category',
    viewFunctionsInCategory: 'View functions in category',
    functionsInCategory: 'functions in category',
    categoryDescription: 'System Function Categories',
    functionCategoryCode: 'Function Category Code',
    exportFunctionCategories: 'Export Function Categories',
    importFunctionCategories: 'Import Function Categories',
    exportFunctionCategoriesSuccess: 'Function categories exported successfully',
    importFunctionCategoriesHint: 'Upload a JSON file exported from another operator to copy function category configurations.',
    importFunctionCategoriesModeSkip: 'Skip existing category codes',
    importFunctionCategoriesModeReplace: 'Update if category code already exists',
    functionCategoryImportJsonOnly: 'Only JSON files (.json) exported from the system are supported',
    missingFunctionCodes: 'Function codes not found in this system',
    addExistingFunction: 'Add function',
    addExistingFunctions: 'Add functions to category',
    selectFunctionsToAdd: 'Select functions to add',
    noFunctionsInCategory: 'No functions in this category yet',
    dragToReorder: 'Drag to reorder',
    saveOrder: 'Save order',
    orderSaved: 'Order saved successfully',
    removeFromCategory: 'Remove from category',
    functionsPreview: 'Functions in category',
    allFunctionsAssigned: 'All functions are already assigned to categories',
    manageCategoryFunctions: 'Manage functions in category',
    currentCategory: 'Current category',
    unsavedOrderChanges: 'Unsaved order changes',
    hideFromMenu: 'Hide from menu',
    showInMenu: 'Show in menu',
    hideCategoryFromMenu: 'Hide from sidebar menu',
    showCategoryInMenu: 'Show in sidebar menu',
    cannotDeleteCategoryWithFunctions: 'Cannot delete a category that still has functions. Remove functions first or disable the category to hide it from the menu.',
    categoryHiddenFromMenuHint: 'Disabled categories are hidden from the left sidebar menu',
    selectCategoryIcon: 'Select icon',
    // Function Category Codes (for sidebar localization)
    MAIN_MANAGEMENT: 'MAIN MANAGEMENT',
    SERVICE_FEES: 'SERVICE FEES',
    INCOME_EXPENSE_MANAGEMENT: 'INCOME & EXPENDITURE',
    ACCOUNT_MANAGEMENT: 'ACCOUNT MANAGEMENT',
    BUILDING_MANAGEMENT: 'BUILDING MANAGEMENT',
    APARTMENT_MANAGEMENT: 'APARTMENT MANAGEMENT',
    TASK_MANAGEMENT: 'TASK MANAGEMENT',
    BUILDING_UTILITIES: 'BUILDING UTILITIES',
    BUILDING_SERVICES: 'BUILDING SERVICES',
    CUSTOMER_CARE: 'CUSTOMER CARE',
    SYSTEM_UTILITIES: 'SYSTEM UTILITIES',
    SYSTEM_SETTINGS: 'SYSTEM SETTINGS',
    FUNCTION_CATEGORIES: 'Function Categories',
    FUNCTIONS: 'Functions',
    SETTINGS: 'Settings',
    addFunction: 'Add Function',
    functionList: 'Function List',
    mainManagement: 'Main Management',
    DASHBOARD: 'Dashboard',
    functionName: 'Function Name',
    functionCode: 'Function Code',
    functionRoute: 'Function Route',
    functionIcon: 'Function Icon',
    menuOrder: 'Menu Order',
    isActive: 'Active',
    status: 'Status',
    editFunction: 'Edit Function',
    updateFunction: 'Update Function',
    back: 'Back',
    // Error messages and alerts
    errorLoadingFunctions: 'Error occurred while loading function list',
    errorToggleStatus: 'Error occurred while changing status',
    errorDeleteFunction: 'Error occurred while deleting function',
    errorSeedFunctions: 'Error occurred while creating default functions',
    confirmDelete: 'Are you sure you want to delete this function?',
    seedSuccessMessage: 'Default functions created successfully!',
    tryAgain: 'Try again',
    // Table headers and labels
    stt: 'No.',
    actions: 'Actions',
    active: 'Active',
    yes: 'Yes',
    no: 'No',
    inactive: 'Inactive',
    totalFunctions: 'Total functions',
    activeFunctions: 'Active',
    createDefaultFunctions: 'Create default functions',
    functionInformation: 'Function Information',
    manageSystemFunctions: 'Manage system functions',
    addNewFunction: 'Add new function/menu to the system',
    updateFunctionInfo: 'Update function information in the system',
    // Permission Groups
    managePermissionGroups: 'Manage system permission groups and their access levels',
    createNewPermissionGroup: 'Create a new permission group with specific function access levels',
    updatePermissionGroupSettings: 'Update permission group settings and function access levels',
    createDefaultGroups: 'Create Default Groups',
    creating: 'Creating...',
    total: 'Total',
    groups: 'groups',
    noPermissionGroups: 'No Permission Groups',
    getStartedPermissionGroups: 'Get started by creating your first permission group or seeding default ones.',
    createFirstGroup: 'Create First Group',
    seedDefaultGroups: 'Seed Default Groups',
    functionPermissions: 'Function Permissions',
    noFunctionsAvailable: 'No functions available',
    noFunctionsAvailableHelp: 'To create a permission group, you need to create system functions first. Please go to the "Functions" menu and click the "Create default function" button.',
    goToFunctionsToSeed: 'Go to Functions to seed',
    goToFunctions: 'Go to Functions',
    function: 'Function',
    editPermissionGroup: 'Edit Permission Group',
    updateGroup: 'Update Group',
    updating: 'Updating...',
    groupStatistics: 'Group Statistics',
    assignedUsers: 'Assigned Users',
    functionsWithPermissions: 'Functions with Permissions',
    created: 'Created',
    permissionGroupNotFound: 'Permission group not found',
    backToPermissionGroups: 'Back to Permission Groups',
    loading: 'Loading...',
    edit: 'Edit',
    delete: 'Delete',
    confirmDeleteGroup: 'Are you sure you want to delete',
    defaultGroupsCreatedSuccess: 'Default permission groups created successfully!',
    errorCreatingDefaultGroups: 'Error creating default permission groups',
    errorLoadingPermissionGroups: 'Error loading permission groups',
    exportPermissionGroups: 'Export Permission Groups',
    importPermissionGroups: 'Import Permission Groups',
    exportPermissionGroupsSuccess: 'Permission groups exported successfully',
    importPermissionGroupsHint: 'Upload a JSON file exported from another project to copy permission groups to this operator account.',
    importPermissionGroupsModeSkip: 'Skip existing groups',
    importPermissionGroupsModeReplace: 'Replace permissions if group exists',
    importPermissionGroupsModeMerge: 'Merge permissions if group exists',
    importPermissionGroupsSuccess: 'Permission groups imported successfully',
    importPermissionGroupsJsonHint: 'File exported from Permission Groups page',
    importPermissionGroupsFormatTitle: 'JSON file structure',
    importPermissionGroupsFormatName: 'Group name, description, group type',
    importPermissionGroupsFormatCode: 'Group code (optional) for matching on update',
    importPermissionGroupsFormatPermissions: 'Permissions list by function code',
    importResultCreated: 'Created',
    importResultUpdated: 'Updated',
    importResultSkipped: 'Skipped',
    importWarnings: 'Warnings',
    importMoreWarnings: 'more warnings',
    errorDeletingPermissionGroup: 'Error deleting permission group',
    pleaseEnterGroupName: 'Please enter a group name',
    permissionGroupCreatedSuccess: 'Permission group created successfully!',
    errorCreatingPermissionGroup: 'Error creating permission group',
    permissionGroupUpdatedSuccess: 'Permission group updated successfully!',
    errorUpdatingPermissionGroup: 'Error updating permission group',
    errorLoadingPermissionGroup: 'Error loading permission group',
    enterGroupName: 'Enter group name',
    enterGroupDescription: 'Enter group description',
    buildingSelectionNote: 'Building selection will be implemented when buildings module is available. For now, it defaults to "All Buildings".',
    loadingPermissionGroups: 'Loading permission groups...',
    // User Form
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    role: 'Role',
    permissionGroup: 'Permission Group',
    // User counts
    users: 'users',
    user: 'user',
    // Permission Details
    detailedPermissions: 'Detailed Permissions',
    functionality: 'Functionality',
    permission: 'Permission',
    view: 'View',
    create: 'Create',
    servicePayment: 'Service Payment',
    transactionReport: 'Transaction Report',
    billReport: 'Bill Report',
    apartment: 'Apartment',
    resident: 'Resident',
    code: 'Code',
    name: 'Name',
    account: 'Account',
    emailNotification: 'Email',
    staff: 'Staff',
    // Actions
    saveInfo: 'SAVE INFO',
    // Login page
    loginTitle: 'Sign in to System',
    createSuperadminTitle: 'Create Superadmin Account',
    firstTimePrompt: 'This is the first login. Please create your superadmin account.',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signOut: 'Sign out',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordDescription: 'Enter your registered email. We will send you a password reset link.',
    forgotPasswordSuccess: 'If the email exists in our system, a reset link has been sent. Please check your inbox.',
    forgotPasswordError: 'Could not send reset email. Please try again.',
    sendResetLink: 'Send reset link',
    sendingResetLink: 'Sending...',
    backToLogin: 'Back to login',
    resetPasswordTitle: 'Reset Password',
    resetPasswordDescription: 'Enter a new password for your account.',
    resetPasswordSuccess: 'Password reset successfully. Please sign in.',
    resetPasswordError: 'Could not reset password. Please try again.',
    invalidResetToken: 'Invalid or expired reset link.',
    resettingPassword: 'Resetting...',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    passwordMismatch: 'Passwords do not match.',
    myAccount: 'My Account',
    myAccountDescription: 'Manage your personal information and password',
    personalInformation: 'Personal Information',
    changePassword: 'Change Password',
    currentPassword: 'Current password',
    changingPassword: 'Changing password...',
    passwordChangedSuccess: 'Password changed successfully!',
    errorChangingPassword: 'Error changing password',
    profileUpdatedSuccess: 'Profile updated successfully!',
    errorUpdatingProfile: 'Error updating profile',
    createAccount: 'Create Account',
    creatingAccount: 'Creating account...',
    signingIn: 'Signing in...',
    firstTimeError: 'Failed to create superadmin account. Please try again.',
    loginError: 'Invalid email or password.',
    superadminName: 'Superadmin',
    systemSubtitle: 'Apartment Building Management System',
    loginFeatureSmartApartments: 'Smart apartment management',
    loginFeatureModernPayments: 'Modern payment system',
    loginFeatureAccurateReports: 'Detailed and accurate reports',
    documentTitleTagline: 'Digital solution for building management',
    // Backend error messages
    passwordComplexity: 'Password must be at least 6 characters long and include uppercase, lowercase, number, and special character.',
    emailExists: 'Email already exists.',
    unauthorized: 'Unauthorized.',
    // Account Management
    manageAccounts: 'Manage system accounts and their access levels',
    searchAccountsPlaceholder: 'Search by name, email, username, or building...',
    createNewAccount: 'Create a new account with personal information and access rights',
    loginInformation: 'Login Information',
    username: 'Login Name',
    selectPermissionGroup: 'Select permission group',
    noAccounts: 'No accounts',
    getStartedAccounts: 'Get started by creating your first account.',
    createFirstAccount: 'Create First Account',
    lastLogin: 'Last Login',
    never: 'Never',
    resetPassword: 'Reset Password',
    toggleStatus: 'Toggle Status',
    confirmDeleteAccount: 'Are you sure you want to delete account',
    accountCreatedSuccess: 'Account created successfully!',
    errorCreatingAccount: 'Error creating account',
    accountUpdatedSuccess: 'Account updated successfully!',
    errorUpdatingAccount: 'Error updating account',
    errorLoadingAccounts: 'Error loading accounts',
    errorDeletingAccount: 'Error deleting account',
    errorToggleAccountStatus: 'Error toggling account status',
    pleaseEnterUsername: 'Please enter login name',
    pleaseEnterPassword: 'Please enter password',
    pleaseSelectPermissionGroup: 'Please select permission group',
    fullSystemAccessNoGroup: 'Full system access (no permission group)',
    superadminPermissionGroupHelp: 'Leave empty for full access (recommended for the primary administrator). Select a permission group only for delegated superadmins with limited access.',
    pleaseSelectRole: 'Please select role',
    enterUsername: 'Enter login name',
    enterPassword: 'Enter password',
    loadingAccounts: 'Loading accounts...',
    // Missing validation and form keys
    pleaseEnterFullName: 'Please enter full name',
    pleaseEnterEmail: 'Please enter email',
    enterFullName: 'Enter full name',
    enterEmail: 'Enter email',
    enterPhoneNumber: 'Enter phone number',
    usernameOrEmail: 'Login Name or Email',
    enterUsernameOrEmail: 'Enter login name or email',
    // Role translations
    roleSelection: 'Role',
    selectRole: 'Select role',
    statusSelection: 'Account status',
    SUPERADMIN: 'Superadmin',
    OPERATOR: 'Operator', 
    STAFF: 'Staff',
    RESIDENT: 'Resident',
    
    // Service Fee Section
    serviceFeeSection: 'SERVICE FEES',
    payment: 'Payment',
    reports: 'Reports',
    transactionReportMenu: 'Transactions',
    receivableReportMenu: 'Receivables',
    
    // Payment Page
    searchApartmentInfo: 'Search Apartment',
    buildingSelection: 'Building',
    apartmentCodeInput: 'Apartment Code',
    phoneNumberSearch: 'Phone Number',
    paymentMethod: 'Payment Method',
    paymentTotal: 'Total',
    
    // Transaction Report
    fromDate: 'From Date',
    toDate: 'To Date',
    viewUnpaidTransactions: 'View unpaid transactions',
    viewReport: 'VIEW REPORT',
    
    // Receivable Report  
    viewOverdueFees: 'View only overdue fees',
    // Menu groupings
    accountsGroup: 'Accounts',
    permissionsGroup: 'Permissions',
    // Building Management
    buildings: 'Buildings',
    buildingList: 'Building List',
    addBuilding: 'Add Building',
    editBuilding: 'Edit Building',
    buildingName: 'Building Name',
    projectCode: 'Project Code',
    enterProjectCode: 'Enter project code (e.g. DA101)',
    projectCodeHint: 'Short code for identification in exported statistics',
    invalidProjectCode: 'Project code may only contain uppercase letters, numbers, underscore, or hyphen',
    operator: 'Operator',
    managementPhone: 'Management Phone',
    managementEmail: 'Management Email',
    buildingLogoPath: 'Building / project logo',
    buildingLogoPathHint: 'Logo path or URL for this building (shown on fee notices and receipts). Upload an image or enter a path/URL.',
    buildingLogoUploadHint: 'PNG, JPG, or SVG. Max 5MB.',
    buildingLogoUrlLabel: 'Or enter path / URL',
    buildingLogoUploadSuccess: 'Logo uploaded successfully',
    buildingLogoUploadSelectOperator: 'Please select an operator before uploading a logo',
    enterBuildingLogoPath: 'e.g. /uploads/buildings/stm-logo.png or https://...',
    imageUploadEmpty: 'No image',
    imageUploadChoose: 'Choose image',
    imageUploadReplace: 'Replace image',
    imageUploadRemove: 'Remove logo',
    imageUploadRemoving: 'Removing...',
    imageUploading: 'Uploading...',
    buildingLogoRemoveSuccess: 'Logo removed',
    confirmRemoveBuildingLogo: 'Remove this building logo?',
    address: 'Address',
    apartmentCount: 'Apartment Count',
    noBuildingsYet: 'No buildings created yet',
    addFirstBuilding: 'Add your first building',
    confirmDeleteBuilding: 'Are you sure you want to delete this building?',
    errorDeletingBuilding: 'Error occurred while deleting building',
    buildingGeneralInfo: 'General Information',
    systemConfiguration: 'System Configuration',
    allowOnlinePayment: 'Allow online payment',
    allowPartialPayment: 'Allow partial payment',
    combinedElevatorVehicleCards: 'Combined elevator + vehicle cards (THE001 on vehicle registry)',
    cardElevatorLinked: 'Elevator card',
    cardElevatorLinkedYes: 'Linked',
    cardElevatorLinkedFilterAll: 'All (elevator)',
    cardElevatorLinkedFilterLinked: 'Elevator linked',
    cardElevatorLinkedFilterNotLinked: 'Not elevator linked',
    cardVehicleAssigned: 'On monthly vehicle',
    autoSendEmailReminder: 'Auto send email reminders for service fees',
    autoGenerateMonthlyServiceFees: 'Auto-generate monthly service fees',
    autoGenerateMonthlyServiceFeesHint:
      'Runs on the closing day below. Turn off to skip scheduled bulk fee creation; manual bulk in Fee Management still works.',
    serviceFeeDay: 'Service fee closing day (monthly)',
    paymentFromDay: 'Service fee payment from day',
    paymentToDay: 'to day (monthly)',
    configurationNote: 'Configure parameters according to your needs.',
    parkingLegacyApiKey: 'Parking gate API key (get_v2 / set_v2)',
    parkingLegacyApiKeyHint:
      'Key for legacy gate software. Generate, edit, or revoke; save the building form to apply.',
    parkingLegacyApiKeyPlaceholder: 'e.g. 02822109199-002',
    generateParkingLegacyApiKey: 'Generate',
    revokeParkingLegacyApiKey: 'Revoke',
    copy: 'Copy',
    copied: 'Copied',
    savingBuilding: 'Saving...',
    saveBuilding: 'SAVE INFORMATION',
    updatingBuilding: 'Updating...',
    updateBuilding: 'UPDATE INFORMATION',
    loadingBuildingInfo: 'Loading information...',
    buildingNotFound: 'Building information not found',
    backToList: 'Back to list',
    errorLoadingBuilding: 'Error occurred while loading building information',
    errorCreatingBuilding: 'Error occurred while creating building',
    errorUpdatingBuilding: 'Error occurred while updating building',
    enterBuildingName: 'Enter building or project name',
    enterManagementPhone: 'Enter management phone number',
    enterManagementEmail: 'Enter management email address',
    managementEmailOptionalHint: 'Optional. If provided, must be a valid email address.',
    invalidEmail: 'Please enter a valid email address',
    pleaseFixFormErrors: 'Please check and fix the errors in the form.',
    selectOperator: 'Select operator',
    pleaseSelectOperator: 'Please select operator',
    currentOperator: 'Current Operator',
    selectOperatorForPermissionGroup: 'Select operator owning this permission group',
    selectOperatorToViewPermissionGroups: 'Select operator to view permission groups',
    selectBuildingsFromList: 'Select building from list',
    noBuildings: 'No buildings',
    selectOperatorToViewBuildings: 'Select operator to view buildings',
    // Role descriptions
    roleInformation: 'Role Information',
    fullSystemAccess: 'Full System Access',
    manageOwnBuildings: 'Manage Own Buildings',
    limitedAccessWithPermissions: 'Limited Access with Permissions',
    viewOwnInformation: 'View Own Information',
    // Utilities
    emailNotifications: 'Email Notifications',
    sendNotification: 'Send Notification',
    sendEmail: 'Send Email', 
    emailList: 'Email List',
    // Function code
    CHAT: 'Chat',
    SUPPORT: 'Support',
    EMAIL_NOTIFICATIONS: 'Email Notifications',
    SEND_EMAIL: 'Send Email',
    EMAIL_LIST: 'Email List',
    AUTOMATION_SETTINGS: 'Automation Settings',
    PDF_TEMPLATES: 'PDF Templates',
    SERVICE_PAYMENT: 'Service Payment',
    TRANSACTION_REPORT: 'Transaction Report',
    RECEIVABLE_REPORT: 'Receivable Report',
    SERVICE_FEE_MANAGEMENT: 'Service Fee Management',
    CONTRACT_MANAGEMENT: 'Contract Management',
    REVENUE_CONTRACTS: 'Revenue Contracts',
    EXPENDITURE_CONTRACTS: 'Expenditure Contracts',
    IE_REVENUE_ACTIVITIES: 'Revenue Activities',
    IE_EXPENDITURE_ACTIVITIES: 'Expenditure Activities',
    IE_SUMMARY: 'Income & Expenditure Summary',
    IE_BANK_ACCOUNTS: 'Bank Accounts',
    IE_FINANCIAL_REPORTS: 'Financial Reports',
    IE_DATA_IMPORT: 'Data Import',
    ACCOUNT_LIST: 'Account List',
    PERMISSION_GROUPS: 'Permission Groups',
    BUILDING_LIST: 'Building List',
    SEND_FEE_NOTIFICATION: 'Send Fee Notification',
    FEE_CATEGORIES: 'Fee Categories',
    BULK_FEE_ENTRY: 'Bulk Fee Entry',
    EXPORT_PDF_SERVICE_FEES: 'Export PDF Service Fees',
    APARTMENT_LIST: 'Apartment List',
    APARTMENT_GROUPS: 'Apartment Groups',
    APARTMENT_USAGE_TYPES: 'Apartment Usage Types',
    RESIDENT_LIST: 'Resident List',
    MONTHLY_VEHICLE_MANAGEMENT: 'Monthly Vehicle Management',
    CARD_MANAGEMENT: 'Card Management',
    TASK_LIST: 'Task List',
    BUILDING_UTILITY_GROUPS: 'Building Utility Groups',
    BUILDING_UTILITY_LIST: 'Building Utility List',
    BUILDING_UTILITY_ADD: 'Add Building Utility',
    BUILDING_UTILITY_EDIT: 'Edit Building Utility',
    BUILDING_BANNER_LIST: 'Banner Management',
    BUILDING_BANNER_ADD: 'Add Banner',
    BUILDING_BANNER_EDIT: 'Edit Banner',
    BUILDING_NEWS_LIST: 'News Management',
    BUILDING_NEWS_ADD: 'Add News',
    BUILDING_NEWS_EDIT: 'Edit News',
    BUILDING_UTILITY_BOOKINGS: 'Building Utility Bookings',
    CONSTRUCTION_REGISTRATION: 'Construction Registration',
    ENTRY_EXIT_REGISTRATION: 'Entry Exit Registration',
    MOVING_REGISTRATION: 'Moving Registration',
    FEEDBACK_LIST: 'Feedback List',
    FEEDBACK_CATEGORY_CONFIG: 'Feedback Categories',
    FEEDBACK_STATISTICS: 'CSKH Statistics',
    utilities: 'Utilities',
    // Send Email Form
    recipientSelection: 'Email Recipients',
    emailContent: 'Email Content',
    selectBuildingForEmail: 'Select Building',
    selectApartmentGroupForEmail: 'Select Apartment Group',
    sendToAllApartments: 'Send to all apartments',
    emailSubject: 'Subject',
    emailContentText: 'Content',
    attachments: 'Attachments',
    maxTwoFiles: 'Max 2 files',
    sendEmailButton: 'SEND EMAIL',
    dragDropFiles: 'Drag and drop files or click here to select',
    acceptedFileTypes: 'File attachments (image, pdf, word, excel. Max 2 files)',
    // Email List
    emailRecordsPerPage: 'Records per page',
    emailSearchPlaceholder: 'Search',
    emailTitle: 'Title',
    emailSendDate: 'Send Date',
    emailRecipientGroup: 'Recipient Group',
    emailSendCount: 'Send Count',
    // Email View & Status
    emailStatus: 'Status',
    emailSent: 'Sent',
    emailSending: 'Sending',
    emailFailed: 'Failed',
    emailDraft: 'Draft',
    viewEmailDetails: 'View Details',
    backToEmailList: 'Back to List',
    emailDetails: 'Email Details',
    sentTo: 'Sent To',
    sentDate: 'Send Date',
    emailAttachments: 'Attachments',
    thankYou: 'Thank you!',
    // Recipient Group Display
    allApartments: 'All Apartments',
    unknownGroup: 'Unknown',
    // Form Placeholders
    enterEmailSubject: 'Enter email subject',
    enterEmailContent: 'Enter email content',
    selectBuildingFirst: 'Select building first',
    selectGroupOrAll: 'Select group or send to all',
    // Success Messages
    emailSentSuccess: 'Email sent successfully!',
    emailSentToApartments: 'Email sent to {count} apartments',
    // Error Messages  
    errorSendingEmail: 'Error sending email',
    errorLoadingEmails: 'Error loading email list',
    errorLoadingEmailDetails: 'Error loading email details',
    pleaseEnterEmailSubject: 'Please enter email subject',
    pleaseEnterEmailContent: 'Please enter email content',
    fileUploadError: 'File upload error',
    maxFilesExceeded: 'Maximum 2 files allowed',
    fileSizeExceeded: 'File size exceeded',
    // Fee Categories
    feeCategories: 'Fee Categories',
    addFeeService: 'Add Fee Service',
    selectBuilding: 'Select Building:',
    selectBuildingPlaceholder: '-- Select Building --',
    manager: 'Manager:',
    noFeeCategories: 'No fee categories yet',
    addFirstFee: 'Add First Fee Categories',
    serviceNumber: '#',
    feeService: 'Fee Service',
    feeCode: 'Fee Code',
    enterFeeCode: 'Enter fee code (e.g. DV001, DV004)',
    feeCodeHint: 'Service/cost code from PQL template, used in exported reports',
    invalidFeeCode: 'Fee code may only contain uppercase letters, numbers, and hyphens',
    feeType: 'Fee Type',
    unitPrice: 'Unit Price',
    vat: 'VAT (%)',
    totalAmount: 'Total Amount',
    closeFee: 'Close Fee',
    notes: 'Notes',
    fixed: 'Fixed',
    usageBased: 'Usage Based',
    tiered: 'Tiered',
    automatic: 'Automatic',
    manual: 'Manual',
    confirmDeleteFeeCategory: 'Are you sure you want to delete this fee service?',
    failedToLoad: 'Failed to load building list',
    failedToLoadCategories: 'Failed to load fee service list',
    failedToDelete: 'Failed to delete fee service',
    failedToUpdateStatus: 'Failed to update status',
    errorCreatingFeeCategory: 'Failed to create fee service',
    errorUpdatingFeeCategory: 'Failed to update fee service',
    failedToLoadFeeCategory: 'Failed to load fee service details',
    close: 'Close',
    // Member-related translations
    memberManagement: 'Member Management',
    fullNameMember: 'Full Name',
    dateOfBirth: 'Date of Birth',
    relationship: 'Relationship',
    relationshipRole: 'Relationship/Role in the Apartment',
    // Relationship types
    ownerRole: 'Owner',
    spouseRole: 'Spouse',
    parentRole: 'Parent',
    childRole: 'Child',
    otherRole: 'Other',
    // Form validation
    pleaseSelectDateOfBirth: 'Please select date of birth',
    // Actions
    addMemberTitle: 'Add Apartment Member',
    deleteMember: 'Delete Member',
    confirmDeleteMember: 'Are you sure you want to delete this member?',
    // Table data states
    noMembersData: 'No members yet',
    addMember: 'Add Member',
    // Fee Category Forms
    addFeeServiceTitle: 'Add Fee Service',
    editFeeServiceTitle: 'Edit Fee Service',
    selectBuildingSection: 'Select Building',
    pleaseSelectBuilding: 'Please select building',
    pleaseEnterServiceName: 'Please enter service name',
    serviceNameLabel: 'Service Name',
    serviceNamePlaceholder: 'Service name',
    serviceInformation: 'Service Information',
    tieredPricing: 'Tiered Pricing',
    singleTier: 'Single Tier',
    quotaBased: 'Quota Based',
    unitPriceLabel: 'Unit Price (excluding VAT if applicable)',
    priceWithVatLabel: 'Unit Price (including VAT)',
    compositePricingTitle: 'Detailed unit price breakdown',
    compositePricingHint: 'Total = base ex-VAT + VAT + surcharge group 1 + surcharge group 2 (% of base or fixed fee).',
    extraFeeGroup1Title: '1. Additional fee group 1',
    extraFeeGroup2Title: '2. Additional fee group 2',
    extraFeeGroupNameLabel: 'Additional fee group name',
    extraFeeGroupNamePlaceholder: 'e.g. DVTN&XLNT fee, Wastage fee',
    tierCommonFeeSettingsHint: 'Shared settings for all tiers (name, %, VAT %, fixed fee). Amounts are calculated per tier.',
    extraFeePercentLabel: 'Fee (%) of base price',
    extraFeeAmountLabel: 'Fee amount',
    extraFeeVatPercentLabel: 'Fee VAT (%)',
    extraFeeVatAmountLabel: 'Fee VAT amount',
    extraFeeFixedLabel: 'Fixed fee',
    totalUnitPriceAfterTax: 'Total price after tax',
    calculatedValue: 'Calculated',
    vatAmountLabel: 'VAT Amount',
    pricePlaceholder: 'Amount',
    usageLevel: 'Usage Level',
    usageFrom: 'From',
    usageTo: 'to',
    usageToUnlimitedHint: 'Leave blank = unlimited',
    usageToLastTierNote: 'Last tier: leave "to" blank for unlimited m³. E.g. tier 3: from 6 to blank. Additional tiers (4, 5, 6…) are used for non-quota billing at the configured unit price.',
    importMetersSampleDescription: 'Download sample file with columns: apartment code, meter code, billing mode, quota tier (ĐM 1, 2, 3… per water fee config)...',
    priceLabel: 'Unit Price (excluding VAT if applicable)',
    unitLabel: 'Unit',
    unitPlaceholder: 'm2, m3, unit...',
    removeLevel: 'Remove Level',
    addLevel: '+ Add Level',
    vatPercentage: 'VAT Percentage (%)',
    monthlyFixedFee: 'Monthly fixed fee per unit (apartment/m2/m3,...)',
    autoCloseMonthly: 'Auto close monthly fee',
    statusLabel: 'Status:',
    notesLabel: 'Notes:',
    notesPlaceholder: 'Notes information',
    waiveFirstVehicleCardIssuanceFee: 'Waive first vehicle card issuance fee per license plate',
    waiveFirstVehicleCardIssuanceFeeHint:
      'When enabled, the first monthly vehicle registration per license plate skips THE003; replacement cards for the same plate are still charged.',
    backButton: 'Back',
    saving: 'Saving...',
    // Fee Category Seeding
    createDefaultFeeCategories: 'Create Default Fee Categories',
    seedDefaultFeeCategories: 'Seed Default Fee Categories',
    exportFeeCategories: 'Export Fee Categories',
    importFeeCategories: 'Import Fee Categories',
    exportFeeCategoriesSuccess: 'Fee categories exported successfully',
    importFeeCategoriesHint: 'Upload a JSON file exported from another building to copy fee configurations to this building.',
    importFeeCategoriesModeSkip: 'Skip existing fee codes',
    importFeeCategoriesModeReplace: 'Update if fee code already exists',
    feeCategoryImportJsonOnly: 'Only JSON files (.json) exported from the system are supported',
    defaultFeeCategoriesCreatedSuccess: 'Default fee categories created successfully!',
    errorCreatingDefaultFeeCategories: 'Error creating default fee categories',
    // Bulk Fee Entry
    bulkFeeEntry: 'Bulk Fee Entry',
    bulkFeeEntryTitle: 'Add Bulk Fee Entry',
    chooseServiceAndPeriod: 'Choose Service and Period',
    service: 'Service',
    billingPeriod: 'Billing Period',
    selectService: 'Select Service',
    selectBillingPeriod: 'Select Billing Period',
    manualEntryByApartmentList: 'MANUAL ENTRY BY APARTMENT LIST',
    exportSampleFile: 'EXPORT SAMPLE FILE',
    importDataFromFile: 'IMPORT DATA FROM FILE',
    searchApartment: 'Search Apartment',
    apartmentCode: 'Apartment',
    oldReading: 'Old Reading',
    newReading: 'New Reading',
    usage: 'Usage',
    search: 'Search',
    addManuallyByList: 'Add manually by apartment list',
    // Pagination
    recordsPerPage: 'Records per page',
    showingRecords: 'Showing {from} - {to} of {total} apartments',
    page: 'Page',
    of: 'of',
    previous: 'Previous',
    next: 'Next',
    first: 'First',
    last: 'Last',
    noData: 'No data',
    // Manual entry toggle
    showManualEntry: 'Show manual entry',
    hideManualEntry: 'Hide manual entry',
    manualEntrySection: 'Manual entry by apartment list',
    // Additional translations for bulk fee entry
    pleaseSelectBuildingToViewApartments: 'Please select building to view apartment list',
    processing: 'Processing...',
    noApartmentsFound: 'No apartments in the system',
    noApartmentsInBuilding: 'No apartments in this building',
    // Error messages for bulk fee entry
    failedToLoadBillingPeriods: 'Failed to load billing periods',
    failedToLoadServices: 'Failed to load services',
    failedToLoadApartments: 'Failed to load apartments',
    failedToExportSample: 'Failed to export sample file',
    failedToImportFile: 'Failed to import file',
    pleaseEnterValidReadings: 'Please enter at least one valid meter reading',
    failedToSubmitBulkEntry: 'Failed to submit meter readings in bulk',
    meterSubmitNoEndingReadings:
      'No ending reading (CHỈ SỐ MỚI) to submit. In the Enter readings import, CHỈ SỐ CŨ is optional period start, not the meter initial reading — use Water/Electric meters tab to import initial readings. Fill CHỈ SỐ MỚI (or CHỈ SỐ CUỐI) for billing.',
    bulkFeeEntrySuccess: 'Meter readings submitted successfully!',
    meterBaselineSavedCount: 'Updated {count} opening indices (no period fee created)',
    pleaseSelectBuildingServiceAndFile: 'Please select building, service and file',
    pleaseSelectBuildingServiceAndPeriod: 'Please select building, service and billing period',
    meterType: 'Meter type',
    electricity: 'Electricity',
    water: 'Water',
    hasData: 'Has data',
    submitMeterReadings: 'Submit meter readings',
    chooseMeterTypeAndPeriod: 'Choose meter type and billing period',
    tabWaterReadings: 'Water readings',
    tabElectricReadings: 'Electric readings',
    tabWaterMeters: 'Water meters',
    tabElectricMeters: 'Electric meters',
    meterReadingEntryTab: 'Enter readings',
    meterReadingHistoryTab: 'Action history',
    meterReadingHistoryAllPeriods: 'All periods',
    usageVariance: 'Variance',
    meterReadingListTab: 'Reading list',
    noRecordedReadingsForPeriod: 'No recorded readings for period {period}',
    readingStatusRecorded: 'Recorded',
    readingHasImage: 'Has image',
    readingNoImage: 'No image',
    meterCode: 'Meter code',
    billingMode: 'Billing mode',
    billingModeQuota: 'Quota-based',
    billingModeNonQuota: 'Non-quota',
    feeMultiplier: 'Fee multiplier',
    quotaTierStart: 'Quota tier start',
    quotaTier1: 'Tier 1',
    quotaTier2: 'Tier 2',
    quotaTier3: 'Tier 3',
    quotaTier4: 'Tier 4',
    initialReading: 'Initial reading',
    registrationDate: 'Registration date',
    meterStatusActive: 'Active',
    meterStatusInactive: 'Inactive',
    exportMeters: 'Export meters',
    exportMeterQrSelected: 'Export selected QR',
    exportMeterQrAll: 'Export all QR',
    meterQrListTitle: 'QR list',
    noMetersSelectedForQr: 'Please select at least one meter to export QR',
    print: 'Print',
    meterQrPrinterSize: 'Paper size',
    meterQrPrinterA4: 'A4 (210mm)',
    meterQrPrinter80mm: '80mm printer',
    meterQrPrinter58mm: '58mm printer',
    importMeters: 'Import meters',
    addMeter: 'Add meter',
    meterList: 'Meter list',
    noMeters: 'No meters',
    failedToLoadMeters: 'Failed to load meters',
    failedToImportMeters: 'Failed to import meters',
    failedToCreateMeter: 'Failed to create meter',
    failedToDeleteMeter: 'Failed to delete meter',
    failedToSaveMeter: 'Failed to save meter',
    confirmDeleteMeter: 'Delete meter {code}?',
    deleteSelectedMeters: 'Delete selected',
    confirmBulkDeleteMeters: 'Delete {count} selected meters?',
    bulkDeleteMetersResultSummary: 'Deleted {deleted} meters, skipped {skipped}.',
    meterCreateRequiredFields: 'Please select apartment and enter meter code',
    importMetersResult: 'Import: {created} new, {updated} updated, {skipped} skipped',
    importReadingsSuccess: 'Imported {count} readings successfully',
    exportReadings: 'Export readings',
    importReadings: 'Import readings',
    importReadingsSampleDescription:
      'Enter readings import requires ending reading (CHỈ SỐ MỚI); CHỈ SỐ CŨ is optional. Meter initial reading: Water/Electric meters tab. Columns: period, apartment, meter code, old/new reading, usage, notes — file period must match selection.',
    deletePeriodReadings: 'Delete readings for this period',
    confirmDeletePeriodReadings:
      'Delete all readings and pending invoices for period {period}? Use when imported to wrong period.',
    failedToDeletePeriodReadings: 'Failed to delete period readings',
    importedFromExcel: 'Data imported from Excel file',
    searchApartmentOrMeter: 'Search apartment or meter code',
    editMeterTitle: 'Edit meter',
    // Apartment Management
    apartments: 'Apartments',
    addApartment: 'Add Apartment',
    apartmentList: 'Apartment List',
    apartmentGroups: 'Apartment Groups',
    apartmentUsageTypes: 'Apartment Usage Types',
    searchApartments: 'Search Apartments',
    addApartmentGroup: 'Add Apartment Group',
    addApartmentUsageType: 'Add Usage Type',
    usageType: 'Usage',
    usageTypeName: 'Usage Type Name',
    usageTypeCode: 'Usage Type Code',
    usageTypeManagementFeeCode: 'Management fee code',
    usageTypeManagementFeeCodeHint:
      'Fee category code (e.g. DV001, DV008). Leave blank: CAN_HO → DV001, TM → DV008.',
    usageTypeNamePlaceholder: 'e.g. Căn hộ, TM',
    selectUsageType: 'Select usage type',
    noUsageType: 'None',
    registeredQuotaCount: 'Registered quota count (ĐKĐM)',
    registeredQuotaCountPlaceholder: 'Number of registered water quotas',
    registeredQuotaCountNote: 'Used for water fee tier calculation (e.g. 3 people × 6m³ = 18m³)',
    apartmentName: 'Apartment name',
    apartmentNamePlaceholder: 'Apartment name',
    apartmentOccupancyStatus: 'Apartment status',
    occupancyOwnerUsing: 'Owner occupying',
    occupancyRented: 'Currently rented',
    occupancyForRent: 'For rent',
    occupancyForSale: 'For sale',
    handoverDate: 'Handover date',
    handoverDatePlaceholder: 'dd/mm/yyyy',
    handoverDateEmptyHint: 'Leave blank if not handed over',
    peCode: 'PE code',
    peCodePlaceholder: 'PE code',
    populationCount: 'Population count',
    populationCountPlaceholder: 'Population count',
    setAsDefaultUsageType: 'Set as default',
    pleaseEnterUsageTypeName: 'Please enter usage type name',
    pleaseEnterUsageTypeCode: 'Please enter usage type code',
    errorCreatingUsageType: 'Error creating usage type',
    errorLoadingUsageTypes: 'Error loading usage types',
    errorDeletingUsageType: 'Error deleting usage type',
    errorUpdatingUsageType: 'Error updating usage type',
    editApartmentUsageType: 'Edit Usage Type',
    exportUsageTypes: 'Export Usage Types',
    importUsageTypes: 'Import Usage Types',
    exportUsageTypesSuccess: 'Usage types exported successfully',
    importUsageTypesHint: 'Upload an Excel or CSV file exported from another building to copy apartment usage types to this building.',
    importUsageTypesModeSkip: 'Skip existing codes',
    importMode: 'Import mode',
    importUsageTypesModeReplace: 'Update if code already exists',
    confirmDeleteUsageType: 'Are you sure you want to delete this usage type?',
    loadingUsageTypes: 'Loading usage types...',
    pleaseSelectBuildingToViewUsageTypes: 'Please select a building to view usage types',
    noUsageTypes: 'No usage types yet',
    addFirstUsageType: 'Add first usage type',
    default: 'Default',
    editApartment: 'Edit Apartment',
    editApartmentGroup: 'Edit Apartment Group',
    selectApartmentGroup: 'Select Apartment Group',
    customerCode: 'Customer Code',
    ownerName: 'Owner Name',
    ownerPhone: 'Phone',
    ownerEmail: 'Owner Email',
    feeNotificationEmail: 'Email (Fee notification)',
    feeNotificationEmailPlaceholder: 'Email for fee notifications',
    invoiceEmail: 'Invoice email',
    invoiceEmailPlaceholder: 'Email for VAT invoices',
    multipleEmailsHint: 'Multiple emails separated by semicolon (;)',
    invalidEmailList: 'Each email must be valid. Separate multiple emails with semicolon (;).',
    apartmentAddress: 'Address',
    apartmentArea: 'Area (m2)',
    taxCode: 'Tax Code',
    apartmentNotes: 'Notes',
    hasVatInvoice: 'Has VAT Invoice',
    apartmentGroup: 'Apartment Group',
    groupDescription: 'Group Description',
    noApartmentGroup: 'No group',
    noApartments: 'No apartments yet',
    noApartmentGroups: 'No apartment groups yet',
    addFirstApartment: 'Add first apartment',
    addFirstApartmentGroup: 'Add first apartment group',
    apartmentInformation: 'Apartment Information',
    ownerInformation: 'Owner Information',
    groupInformation: 'Group Information',
    totalApartments: 'Total Apartments',
    totalGroups: 'Total Groups',
    apartmentsInGroup: 'Apartments',
    confirmDeleteApartment: 'Are you sure you want to delete this apartment?',
    confirmDeleteApartmentGroup: 'Are you sure you want to delete this apartment group?',
    apartmentCreatedSuccess: 'Apartment created successfully!',
    apartmentUpdatedSuccess: 'Apartment updated successfully!',
    apartmentGroupCreatedSuccess: 'Apartment group created successfully!',
    apartmentGroupUpdatedSuccess: 'Apartment group updated successfully!',
    errorCreatingApartment: 'Error creating apartment',
    errorUpdatingApartment: 'Error updating apartment',
    errorLoadingApartments: 'Error loading apartments',
    errorDeletingApartment: 'Error deleting apartment',
    errorCreatingApartmentGroup: 'Error creating apartment group',
    errorUpdatingApartmentGroup: 'Error updating apartment group',
    errorLoadingApartmentGroups: 'Error loading apartment groups',
    errorDeletingApartmentGroup: 'Error deleting apartment group',
    selectApartmentGroups: 'Select apartment groups',
    unassignedApartmentGroup: 'No group',
    apartmentGroupMultiSelectHint: 'Select one or more groups. Leave empty (without "Send to all") to block sending.',
    feeNotificationGroupHint: 'Select groups for fee generation and notifications. Leave empty to apply to the whole building.',
    selectedApartmentGroupsText: 'apartments in selected groups',
    bulkAssignApartmentGroup: 'Bulk assign apartments',
    bulkAssignApartmentGroupFor: 'Assign apartments to group',
    bulkAssignApartmentGroupSuccess: 'Successfully assigned {count} apartments to the group',
    errorBulkAssignApartmentGroup: 'Error assigning apartments to group',
    showUnassignedApartmentsOnly: 'Show unassigned apartments only',
    selectAllFiltered: 'Select all in list',
    selectUnassignedFiltered: 'Select unassigned in list',
    clearFilteredSelection: 'Clear selection in list',
    selectedApartmentsCount: 'Selected: {count} apartments',
    assignApartments: 'Assign apartments',
    pleaseEnterApartmentCode: 'Please enter apartment code',
    pleaseEnterOwnerName: 'Please enter owner name',
    enterApartmentCode: 'Enter apartment code',
    enterCustomerCode: 'Enter customer code',
    enterOwnerName: 'Enter owner name',
    enterOwnerPhone: 'Enter owner phone',
    enterOwnerEmail: 'Enter owner email',
    enterApartmentAddress: 'Enter apartment address',
    enterApartmentArea: 'Enter area',
    enterTaxCode: 'Enter tax code',
    enterApartmentNotes: 'Enter notes',
    loadingApartments: 'Loading apartments...',
    loadingApartmentGroups: 'Loading apartment groups...',
    // Apartment Form Placeholders and Labels
    apartmentCodePlaceholder: 'APARTMENT ID',
    customerCodePlaceholder: 'CUSTOMER CODE', 
    customerCodeNote: 'Customer code used for residents to check service fees online, leave blank if using the same as apartment code.',
    apartmentAreaPlaceholder: 'Area',
    ownerInfoTitle: 'Apartment Owner Information',
    ownerNamePlaceholder: 'Owner Name',
    ownerPhonePlaceholder: 'Owner Phone',
    ownerAddressPlaceholder: 'Owner Address',
    ownerEmailPlaceholder: 'Owner Email',
    taxCodePlaceholder: 'Tax Code',
    vatInvoiceNote: 'These information is used to send information & issue invoices (if applicable).',
    defaultGroup: 'Default Group',
    // Apartment Details
    apartmentDetails: 'Apartment Details',
    serviceFees: 'Service Fees',
    members: 'Members',
    residentList: 'Resident List',
    mobileAppAccount: 'Mobile app account',
    mobileAppLinked: 'Linked',
    mobileAppNotLinked: 'Not linked',
    totalResidents: 'Total residents',
    totalOwners: 'Owners',
    appLinkedResidents: 'App linked',
    pleaseSelectBuildingToViewApartmentGroups: 'Please select a building to view apartment groups',
    pleaseSelectBuildingToViewResidents: 'Please select a building to view residents',
    addResident: 'Add Resident',
    editResident: 'Edit Resident',
    residentName: 'Resident name',
    residentRole: 'Role',
    residentRoleOwner: 'Owner',
    residentRoleMember: 'Resident',
    manageResidents: 'Manage residents',
    membersTabReadOnlyHint: 'Add, edit, and import residents from the Resident List menu.',
    exportResidents: 'Export residents',
    importResidents: 'Import residents',
    importResidentsHint: 'Upload an Excel file using the sample format. Apartment codes must exist in the selected building.',
    errorLoadingResidents: 'Error loading residents',
    errorSavingResident: 'Error saving resident',
    errorDeletingResident: 'Error deleting resident',
    confirmDeleteResident: 'Are you sure you want to delete this resident?',
    residentListTab: 'Resident List',
    residentHistoryTab: 'Activity History',
    deleteSelectedResidents: 'Delete selected',
    confirmBulkDeleteResidents: 'Delete {count} selected residents?',
    bulkDeleteResidentsResultSummary: 'Deleted {deleted} residents.',
    deleteSelectedMonthlyVehicles: 'Delete selected',
    confirmBulkDeleteMonthlyVehicles: 'Delete {count} selected monthly vehicles?',
    bulkDeleteMonthlyVehiclesResultSummary: 'Deleted {deleted} monthly vehicles.',
    activityHistoryDeletedResidents: 'Deleted',
    showLegacyDeletedVehicles: 'Show legacy deleted vehicles',
    showLegacyDeletedVehiclesHint: 'Old soft-deleted records still in the database. Select and permanently remove the ones you no longer need.',
    legacyDeletedViewNote: 'Viewing legacy soft-deleted vehicles. Select records to permanently remove from the database.',
    legacyDeletedCountLabel: 'Legacy vehicles in building',
    purgeLegacyVehicle: 'Purge permanently',
    purgeSelectedLegacyVehicles: 'Purge selected',
    confirmPurgeLegacyVehicle: 'Permanently remove this legacy vehicle from the database?',
    confirmBulkPurgeLegacyVehicles: 'Permanently remove {count} selected legacy vehicles from the database?',
    monthlyVehicleManagement: 'Monthly Vehicle Management',
    cardManagement: 'Card Management',
    vehicleCards: 'Vehicle Cards',
    vehicleAndElevatorCards: 'Vehicle + elevator cards',
    elevatorCards: 'Elevator Cards',
    entryCards: 'Entry Cards',
    addMonthlyVehicle: 'Add Monthly Vehicle',
    editMonthlyVehicle: 'Edit Monthly Vehicle',
    importMonthlyVehicles: 'Import Monthly Vehicles from Excel',
    confirmDeleteMonthlyVehicle: 'Are you sure you want to delete this monthly vehicle?',
    monthlyVehicleDeleteModalTitle: 'Delete monthly vehicle',
    monthlyVehicleBulkDeleteModalTitle: 'Delete {count} selected monthly vehicles',
    monthlyVehicleDeleteNotesHint:
      'Reason for deletion (optional, saved in action history and on the legacy vehicle notes field)',
    restoreMonthlyVehicle: 'Restore',
    restoreSelectedMonthlyVehicles: 'Restore selected',
    monthlyVehicleRestoreModalTitle: 'Restore monthly vehicle',
    monthlyVehicleBulkRestoreModalTitle: 'Restore {count} selected monthly vehicles',
    confirmRestoreMonthlyVehicle: 'Restore this vehicle to the active list?',
    confirmBulkRestoreMonthlyVehicles: 'Restore {count} selected monthly vehicles?',
    monthlyVehicleRestoreNotesHint: 'Reason for restore (optional)',
    bulkRestoreMonthlyVehiclesResultSummary: 'Restored {restored} monthly vehicles.',
    cardActionRestore: 'Restore',
    confirmDeleteCard: 'Are you sure you want to delete this card?',
    addCard: 'Add Card',
    editCard: 'Edit Card',
    importCards: 'Import Cards from Excel',
    cardNumber: 'Card Number',
    cardCode: 'Card Code',
    cardType: 'Card Type',
    cardStockStatus: 'Status',
    cardSold: 'Sold',
    cardAvailable: 'Available',
    cardsSoldCount: 'Sold',
    cardsAvailableCount: 'Available',
    cardActionHistory: 'Action History',
    cardActionCreate: 'Create',
    cardActionUpdate: 'Update',
    cardActionDelete: 'Delete',
    cardActionBulkDelete: 'Bulk delete',
    cardActionImport: 'Import',
    cardStockStatusFilterAll: 'All statuses',
    cardTypeFilterAll: 'All card types',
    cardTypeUsageCountHint: 'Cards in the vehicle card registry for this type.',
    deleteSelectedCards: 'Delete selected',
    deleteAllAvailableCards: 'Delete all available',
    confirmBulkDeleteAccessCards: 'Delete {count} selected cards (available only)?',
    confirmDeleteAllAvailableAccessCards:
      'Delete all available cards in this tab (current filters)? Sold or assigned cards are skipped.',
    bulkDeleteAccessCardsResultSummary: 'Deleted {deleted} cards, skipped {skipped}.',
    restoreAccessCard: 'Restore',
    confirmRestoreAccessCard: 'Restore deleted cards from this history entry?',
    bulkRestoreAccessCardsResultSummary: 'Restored {restored} cards.',
    cardKindLabel: 'Card kind',
    cardActionStaff: 'Staff',
    cardNumberFromRegistry: 'Select card number registered in Card Management',
    cardNumberSearchPlaceholder: 'Type card number or UID (min 2 characters)...',
    createVehicleCardIssuanceFee: 'Create vehicle card issuance fee',
    createParkingFeeInvoice: 'Create parking fee invoice',
    saveAndPay: 'Save & Pay',
    monthlyVehicleCardRequiredForIssuanceFee: 'Select an available card to create the card issuance fee',
    monthlyVehicleCardClearedHint:
      'Current card cleared. Pick a new card from search or save to update other fields only.',
    monthlyVehicleDatesRequiredForParkingFee: 'Enter start and end dates to create the parking fee invoice',
    licensePlate: 'License Plate',
    vehicleModel: 'Vehicle Model',
    vehicleModelPlaceholder: 'e.g. Honda Vision, Toyota Vios',
    parkingSpot: 'Parking Spot',
    monthlyVehicleParkingFee: 'Monthly fee',
    monthlyVehicleParkingFeeHint:
      'Leave empty = fee category (card type). 0 = free (no parking invoices). Amount = all-in parking fee (VAT included).',
    monthlyVehicleParkingFeeByCategory: 'By category',
    startDate: 'Start Date',
    endDate: 'End Date',
    endOfMonth: 'End of month',
    parkingExpiryHint: 'Day 01 each month = 00:00 on the 1st (expires at that instant). E.g. 01/09/2026',
    parkingStatusExpired: 'Expired',
    parkingStatusLocked: 'Locked',
    parkingStatusDeleted: 'Deleted',
    syncParkingQuantities: 'Full Building Sync',
    syncParkingQuantitiesHint:
      'Sync apartment parking fee quantities from monthly vehicles. Apartments without monthly vehicles are reset to 0. Unpaid parking invoices that no longer match registered vehicles are cleaned only for the current billing period; older periods are unchanged.',
    monthlyVehicleAutoSyncNote: 'When an apartment has monthly vehicle records: parking invoices are per vehicle and fee quantity is statistics only. Apartments/buildings without monthly vehicles still bill by quantity (one invoice per vehicle type).',
    parkingQuantitiesSynced: 'Parking fee quantities synced for all apartments',
    cardTypeFeeMapping: 'Card Type → Parking Fee Mapping',
    cardTypeFeeMappingHint: 'Each card type maps to a parking fee category. Apartment fee quantities auto-update from OK monthly vehicles.',
    cardTypeManagement: 'Vehicle Card Types',
    cardTypeManagementHint: 'Manage vehicle card types per building. When importing vehicle cards or monthly vehicles, new LOẠI THẺ values are created automatically if missing.',
    addCardType: 'Add Card Type',
    editCardType: 'Edit Card Type',
    cardTypeName: 'Card Type Name',
    cardTypeCode: 'Card Type Code',
    cardTypeCodeOptional: 'Optional — auto-generated from name if empty',
    confirmDeleteCardType: 'Are you sure you want to delete this card type?',
    noCardTypesYet: 'No card types yet. Add manually or import Excel with LOẠI THẺ column.',
    noCardTypesForVehicleImport: 'No card types yet. Add them in Card Types tab, or import Excel — new types are auto-created from LOẠI THẺ.',
    importCardsTypeHint: 'LOẠI THẺ column will auto-create new card types if they do not exist.',
    importCardsSampleDescription: 'Download sample with SỐ THẺ, MÃ THẺ, LOẠI THẺ (vehicle cards), GHI CHÚ. New types in the file are created automatically.',
    cardTypeFeeMappingSaveHint: 'After saving fee mapping, use "Sync Fee Quantities" in Monthly Vehicle Management to update apartment quantities.',
    vehicleOwner: 'Vehicle Owner',
    cardNotFoundInRegistry: 'Card number not found in vehicle card registry',
    importMonthlyVehiclesSampleDescription: 'Download sample with apartment code, card number, card type, license plate, owner... New card types are auto-created.',
    usageCount: 'In use',
    notMapped: 'Not mapped',
    searchMonthlyVehiclesPlaceholder: 'Search by apartment code/name, plate, model, card number...',
    searchCardsPlaceholder: 'Search by card number or code...',
    importExcel: 'Import Excel',
    exportExcel: 'Export Excel',
    downloadSample: 'Download Sample',
    importComplete: 'Import complete',
    importCreated: 'created',
    updated: 'updated',
    skipped: 'skipped',
    importing: 'Importing...',
    import: 'Import',
    syncing: 'Syncing...',
    syncFailed: 'Sync failed',
    saveFailed: 'Save failed',
    deleteFailed: 'Delete failed',
    totalRecords: 'Total records',
    noResidents: 'No residents yet',
    searchResidentsPlaceholder: 'Search by name, email, phone, apartment code...',
    residentApartmentCode: 'Apartment code',
    gender: 'Gender',
    nationality: 'Nationality',
    idIssueDate: 'Issue date',
    idExpiryDate: 'Expiry date',
    moveInDate: 'Move-in date',
    moveOutDate: 'Move-out date',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderOther: 'Other',
    nationalityVietnam: 'Vietnam',
    nationalityForeign: 'Foreign',
    relationshipTenant: 'Tenant',
    relationshipContractHolder: 'Lease contract holder',
    relationshipHusband: 'Husband',
    relationshipWife: 'Wife',
    relationshipBrother: 'Brother',
    relationshipSister: 'Sister',
    relationshipGrandson: 'Grandson',
    relationshipGranddaughter: 'Granddaughter',
    relationshipYoungerBrother: 'Younger brother',
    relationshipYoungerSister: 'Younger sister',
    relationshipFather: 'Father',
    relationshipMother: 'Mother',
    relationshipGrandfather: 'Grandfather',
    relationshipGrandmother: 'Grandmother',
    relationshipAunt: 'Aunt',
    relationshipUncle: 'Uncle',
    relationshipCleaner: 'Cleaner',
    relationshipSecurity: 'Security',
    relationshipStaff: 'Staff',
    relationshipAuthorized: 'Authorized',
    relationshipMotherInLaw: 'Mother-in-law',
    relationshipFatherInLaw: 'Father-in-law',
    relationshipDaughterInLaw: 'Daughter-in-law',
    relationshipSonInLaw: 'Son-in-law',
    relationshipGrandchild: 'Grandchild',
    relationshipBrotherInLaw: 'Brother-in-law',
    relationshipSisterInLaw: 'Sister-in-law',
    relationshipFriend: 'Friend',
    relationshipHousekeeper: 'Housekeeper',
    relationshipFormerOwner: 'Former owner',
    relationshipOwner: 'Owner',
    relationshipSon: 'Son',
    relationshipDaughter: 'Daughter',
    relationshipPartner: 'Partner',
    relationshipRelative: 'Relative',
    relationshipSpouse: 'Spouse',
    relationshipChild: 'Child',
    paymentHistory: 'Payment History',
    notificationHistory: 'Notification History',
    noNotificationHistory: 'No Notification History',
    updateInfo: 'UPDATE INFORMATION',
    // Settings Page
    settings: 'Settings',
    settingsTitle: 'System Settings',
    emailSettings: 'Email Settings',
    paymentSettings: 'Payment Settings',
    systemSettings: 'System Settings',
    personalSettings: 'Personal Settings',
    globalSettings: 'Global Settings (Default)',
    effectiveSettings: 'Current Effective Settings',
    currentlyActive: 'Currently Active',
    noSettingsConfigured: 'No settings configured',
    fallbackToGlobal: 'Will use global (default) settings',
    fallbackToEnvironment: 'Will use environment variable settings',
    // Email Settings
    smtpHost: 'SMTP Host',
    smtpPort: 'SMTP Port',
    smtpSecure: 'Use SSL/TLS encryption',
    smtpSecureDescription: 'Enable for port 465 (SSL/TLS), disable for port 587 (STARTTLS) or port 25 (no encryption)',
    smtpUsername: 'SMTP Username',
    smtpPassword: 'SMTP Password',
    smtpFromEmail: 'From Email',
    emailProviderType: 'Email delivery method',
    emailProviderSmtp: 'SMTP',
    emailProviderSmtpDescription: 'Send via traditional SMTP server (Gmail, hosting mail, etc.)',
    emailProviderApi: 'Email API',
    emailProviderApiDescription: 'Send via API (Sendify, Resend, etc.) with per-message delivery tracking',
    emailApiProvider: 'API provider',
    emailApiProviderSendify: 'Sendify (MatBao)',
    emailApiProviderResend: 'Resend',
    emailApiProviderCustom: 'Custom (Resend-compatible API)',
    emailApiProviderDescription: 'Sendify API: https://sendify.vn/api/emails — each API key can only send from one verified domain',
    emailApiKey: 'API Key',
    emailApiBaseUrl: 'API Base URL',
    emailApiBaseUrlDescription: 'API root URL, e.g. https://api.example.com (do not append /emails)',
    emailApiFromDescription: 'Verified sender on the API provider, e.g. "eBMS" hello@domain.com',
    testConnection: 'Test Connection',
    saveSettings: 'Save Settings',
    deleteSettings: 'Delete Settings',
    testingConnection: 'Testing connection...',
    savingSettings: 'Saving settings...',
    deletingSettings: 'Deleting settings...',
    confirmDeleteEmailSettings: 'Are you sure you want to delete this email configuration?',
    confirmDeletePaymentSettings: 'Are you sure you want to delete this payment configuration?',
    pleaseEnterSmtpHost: 'Please enter SMTP host',
    pleaseEnterSmtpPort: 'Please enter SMTP port',
    pleaseEnterSmtpUsername: 'Please enter SMTP username',
    pleaseEnterSmtpPassword: 'Please enter SMTP password',
    pleaseEnterFromEmail: 'Please enter from email',
    enterSmtpHost: 'Enter SMTP host (e.g.: smtp.gmail.com)',
    enterSmtpPort: 'Enter SMTP port (e.g.: 587)',
    enterSmtpUsername: 'Enter SMTP username',
    enterSmtpPassword: 'Enter SMTP password',
    enterFromEmail: 'Enter from email',
    // Payment Settings
    bankName: 'Bank Name',
    bankAccount: 'Bank Account',
    bankAccountName: 'Account Name',
    paymentMethods: 'Payment Methods',
    pleaseEnterBankName: 'Please enter bank name',
    pleaseEnterBankAccount: 'Please enter bank account',
    pleaseEnterBankAccountName: 'Please enter account name',
    pleaseSelectPaymentMethods: 'Please select at least one payment method',
    enterBankName: 'Enter bank name',
    enterBankAccount: 'Enter bank account',
    enterBankAccountName: 'Enter account name',
    selectPaymentMethods: 'Select payment methods',
    bankTransfer: 'Bank Transfer',
    cash: 'Cash',
    creditCard: 'Credit Card',
    debitCard: 'Debit Card',
    eWallet: 'E-Wallet',
    onlinePayment: 'Online Payment',
    check: 'Check',
    other: 'Other',
    // Building Selection
    selectBuildingForSettings: 'Select Building',
    pleaseSelectBuildingFirst: 'Please select a building before configuring personal settings',
    // Status Messages
    notConfigured: 'Not configured',
    usingPersonalSettings: 'Using personal settings',
    usingGlobalSettings: 'Using global settings',
    itemsCount: 'items',
    // Send Fee Notification
    sendFeeNotification: 'Send Fee Notification',
    // Export PDF Service Fees
    exportPdfServiceFees: 'Export PDF Service Fees',
    apartmentInfo: 'Apartment Information',
    apartmentsWithEmail: 'Apartments with Email',
    apartmentsWithPhone: 'Apartments with Phone',
    apartmentsWithAppLinked: 'Apartments linked to app',
    sendDebtReminderNotification: 'Send debt reminder',
    selectFeeNotificationDeliveryMethods: 'Select notification delivery methods',
    deliveryMethodEmail: 'Send via Email',
    deliveryMethodAppPush: 'Send via App Push',
    deliveryMethodEmailFeeHint: 'Send to the primary email saved on the apartment',
    deliveryMethodAppFeeHint: 'Send only to apartments linked to a mobile app account',
    confirmSendNotification: 'Confirm send',
    notificationStaffName: 'Staff',
    appPushNotificationMethod: 'App Push',
    bothNotificationMethods: 'Email, App Push',
    apartmentsWithOutstandingFees: 'Apartments with Outstanding Fees',
    monthlyServiceFeeNotification: 'Monthly Service Fee Notification',
    notificationTitle: 'Title',
    notificationSentDate: 'Sent Date',
    notificationMethod: 'Method',
    emailNotificationMethod: 'Email',
    quantity: 'Quantity',
    noAddress: 'No address',
    enabled: 'Enabled',
    disabled: 'Disabled',
    selectBuildingForNotification: 'Select Building',
    selectBuildingToContinue: 'Select a building to continue',
    selectBuildingToViewAndSendNotification: 'Please select a building from the list on the left to view details and send service fee notification',
    buildingInfoSection: 'Building Information',    
    serviceFeeDayText: 'Service fee closing day',
    autoSendEmailReminderText: 'Auto send email reminders',
    actionNotificationSection: 'Notification Action',
    importantNoteTitle: 'Important Information',
    systemWillAutoGenerateText: 'System will automatically generate service fee invoices for',
    allApartmentsText: 'all apartments',
    inBuildingText: 'in building',
    emailWillBeSentText: 'Email notifications will be sent to apartments with',
    haveEmailAddressText: 'email addresses',
    billingPeriodText: 'Billing Period',
    operationCannotBeUndoneText: 'This operation cannot be undone after execution',
    successText: 'Success',
    failureText: 'Failure',
    // Toast Messages
    saveEmailSettingsGlobalSuccess: '✅ Global email settings saved successfully!',
    saveEmailSettingsPersonalSuccess: '✅ Email settings saved successfully for building {buildingName}!',
    savePaymentSettingsGlobalSuccess: '✅ Global payment settings saved successfully!',
    savePaymentSettingsPersonalSuccess: '✅ Payment settings saved successfully for building {buildingName}!',
    testEmailConnectionGlobalSuccess: '✅ Global email connection test successful!',
    testEmailConnectionPersonalSuccess: '✅ Email connection test successful for building {buildingName}!',
    deleteEmailSettingsSuccess: '✅ Email settings deleted successfully!',
    deletePaymentSettingsSuccess: '✅ Payment settings deleted successfully!',
    errorSavingEmailSettings: '❌ Failed to save email settings: {error}',
    errorSavingPaymentSettings: '❌ Failed to save payment settings: {error}',
    errorTestingEmailConnection: '❌ Failed to test email connection: {error}',
    errorDeletingEmailSettings: '❌ Failed to delete email settings: {error}',
    errorDeletingPaymentSettings: '❌ Failed to delete payment settings: {error}',
    // Export PDF Feature
    selectBuildingToExportPdf: 'Select building to export PDF',
    selectBillingPeriodToExport: 'Select billing period to export',
    onlyExportOutstandingFees: 'Only export apartments with outstanding fees',
    emailToReceiveDownloadLink: 'Email to receive download link',
    exportPdf: 'EXPORT PDF',
    exporting: 'Exporting...',
    exportHistory: 'Export History',
    exportTime: 'Time',
    exportStatus: 'Status',
    downloadLink: 'Download Link',
    processingExport: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    noExportHistory: 'No export history',
    pleaseSelectBuildingAndPeriod: 'Please select building and billing period',
    pleaseEnterEmailForDownload: 'Please enter email',
    exportRequestSent: 'Export request sent successfully!',
    errorSubmittingExportRequest: 'Error occurred while submitting export request',
    exportPdfTitle: 'Export PDF Service Fees',
    exportPdfDescription: 'Export all service fee invoices to PDF format for printing',
    selectBuildingForExport: 'Select Building',
    enterEmailToReceiveLink: 'Enter email to receive download link',
    // PDF Templates
    pdfTemplates: 'PDF Service Fee Templates',
    pdfTemplateManagement: 'PDF Template Management',
    addPdfTemplate: 'Add PDF Template',
    editPdfTemplate: 'Edit PDF Template',
    templateName: 'Template Name',
    templateDescription: 'Template Description',
    templateType: 'Template Type',
    defaultTemplate: 'Default Template',
    globalTemplate: 'Global Template',
    buildingTemplate: 'Building Template',
    templateLayout: 'Template Layout',
    professionalLayout: 'Professional Layout',
    simpleLayout: 'Simple Layout',
    customLayout: 'Custom Layout',
    headerSettings: 'Header Settings',
    tableSettings: 'Table Settings',
    footerSettings: 'Footer Settings',
    showLogo: 'Show Logo',
    showBorders: 'Show Table Borders',
    showPaymentInfo: 'Show Payment Info',
    showSignature: 'Show Signature',
    createDefaultTemplates: 'Create Default Templates',
    qrSettings: 'QR Settings',
    logoSettings: 'Logo Settings',
    logoSettingsGlobalHint: 'Global logo is used on the login page and as the default when an operator has not configured their own logo.',
    logoSettingsOperatorHint: 'Operator logo appears in the sidebar after login. If not set, the system falls back to the SUPERADMIN global logo.',
    logoSettingsEffectiveTitle: 'Currently displayed logo',
    logoSettingsUsingOperator: 'Using operator logo.',
    logoSettingsUsingGlobalFallback: 'Using global logo (no operator logo configured).',
    logoSettingsNoOwnYet: 'No custom logo yet. Upload an image below or use the global logo.',
    logoSettingsUploadLabel: 'System logo',
    logoSettingsUploadHint: 'PNG, JPG, or WEBP. Transparent background recommended, max 5MB.',
    logoSettingsSaved: 'Logo saved.',
    logoSettingsSaveFailed: 'Failed to save logo.',
    logoSettingsDeleted: 'Logo deleted.',
    logoSettingsDeleteFailed: 'Failed to delete logo.',
    confirmDeleteLogoSettings: 'Are you sure you want to delete this logo?',
    qrPaymentTab: 'Payment QR',
    qrAppTab: 'App download QR',
    qrSelectBank: 'Select bank',
    qrBankAccount: 'Bank account',
    qrAccountName: 'Account name',
    qrAmountOptional: 'Amount (optional)',
    qrDescriptionOptional: 'Description (optional)',
    qrGenerateSample: 'Generate sample',
    qrGenerateAppImages: 'Generate & save QR',
    qrAndroidUrl: 'Android link',
    qrIosUrl: 'iOS link',
    qrSavedSuccess: 'QR settings saved',
    qrAppGeneratedSuccess: 'App download QR images saved',
    qrAppSavedSuccess: 'App download QR links saved',
    qrAppClearedSuccess: 'App download QR cleared',
    qrClearAppQr: 'Clear app download QR',
    qrAppUsingGlobalDefaults:
      'No app download QR override for this scope. Fee notices will use global settings when available. Enter links and save to create an override.',
    qrClearPaymentQr: 'Clear payment QR',
    qrPaymentClearedSuccess: 'Payment QR settings cleared',
    qrPaymentUsingGlobalDefaults:
      'No payment QR override for this scope. Fee notices will use global settings when available. Enter bank details and save to create an override.',
    noTemplatesYet: 'No PDF templates yet',
    addFirstTemplate: 'Add first PDF template',
    templateCreatedSuccess: 'PDF template created successfully!',
    templateUpdatedSuccess: 'PDF template updated successfully!',
    templateDeletedSuccess: 'PDF template deleted successfully!',
    defaultTemplatesCreatedSuccess: 'Default templates created successfully!',
    errorCreatingTemplate: 'Error creating PDF template',
    errorUpdatingTemplate: 'Error updating PDF template',
    errorDeletingTemplate: 'Error deleting PDF template',
    errorLoadingTemplates: 'Error loading PDF templates',
    confirmDeleteTemplate: 'Are you sure you want to delete this PDF template?',
    defaultTemplateWillBeReassigned: 'Another template will be promoted to default if available.',
    setAsDefault: 'Set as default',
    templateSetAsDefaultSuccess: 'Template set as default',
    cannotDeleteDefaultTemplate: 'Cannot delete default template',
    pleaseEnterTemplateName: 'Please enter template name',
    enterTemplateName: 'Enter PDF template name',
    enterTemplateDescription: 'Enter template description (optional)',
    selectTemplateType: 'Select template type',
    serviceFeeTemplate: 'Service Fee Template',
    feeNoticeTemplate: 'Fee Notice',
    receiptTemplate: 'Receipt',
    invoiceTemplate: 'Invoice Template',
    createNewPdfTemplate: 'Create New Template',
    basicInformation: 'Basic Information',
    fieldsAndLayout: 'Fields & Layout',
    stylingAndColors: 'Styling & Colors',
    showBuildingInfo: 'Show Building Information',
    bilingualHeader: 'Bilingual (Vietnamese/English)',
    titleLabel: 'Title',
    titleEnLabel: 'Title (English)',
    managementCompany: 'Management Company',
    managementCompanyEn: 'Management Company (English)',
    logoPathOptional: 'Logo Path (optional)',
    templateLogoPathHint: 'Company logo shown on PDF headers (top-left). Upload an image or enter a path/URL.',
    buildingLogoPathOptional: 'Building Logo Path (optional fallback)',
    templateBuildingLogoPathHint: 'Configure each building logo under Buildings → Edit. This field is only used when the building has no logo set.',
    hideZeroSections: 'Hide zero-amount sections',
    customerInformation: 'Customer Information',
    showCustomerInfoBox: 'Show Customer Information Box',
    customerFields: 'Customer Fields',
    alternateRowColors: 'Alternate Row Colors',
    showVatColumns: 'Show VAT Columns',
    tableHeaders: 'Table Headers',
    addColumn: 'Add Column',
    showBankInfo: 'Show Bank Information',
    showSignatureFields: 'Show Signature Fields',
    showPaymentQr: 'Show Payment QR',
    showAppQr: 'Show App Download QR',
    showNoticeText: 'Show Notice Text',
    showSignatureBlocks: 'Show signature blocks (Preparer / Payer)',
    defaultReason: 'Default reason',
    hotlineLabel: 'Hotline',
    officeHoursVi: 'Office Hours (VI)',
    noticeTextVi: 'Notice Text (VI)',
    noticeTextEn: 'Notice Text (EN)',
    layoutLabel: 'Layout',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    accentColor: 'Accent Color',
    previewLabel: 'Preview',
    generatePreview: 'Generate Preview',
    generatingPreview: 'Generating...',
    clickGeneratePreview: 'Click "Generate Preview" to see how your template will look',
    saveTemplateFirstPreview: 'Save the template first to generate preview',
    updateTemplate: 'Update Template',
    createTemplate: 'Create Template',
    saveTemplateFirstForPreview: 'Please save the template first to generate preview',
    failedGeneratePreview: 'Failed to generate preview',
    failedSaveTemplate: 'Failed to save template',
    optionalLeaveBlank: 'Optional — leave blank to hide',
    pdfCustomerFieldName: 'Name',
    pdfCustomerFieldAddress: 'Address',
    pdfCustomerFieldContract: 'Contract',
    pdfCustomerFieldTaxCode: 'Tax Code',
    pdfCustomerFieldPhone: 'Phone',
    pdfCustomerFieldEmail: 'Email',
    layoutFeeNotice: 'Fee Notice',
    layoutPaymentReceipt: 'Simple Receipt Voucher',
    layoutPaymentReceiptDetailed: 'Detailed Receipt (like Fee Notice)',
    layoutProfessional: 'Professional (Debit Note)',
    layoutSimple: 'Simple',
    layoutCustom: 'Custom',
    statusPaid: 'Paid',
    statusOverdue: 'Overdue',
    statusUnpaid: 'Unpaid',
    
    // Task Management
    tasksSection: 'TASKS',
    addTask: 'Add Task',
    taskList: 'Task List',
    allTasks: 'All',
    incompleteTasks: 'Incomplete',
    completedTasks: 'Completed',
    taskAssignment: 'Task Assignment',
    taskContent: 'Task Content',
    assignToStaff: 'Assign to Staff',
    dueDate: 'Due Date',
    taskTitle: 'Title',
    taskDescription: 'Description',
    taskAttachments: 'Attachments',
    taskAttachmentsNote: 'image, pdf, word, excel. Max 2 files',
    createTaskButton: 'CREATE TASK',
    taskNumber: '#',
    taskName: 'Task',
    createdDate: 'Created Date',
    completedDate: 'Completed Date',
    taskStatus: 'Status',
    lastUpdated: 'Last Updated',
    taskStatusInProgress: 'In Progress',
    taskStatusPending: 'Pending',
    taskStatusCompleted: 'Completed',
    taskRequirements: 'Task Requirements',
    taskUpdates: 'Updates & Feedback',
    confirmTaskCompletion: 'Mark as completed',
    updateTaskButton: 'SAVE INFORMATION',
    // Task form validation
    pleaseSelectStaff: 'Please select staff member',
    pleaseEnterDeadline: 'Please select deadline',
    pleaseEnterTaskTitle: 'Please enter task title',
    pleaseEnterTaskDescription: 'Please enter task description',
    selectStaffPlaceholder: 'Select staff member',
    enterTaskTitle: 'Enter task title',
    enterTaskDescription: 'Enter detailed task description',
    enterTaskUpdate: 'Enter update or feedback',
    // Task success/error messages
    taskCreatedSuccess: 'Task created successfully!',
    taskUpdatedSuccess: 'Task updated successfully!',
    errorCreatingTask: 'Error occurred while creating task',
    errorUpdatingTask: 'Error occurred while updating task',
    errorLoadingTasks: 'Error occurred while loading task list',
    errorLoadingTaskDetails: 'Error occurred while loading task details',
    errorLoadingStaff: 'Error occurred while loading staff list',
    noTasksFound: 'No tasks found',
    noTasksMessage: 'No tasks have been created yet',
    createFirstTask: 'Create first task',
    backToTaskList: 'Back to task list',
    // Task Details - New translations only
    taskDetails: 'Task Details',
    viewAndUpdateTaskDetails: 'View and update detailed task information',
    updatesAndFeedback: 'Updates & Feedback',
    addUpdate: 'Add Update',
    enterUpdateComment: 'Enter update content, progress notes...',
    updateTask: 'Update Task',
    taskHistory: 'Task History',
    noUpdatesYet: 'No updates yet',
    addFirstUpdate: 'Add the first update to track progress',
    markedAsCompleted: 'Marked as completed',
    unknown: 'Unknown',
    taskNotFound: 'Task not found',
    taskMayBeDeleted: 'Task may have been deleted or does not exist',
    errorLoadingTask: 'Error occurred while loading task',
    taskUpdatedSuccessfully: 'Task updated successfully',
    assignedTo: 'Assigned to',
    createdBy: 'Created by',
    markAsCompleted: 'Mark as Completed',
    // Task details - additional keys
    attachFiles: 'Attach files',
    uploadFiles: 'Upload files',
    orDragAndDrop: 'Or drag and drop',
    maxFileSize: 'Max file size 10MB',
    confirmInProgress: 'Mark as In Progress',
    confirmCompleted: 'Mark as Completed',
    taskPriority: 'Priority',
    taskPriorityLow: 'Low',
    taskPriorityMedium: 'Medium',
    taskPriorityHigh: 'High',
    taskPriorityUrgent: 'Urgent',
    openInNewTab: 'Open in new tab',
    download: 'Download',
    
    // Feedback Management
    customerCareSection: 'CUSTOMER CARE',
    feedbackManagement: 'Feedback',
    feedbackList: 'Feedback List',
    feedbackCategoryConfig: 'Feedback Category Configuration',
    addFeedback: 'Add Feedback',
    addFeedbackCategory: 'Add Feedback Category',
    editFeedbackCategory: 'Edit Feedback Category',
    feedbackCategoryName: 'Category Name',
    feedbackCategoryNameEn: 'English Name',
    feedbackCategoryCode: 'Category Code',
    feedbackId: 'Feedback ID',
    feedbackContent: 'Content',
    feedbackApartment: 'Apartment',
    feedbackResident: 'Resident',
    feedbackTags: 'Tags',
    feedbackCategory: 'Feedback Category',
    feedbackDeadline: 'Deadline',
    feedbackConfirmedDate: 'Confirmed Date',
    feedbackConfirmedBy: 'Confirmed By',
    feedbackCompletedDate: 'Completed Date',
    feedbackStatus: 'Status',
    feedbackPriority: 'Priority',
    feedbackActions: 'Actions',
    feedbackMessages: 'Messages',
    feedbackDetails: 'Feedback Details',
    
    // Feedback Status
    feedbackStatusPendingConfirmation: 'Pending Confirmation',
    feedbackStatusConfirmed: 'Confirmed',
    feedbackStatusInProgress: 'In Progress',
    feedbackStatusCompleted: 'Completed',
    feedbackStatusRejected: 'Rejected',
    
    // Feedback Priority
    feedbackPriorityLow: 'Low',
    feedbackPriorityMedium: 'Medium',
    feedbackPriorityHigh: 'High',
    feedbackPriorityUrgent: 'Urgent',
    
    // Feedback Actions
    confirmFeedback: 'Confirm',
    completeFeedback: 'Complete',
    rejectFeedback: 'Reject',
    viewFeedbackDetails: 'View Details',
    addMessage: 'Add Message',
    
    // Feedback Form
    selectBuildingToViewFeedbacks: 'Select Building To View Feedbacks',
    selectApartment: 'Select Apartment',
    selectFeedbackCategory: 'Select Feedback Category',
    enterFeedbackContent: 'Enter feedback content',
    enterFeedbackTags: 'Enter tags (separated by commas)',
    selectFeedbackPriority: 'Select priority',
    selectDeadline: 'Select deadline',
    enterCategoryName: 'Enter category name',
    enterCategoryNameEn: 'Enter English name',
    enterCategoryCode: 'Enter category code',
    
    // Feedback Messages
    feedbackCreatedSuccess: 'Feedback created successfully!',
    feedbackUpdatedSuccess: 'Feedback updated successfully!',
    feedbackConfirmedSuccess: 'Feedback confirmed successfully!',
    feedbackCompletedSuccess: 'Feedback completed successfully!',
    feedbackCategoryCreatedSuccess: 'Feedback category created successfully!',
    feedbackCategoryUpdatedSuccess: 'Feedback category updated successfully!',
    feedbackCategoryDeletedSuccess: 'Feedback category deleted successfully!',
    defaultFeedbackCategoriesCreatedSuccess: 'Default feedback categories created successfully!',
    createDefaultFeedbackCategories: 'Create default categories',
    confirmCreateDefaultFeedbackCategories: 'Create default feedback categories for this building?',
    errorCreatingDefaultFeedbackCategories: 'Error creating default feedback categories',
    feedbackMessageAddedSuccess: 'Message added successfully!',
    feedbackStatistics: 'CSKH Statistics',
    feedbackResponsibleStaff: 'Responsible Staff',
    feedbackCompletedBy: 'Completed By',
    feedbackProcessingTime: 'Processing Time',
    feedbackStatusCancelled: 'Cancelled',
    generalInfoTab: 'General Information',
    processingWorkflowTab: 'Processing Workflow',
    workflowStepName: 'Step Name',
    workflowStatusDescription: 'Status Description',
    workflowSystemStatus: 'System Status',
    workflowDepartment: 'Department',
    workflowAssignees: 'Assignees',
    workflowSla: 'SLA',
    workflowSlaReminder: 'SLA Reminder',
    addWorkflowStep: 'Add Step',
    selectStaff: 'Select staff',
    workflowSavedSuccess: 'Workflow saved successfully!',
    errorSavingWorkflow: 'Error saving workflow',
    slaUnitMinutes: 'Minutes',
    slaUnitHours: 'Hours',
    slaUnitDays: 'Days',
    cskhDashboard: 'Customer Service Dashboard',
    currentOverview: 'Current Overview',
    performanceInPeriod: 'Performance in Period',
    pendingBacklog: 'Pending',
    overdueSla: 'Overdue SLA',
    createdInPeriod: 'Created in Period',
    closedByCreationPeriod: 'Closed by Creation Period',
    completionRate: 'Completion Rate',
    closedInPeriod: 'Closed in Period',
    slaComplianceRate: 'SLA Compliance Rate',
    newRequests: 'New Requests',
    feedbackProcessingMetric: 'Processing',
    paused: 'Paused',
    slaTrend: 'SLA Compliance Trend',
    openTicketAge: 'Open Ticket Age',
    slaOverview: 'SLA Overview',
    processingTrend: 'Processing Trend',
    requestsByCategory: 'Requests by Category',
    departmentPerformance: 'Performance by Department',
    staffPerformance: 'Individual Performance (Top 5)',
    averageProcessingTimes: 'Average Processing Times',
    requestsByChannel: 'Requests by Channel',
    qualitySatisfaction: 'Quality & Satisfaction',
    slaAlerts: 'SLA Alerts',
    onTimeSla: 'On-time SLA',
    slaViolations: 'SLA Violations',
    satisfactionRate: 'Satisfaction Rate',
    viewNow: 'View now',
    violatingSla: 'Currently violating SLA',
    approachingSla: 'Approaching SLA',
    firstResponseTime: 'First Response Time',
    averageProcessingTime: 'Average Processing Time',
    closeRequestTime: 'Time to Close Request',
    averageSlaViolationTime: 'Average SLA Violation Time',
    onTime: 'On Time',
    allDepartments: 'All Departments',
    allStaff: 'All Staff',
    
    // Feedback Errors
    errorCreatingFeedback: 'Error creating feedback',
    errorUpdatingFeedback: 'Error updating feedback',
    errorLoadingFeedbacks: 'Error loading feedback list',
    errorLoadingFeedbackDetails: 'Error loading feedback details',
    errorCreatingFeedbackCategory: 'Error creating feedback category',
    errorUpdatingFeedbackCategory: 'Error updating feedback category',
    errorLoadingFeedbackCategories: 'Error loading feedback categories',
    errorAddingFeedbackMessage: 'Error adding message',
    
    // Feedback Validation
    pleaseSelectApartment: 'Please select apartment',
    pleaseSelectFeedbackCategory: 'Please select feedback category',
    pleaseEnterFeedbackContent: 'Please enter feedback content',
    pleaseEnterCategoryName: 'Please enter category name',
    pleaseEnterCategoryCode: 'Please enter category code',
    pleaseEnterMessageContent: 'Please enter message content',
    
    // Feedback Confirmation
    confirmDeleteFeedback: 'Are you sure you want to delete this feedback?',
    confirmDeleteFeedbackCategory: 'Are you sure you want to delete this feedback category?',
    confirmCompleteFeedback: 'Are you sure you want to mark this feedback as completed?',
    
    // Feedback Statistics
    filter: 'Filter',
    feedbackExchange: 'Exchange',
    feedbackResidentChat: 'Resident',
    feedbackInternalChat: 'Internal',
    feedbackInternalChatHint: 'Internal messages are only visible to staff assigned to this feedback.',
    noFeedbackMessages: 'No messages yet',
    feedbackMessagePlaceholder: 'Enter message...',
    feedbackRefresh: 'Refresh',
    totalFeedbacks: 'Total Feedbacks',
    pendingFeedbacks: 'Pending',
    confirmedFeedbacks: 'Confirmed',
    inProgressFeedbacks: 'In Progress',
    completedFeedbacks: 'Completed',
    allCategories: 'All feedback types',
    allPriorities: 'All priorities',
    allApartmentGroups: 'All apartment groups',
    allAssignees: 'All assignees',
    exportData: 'Export Data',
    exportDataSuccess: 'Data exported successfully',
    chooseFiles: 'Choose files',
    noFileChosen: 'No file chosen',
    searchMinCharsHint: 'Enter at least 2 characters to search',
    searching: 'Searching...',
    noSearchResults: 'No results found',
    searchApartmentGroupPlaceholder: 'Search apartment group...',
    searchApartmentPlaceholder: 'Search apartment code or owner name...',
    searchAssigneePlaceholder: 'Search assignee...',
    noFeedbacks: 'No feedbacks found',
    noFeedbackCategories: 'No feedback categories yet',
    
    // Feedback Tags
    securityTag: 'Security',
    operationTag: 'Operation',
    landscapeTag: 'Landscape',
    maintenanceTag: 'Maintenance',
    cleaningTag: 'Cleaning',
    otherTag: 'Other',
    
    // Chat System
    'Chat is locked': 'Chat is locked',
    'Chat is locked. Please unlock it first to send messages.': 'Chat is locked. Please unlock it first to send messages.',
    'No one can send messages until the chat is unlocked. Only staff can unlock it.': 'No one can send messages until the chat is unlocked. Only staff can unlock it.',
    'Type a message...': 'Type a message...',
    'Add description (optional)...': 'Add description (optional)...',
    'Attach file': 'Attach file',
    'Send message': 'Send message',
    
    // Apartment Import
    importApartments: 'Import Apartments',
    exportApartments: 'Export Apartments',
    downloadSampleFile: 'Download Sample File',
    step1DownloadSample: 'Step 1: Download Sample File',
    step2UploadFile: 'Step 2: Upload Your File',
    requiredFields: 'Required Fields',
    uploadYourFile: 'Upload Your File',
    clickToSelectFile: 'Click to select file or drag and drop',
    csvExcelSupported: 'CSV, Excel files supported',
    excelRecommended: 'Excel (.xlsx, .xls) recommended',
    csvAlsoSupported: 'CSV also supported',
    dragAndDrop: 'or drag and drop',
    fileSelected: 'File selected',
    noFileSelected: 'No file selected',
    pleaseSelectFile: 'Please select a file to import',
    importSuccess: 'Import successful',
    importNewCount: 'New',
    importUpdatedCount: 'Updated',
    importSkippedCount: 'Duplicate in file',
    importMissingCount: 'Missing from file',
    importRenamedCount: 'Renamed',
    importMissingCodes: 'Apartments in DB but not in import file',
    importExistingCount: 'Apartments in DB',
    importFileApartmentCount: 'Apartment codes in file',
    importErrorSummary: 'Errors by type',
    importErrorRows: 'rows',
    importFailedSummary: 'Import failed — see summary below',
    importSkippedCodes: 'Duplicate codes in file',
    apartmentListTab: 'Apartment List',
    apartmentImportHistoryTab: 'Import history',
    importHistoryFileName: 'Imported file',
    importHistoryDate: 'Date/time',
    importHistoryStaff: 'Staff',
    importHistoryTotalRows: 'Rows',
    importHistoryMissing: 'Missing',
    importHistoryStatus: 'Status',
    importHistoryNoData: 'No activity history yet',
    importHistoryDetails: 'Details',
    apartmentImportRevert: 'Revert',
    apartmentImportReverted: 'Reverted',
    apartmentImportRevertConfirm:
      'Revert fee quantity changes from "{fileName}"?\n\nOnly fee quantities (charging, parking, …) are restored — apartments are not deleted.',
    apartmentImportRevertSuccess: 'Reverted {count} fee quantity change(s).',
    apartmentImportRevertUnavailable: 'This older import cannot be reverted — fix manually or re-import a corrected file.',
    apartmentImportSummary: 'Updated {updated} apartments, {quantities} fee quantities',
    activityHistoryKind: 'Type',
    activityHistoryDescription: 'Description',
    activityHistoryImport: 'Import',
    activityHistoryUpdate: 'Update',
    activityHistoryDelete: 'Delete',
    activityHistoryBulkDelete: 'Bulk delete',
    activityHistoryDeletedCodes: 'Deleted',
    activityHistorySkippedApartments: 'Skipped',
    selectAllOnPage: 'Select page',
    deleteSelectedApartments: 'Delete selected',
    confirmBulkDeleteApartments: 'Delete {count} selected apartments? Only apartments without linked data can be removed.',
    bulkDeleteResultSummary: 'Deleted {deleted} apartments, skipped {skipped}.',
    importSuccessStatus: 'Completed',
    importPartialStatus: 'Warning',
    importFailedStatus: 'Failed',
    importFailed: 'Import failed',
    importLoading: 'Importing...',
    importError: 'Import error',
    importSuccessMessage: 'Apartment list imported successfully!',
    importErrorMessage: 'Failed to import apartment list. Please check your file format.',
    fileFormatError: 'Invalid file format. Please use CSV or Excel files.',
    existingCodesSkipped: 'existing codes were skipped',
    existingCodesSkippedMessage: 'existing codes were skipped',
    sampleFileDescription: 'Download the sample Excel file below to see the required format. Edit it with your apartment data and save as Excel (.xlsx) for best results.',
    requiredFieldsDescription: 'Required fields are marked with red asterisks. Other fields are optional.',
    fieldCode: 'short unique apartment code (e.g. A-0.01) — not the display name',
    fieldApartmentName: 'display apartment name (optional)',
    importApartmentParkingQuantityHint: 'Add quantity columns using the full fee category name (or fee code, e.g. SAC001) — parking, EV charging, and other manual per-apartment fees.',
    fieldOldCode: 'existing apartment code in system — use when renaming code (e.g. A-0.01 → SGAM-DA-A001)',
    fieldOccupancyStatus: 'apartment status (owner-using / rented / for_rent / for_sale)',
    fieldHandoverDate: 'handover date dd/mm/yyyy (blank if not handed over)',
    fieldPeCode: 'PE code (optional)',
    fieldPopulationCount: 'population count (optional)',
    fieldOwnerName: 'owner full name',
    fieldOwnerNameOptional: 'owner full name (leave empty if not handed over)',
    fieldOwnerPhone: 'owner phone number (optional)',
    fieldOwnerEmail: 'fee notification email, multiple emails separated by ; (optional)',
    fieldInvoiceEmail: 'VAT invoice email, multiple emails separated by ; (optional)',
    fieldAddress: 'apartment address (optional)',
    fieldArea: 'area in square meters (optional)',
    fieldCustomerCode: 'customer code (optional)',
    fieldTaxCode: 'tax code (optional)',
    fieldHasVatInvoice: 'has VAT invoice - Yes/No or true/false (optional)',
    fieldNotes: 'additional notes (optional)',
    fieldApartmentGroup: 'apartment group name in selected building (optional)',
    fieldUsageType: 'usage type - Căn hộ/TM (optional)',
    fieldRegisteredQuotaCount: 'registered water quota count (optional)',
    apply: 'Apply',
    clear: 'Clear',
  },
};

type Lang = 'vi' | 'en';

const LangContext = createContext<{ lang: Lang; setLang: (l: Lang) => void; t: (k: string) => string }>({
  lang: 'vi',
  setLang: () => {},
  t: (k) => k,
});

export const LangProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<Lang>('vi');
  
  useEffect(() => {
    const storedLang = localStorage.getItem('lang') as Lang | null;
    if (storedLang && (storedLang === 'vi' || storedLang === 'en')) {
      setLang(storedLang);
    }
  }, []);
  
  const t = (k: string) => translations[lang][k] || k;
  
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext); 